// src/components/form/search-form.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return(g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g);
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSErrorSummaryFragment on EGDSErrorSummary {\n    egdsElementId\n    goToErrorLinkText\n    goToFirstErrorLinkText\n    heading\n    body {\n      text\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    impressionAnalytics {\n      linkName\n      referrerId\n    }\n    headingTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSButtonFragment on EGDSButton {\n    primary\n    disabled\n    accessibility\n    icon {\n      id\n      description\n      token\n      title\n    }\n    analytics {\n      linkName\n      referrerId\n    }\n    action {\n      accessibility\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormButtonFragment on EGDSSearchFormButton {\n    egdsElementId\n    ...EGDSButtonFragment\n    onClick {\n      ...EGDSSubmitSearchFormActionFragment\n    }\n  }\n\n  fragment EGDSSubmitSearchFormActionFragment on EGDSSubmitSearchFormAction {\n    analytics {\n      linkName\n      referrerId\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment IconFragment on Icon {\n    id\n    title\n    token\n    description\n    size\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicPillFragment on EGDSBasicPill {\n    accessibility\n    disabled\n    name\n    primary\n    selected\n    selectedText\n    value\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...AnalyticsFragment\n    }\n    deselectAnalytics {\n      ...AnalyticsFragment\n    }\n  }\n\n  fragment AnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibilityCalendarContentFragment on EGDSDatePickerFlexibilityCalendarContent {\n    __typename\n    flexibleDateOptions {\n      ...EGDSBasicPillFragment\n    }\n    formElementId\n    title {\n      text\n      accessibility\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicTabsFragment on EGDSBasicTabs {\n    __typename\n    egdsElementId\n    selectedTabId\n    tabs {\n      __typename\n      accessibility\n      label\n      tabId\n    }\n  }\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSToggleButtonFragment on EGDSToggleButton {\n    __typename\n    primary\n    subText\n    name\n    icon {\n      ... on Icon {\n        description\n        size\n      }\n    }\n    selected\n    disabled\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSToggleButtonGroupFragment on EGDSToggleButtonGroup {\n    __typename\n    options {\n      ...EGDSToggleButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibleMonthsFragment on EGDSDatePickerFlexibleMonths {\n    heading\n    subHeading\n    options {\n      ...EGDSToggleButtonGroupFragment\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicCheckBoxFragment on EGDSBasicCheckBox {\n    egdsElementId\n    description\n    enabled\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    label {\n      text\n    }\n    name\n    required\n    state\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCheckBoxFragment on EGDSCheckBox {\n    __typename\n\n    ...EGDSBasicCheckBoxFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicRemovablePillFragment on EGDSBasicRemovablePill {\n    primary\n    name\n    accessibility\n    id\n    removeAnalytics {\n      referrerId\n      linkName\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicTriggerPillFragment on EGDSBasicTriggerPill {\n    id\n    disabled\n    primary\n    selected\n    icon {\n      ...IconFragment\n    }\n    selectAnalytics {\n      ...AnalyticsFragment\n    }\n    deselectAnalytics {\n      ...AnalyticsFragment\n    }\n    accessibility\n  }\n\n  fragment AnalyticsFragment on ClientSideAnalytics {\n    linkName\n    referrerId\n  }\n\n  ",
        "\n"
    ]);
    _templateObject13 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject14() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPillFragment on EGDSPill {\n    __typename\n\n    ...EGDSBasicPillFragment\n    ...EGDSBasicTriggerPillFragment\n    ...EGDSBasicRemovablePillFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject14 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject15() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibleNightsFragment on EGDSDatePickerFlexibleNights {\n    heading\n    includeWeekend {\n      ...EGDSCheckBoxFragment\n    }\n    options {\n      ...EGDSPillFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject15 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject16() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibilityDatesContentFragment on EGDSDatePickerFlexibilityDatesContent {\n    __typename\n    nightsSelection {\n      ...EGDSDatePickerFlexibleNightsFragment\n    }\n    monthsSelection {\n      ...EGDSDatePickerFlexibleMonthsFragment\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject16 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject17() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDatePickerFlexibilityContentFragment on EGDSDatePickerFlexibilityContent {\n    __typename\n    calendarContent {\n      ...EGDSDatePickerFlexibilityCalendarContentFragment\n    }\n    contentSelector {\n      ...EGDSBasicTabsFragment\n    }\n    flexibleDatesContent {\n      ...EGDSDatePickerFlexibilityDatesContentFragment\n    }\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject17 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject18() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSDateRangePickerFragment on EGDSDateRangePicker {\n    buttonText\n    buttonTextTemplate {\n      ... on EGDSCardinalLocalizedText {\n        text\n        models {\n          key\n          source\n          __typename\n        }\n        templates {\n          category\n          template\n          __typename\n        }\n        __typename\n      }\n    }\n    clearButtonText\n    firstDayOfWeek\n    maxNumberOfDaysSelected\n    sameDaySelectionAllowed\n    selectedStartDate {\n      ...DateFragment\n    }\n    startDatePlaceholderText\n    selectedEndDate {\n      ...DateFragment\n    }\n    endDatePlaceholderText\n    validDaysLowerBoundInclusive {\n      ...DateFragment\n    }\n    validDaysUpperBoundInclusive {\n      ...DateFragment\n    }\n    submitButtonAnalytics {\n      linkName\n      referrerId\n    }\n    nextButtonAnalytics {\n      linkName\n      referrerId\n    }\n    previousButtonAnalytics {\n      linkName\n      referrerId\n    }\n    startDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    endDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    clearDatesButtonAnalytics {\n      linkName\n      referrerId\n    }\n    showClearDatesButton\n\n    flexibleDateContent {\n      ...EGDSDatePickerFlexibilityContentFragment\n    }\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n\n  ",
        "\n"
    ]);
    _templateObject18 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject19() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSingleDatePickerFragment on EGDSSingleDatePicker {\n    buttonText\n    selectedStartDate {\n      ...DateFragment\n    }\n    validDaysLowerBoundInclusive {\n      ...DateFragment\n    }\n    validDaysUpperBoundInclusive {\n      ...DateFragment\n    }\n    submitButtonAnalytics {\n      linkName\n      referrerId\n    }\n    startDateButtonAnalytics {\n      linkName\n      referrerId\n    }\n    firstDayOfWeek\n  }\n\n  fragment DateFragment on Date {\n    day\n    month\n    year\n  }\n"
    ]);
    _templateObject19 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject20() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormDatePickerFieldFragment on EGDSSearchFormDatePickerField {\n    egdsElementId\n    label\n    placeholder\n    errorMessage\n    validations {\n      ... on EGDSMaxLengthInputValidation {\n        errorMessage\n      }\n    }\n    action {\n      ...EGDSOpenDatePickerActionFragment\n    }\n  }\n\n  fragment EGDSOpenDatePickerActionFragment on EGDSOpenDatePickerAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    datePicker {\n      ...EGDSDateRangePickerFragment\n      ...EGDSSingleDatePickerFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject20 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject21() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormLocationFieldFragment on EGDSSearchFormLocationField {\n    __typename\n    egdsElementId\n    label\n    placeholder\n    value\n    errorMessage\n    required\n    leftIcon {\n      title\n    }\n    action {\n      ...OpenTypeaheadActionFragment\n    }\n    closeAnalytics {\n      linkName\n      referrerId\n    }\n    changeAnalytics {\n      linkName\n      referrerId\n    }\n    multiLocations {\n      text\n      value\n    }\n  }\n\n  fragment OpenTypeaheadActionFragment on OpenTypeaheadAction {\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    info {\n      ...TypeaheadInfoFragment\n    }\n    emptyResultsPlaceholder\n    categorize\n    allowExactMatch\n    listTitle\n    selectedItemHeading\n    clearAllText\n    dismissButtonText\n  }\n\n  fragment TypeaheadInfoFragment on TypeaheadInfo {\n    client\n    drivable\n    isDestination\n    lineOfBusiness\n    maxNumberOfResults\n    packageType\n    personalize\n    regionType\n    typeaheadFeatures\n    isMultiLocation\n    domain\n    regionId\n    showCurrentLocation\n  }\n"
    ]);
    _templateObject21 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject22() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSPrimaryButtonFragment on UIPrimaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject22 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject23() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTertiaryButtonFragment on UITertiaryButton {\n    egdsElementId\n    ...EGDSButtonFragment\n  }\n\n  ",
        "\n"
    ]);
    _templateObject23 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject24() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicOptionFragment on EGDSBasicOption {\n    label\n    value\n    egdsElementId\n    changeAnalytics {\n      linkName\n      referrerId\n    }\n  }\n"
    ]);
    _templateObject24 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject25() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerChildAgeSelectFragment on EGDSTravelerChildAgeSelect {\n    labelTemplate {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n      }\n    }\n    options {\n      ...EGDSBasicOptionFragment\n    }\n    egdsElementId\n    value\n  }\n\n  ",
        "\n"
    ]);
    _templateObject25 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject26() {
    var data = _tagged_template_literal([
        "\n  fragment TemplateModelFragment on TemplateModel {\n    key\n    source\n  }\n"
    ]);
    _templateObject26 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject27() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicLocalizedTextFragment on EGDSBasicLocalizedText {\n    template\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject27 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject28() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCardinalLocalizedTextFragment on EGDSCardinalLocalizedText {\n    egdsElementId\n    text\n    models {\n      ...TemplateModelFragment\n    }\n    templates {\n      ...CardinalTemplateFragment\n    }\n  }\n\n  fragment CardinalTemplateFragment on CardinalTemplate {\n    template\n    category\n  }\n\n  ",
        "\n"
    ]);
    _templateObject28 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject29() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSCompositeLocalizedTextFragment on EGDSCompositeLocalizedText {\n    egdsElementId\n    text\n    template\n    models {\n      ...CompositeLocalizedTextModelFragment\n    }\n  }\n\n  fragment CompositeLocalizedTextModelFragment on CompositeLocalizedTextModel {\n    key\n    models {\n      ...EGDSTemplateModelsFragment\n    }\n  }\n\n  fragment EGDSTemplateModelsFragment on EGDSTemplateModels {\n    models {\n      ...TemplateModelFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject29 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject30() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSLocalizedTextFragment on EGDSLocalizedText {\n    ...EGDSBasicLocalizedTextFragment\n    ...EGDSCardinalLocalizedTextFragment\n    ...EGDSCompositeLocalizedTextFragment\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject30 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject31() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerStepInputFragment on EGDSStepInput {\n    ... on EGDSTravelerStepInput {\n      decreaseAnalytics {\n        linkName\n        referrerId\n      }\n      increaseAnalytics {\n        linkName\n        referrerId\n      }\n      decreaseText\n      decreaseTextTemplate {\n        ...EGDSBasicLocalizedTextFragment\n      }\n      increaseText\n      increaseTextTemplate {\n        ...EGDSBasicLocalizedTextFragment\n      }\n      egdsElementId\n    }\n    label\n    max\n    min\n    step\n    subLabel\n    value\n  }\n\n  ",
        "\n"
    ]);
    _templateObject31 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject32() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerChildrenFragment on EGDSTraveler {\n    count {\n      ...EGDSTravelerStepInputFragment\n    }\n    ... on EGDSBasicTraveler {\n      type\n    }\n    ... on EGDSTravelerChildren {\n      ages {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n      ageTemplate {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n    }\n    ... on EGDSTravelerInfant {\n      ages {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n      ageTemplate {\n        ...EGDSTravelerChildAgeSelectFragment\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject32 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject33() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelersFragment on EGDSTravelers {\n    adults {\n      ...EGDSTravelerStepInputFragment\n    }\n    children {\n      ...EGDSTravelerChildrenFragment\n    }\n    infantsInSeat {\n      ...EGDSTravelerChildrenFragment\n    }\n    infantsOnLap {\n      ...EGDSTravelerChildrenFragment\n    }\n    pets {\n      ...EGDSBasicCheckBoxFragment\n    }\n    travelerNote {\n      __typename\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n        text\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject33 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject34() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSBasicTravelerSelectorFragment on EGDSBasicTravelerSelector {\n    closeButton {\n      ...EGDSPrimaryButtonFragment\n      ...EGDSTertiaryButtonFragment\n    }\n    doneButton {\n      ...EGDSPrimaryButtonFragment\n    }\n    title\n    travelers {\n      ...EGDSTravelersFragment\n    }\n    validations {\n      ... on EGDSTravelersInputValidation {\n        errorMessage\n        maxCount\n        type\n        infantsInSeatPerAdult\n        errorSummary {\n          ...EGDSErrorSummaryFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject34 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject35() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSStandardLinkFragment on EGDSStandardLink {\n    text\n    action {\n      accessibility\n      target\n      resource {\n        value\n      }\n      analytics {\n        linkName\n        referrerId\n      }\n    }\n    icon {\n      id\n    }\n    iconPosition\n  }\n"
    ]);
    _templateObject35 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject36() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerInfantSeatSelectFragment on EGDSTravelerInfantSeatSelection {\n    airlineAgeRule {\n      ...EGDSStandardLinkFragment\n    }\n    groupName\n    labelTemplate {\n      ... on EGDSCardinalLocalizedText {\n        text\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n    options {\n      label\n      value\n    }\n    selected\n  }\n  ",
        "\n"
    ]);
    _templateObject36 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject37() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSTravelerSelectorRoomFragment on EGDSTravelerSelectorRoom {\n    label {\n      ... on EGDSBasicLocalizedText {\n        models {\n          key\n          source\n        }\n        template\n      }\n    }\n    adults {\n      ...EGDSTravelerStepInputFragment\n    }\n    children {\n      ...EGDSTravelerChildrenFragment\n    }\n    infants {\n      ...EGDSTravelerChildrenFragment\n    }\n    removeRoomButton {\n      ...EGDSTertiaryButtonFragment\n    }\n    travelerNote {\n      __typename\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n        text\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject37 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject38() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSRoomsTravelerSelectorFragment on EGDSRoomsTravelerSelector {\n    addAnotherRoomButton {\n      ...EGDSTertiaryButtonFragment\n    }\n    closeButton {\n      ...EGDSPrimaryButtonFragment\n      ...EGDSTertiaryButtonFragment\n    }\n    doneButton {\n      ...EGDSPrimaryButtonFragment\n    }\n    infantSeatSelection {\n      ...EGDSTravelerInfantSeatSelectFragment\n    }\n    maxRoomCount\n    rooms {\n      ...EGDSTravelerSelectorRoomFragment\n    }\n    title\n    validations {\n      ... on EGDSTravelersInputValidation {\n        errorMessage\n        maxCount\n        type\n        infantsInSeatPerAdult\n        errorSummary {\n          ...EGDSErrorSummaryFragment\n        }\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject38 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject39() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchFormTravelersFieldFragment on EGDSSearchFormTravelersField {\n    action {\n      ... on EGDSOpenTravelerSelectorAction {\n        analytics {\n          linkName\n          referrerId\n        }\n        travelerSelector {\n          ...EGDSBasicTravelerSelectorFragment\n          ...EGDSRoomsTravelerSelectorFragment\n        }\n      }\n    }\n    label\n    labelTemplate {\n      ... on EGDSCardinalLocalizedText {\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n        secondaryTemplates {\n          category\n          template\n        }\n        text\n      }\n      ... on EGDSCompositeLocalizedText {\n        models {\n          key\n          models {\n            ... on EGDSCardinalLocalizedText {\n              models {\n                key\n                source\n              }\n              templates {\n                category\n                template\n              }\n            }\n          }\n        }\n        template\n        text\n      }\n    }\n    leftIcon {\n      id\n    }\n    readOnly\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject39 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject40() {
    var data = _tagged_template_literal([
        "\n  fragment EGDSSearchPlaybackFragment on EGDSSearchPlayback {\n    primary {\n      text\n    }\n    secondaries {\n      ... on EGDSPlainText {\n        text\n        accessibility\n      }\n      ... on EGDSBasicLocalizedText {\n        text\n        template\n        accessibilityTemplate\n        models {\n          key\n          source\n        }\n        egdsElementId\n      }\n      ... on EGDSCardinalLocalizedText {\n        text\n        accessibilityText\n        egdsElementId\n        models {\n          key\n          source\n        }\n        templates {\n          category\n          template\n        }\n      }\n    }\n    showAction {\n      ... on EGDSShowSearchFormAction {\n        accessibility\n        analytics {\n          linkName\n          referrerId\n        }\n        icon {\n          id\n          size\n        }\n        resource {\n          value\n        }\n      }\n    }\n    hideButton {\n      ...EGDSTertiaryButtonFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject40 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject41() {
    var data = _tagged_template_literal([
        "\n  fragment EGUisMicroMessageFragment on EGUisMicroMessage {\n    schemaName\n    messageContent\n  }\n"
    ]);
    _templateObject41 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject42() {
    var data = _tagged_template_literal([
        "\n  fragment AdaptexTrackingSuccessFragment on SearchFormAdaptExSuccessEvent {\n    __typename\n    datePrefill {\n      ...EGUisMicroMessageFragment\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject42 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject43() {
    var data = _tagged_template_literal([
        "\n  fragment SoftPackagesFragment on SoftPackages {\n    actionURL\n    addCar {\n      ...EGDSCheckBoxFragment\n    }\n    addFlight {\n      ...EGDSCheckBoxFragment\n    }\n    car {\n      ...EGDSPillFragment\n    }\n    flight {\n      ...EGDSPillFragment\n    }\n    origin {\n      ...EGDSSearchFormLocationFieldFragment\n    }\n    maxBookableTravelers\n    maxTravelersErrorMessage\n    validDaysUpperBoundInclusive {\n      day\n      month\n      year\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject43 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject44() {
    var data = _tagged_template_literal([
        "\n  fragment LodgingSearchFormFragment on LodgingSearchForm {\n    __typename\n    egdsElementId\n    actionURL\n    errorSummary {\n      ...EGDSErrorSummaryFragment\n    }\n    elements {\n      __typename\n      ...EGDSSearchFormLocationFieldFragment\n      ...EGDSSearchFormDatePickerFieldFragment\n      ...EGDSSearchFormTravelersFieldFragment\n    }\n    search {\n      ...EGDSSearchFormButtonFragment\n    }\n\n    playback @include(if: $includePlayback) {\n      ...EGDSSearchPlaybackFragment\n    }\n\n    softPackages {\n      ...SoftPackagesFragment\n    }\n\n    adaptExSuccessEvent {\n      ...AdaptexTrackingSuccessFragment\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject44 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject45() {
    var data = _tagged_template_literal([
        "\n  query LodgingSearchFormQuery(\n    $context: ContextInput!\n    $propertySearchCriteriaInput: PropertySearchCriteriaInput\n    $includePlayback: Boolean = false\n    $features: [String!]\n  ) {\n    searchForm(context: $context) {\n      lodging(propertySearchCriteria: $propertySearchCriteriaInput, features: $features) {\n        __typename\n        ...LodgingSearchFormFragment\n      }\n    }\n  }\n\n  ",
        "\n"
    ]);
    _templateObject45 = function _templateObject() {
        return data;
    };
    return data;
}
import React50 from "react";
import { gql as gql42, useQuery } from "@apollo/client";
import { useBexApi as useBexApi4 } from "@shared-ui/bex-api-context";
import { useLoggerEvents } from "@shared-ui/logger-context";
// ../internal/src/components/form/form-skeleton.tsx
import React from "react";
import { UitkLineSkeleton } from "uitk-react-skeleton";
import { UitkSpacing } from "uitk-react-spacing";
var FormSkeleton = function(param) {
    var rows = param.rows;
    return /* @__PURE__ */ React.createElement(React.Fragment, null, rows.map(function(param, index) {
        var type = param.type;
        return /* @__PURE__ */ React.createElement(UitkSpacing, {
            key: index,
            padding: index === 0 ? void 0 : {
                blockstart: "three"
            }
        }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(UitkLineSkeleton, {
            animation: true,
            type: type
        })));
    }));
};
// src/components/form/search-form.tsx
import { ViewMedium as ViewMedium7, Viewport as Viewport7, ViewSmall as ViewSmall5 } from "@shared-ui/viewport-context";
// src/__generated__/globalTypes.ts
var ClosedPeriodBounding = /* @__PURE__ */ function(ClosedPeriodBounding2) {
    ClosedPeriodBounding2["LOWER"] = "LOWER";
    ClosedPeriodBounding2["UPPER"] = "UPPER";
    return ClosedPeriodBounding2;
}(ClosedPeriodBounding || {});
var DatePeriodUnit = /* @__PURE__ */ function(DatePeriodUnit2) {
    DatePeriodUnit2["DAY"] = "DAY";
    DatePeriodUnit2["MONTH"] = "MONTH";
    DatePeriodUnit2["WEEK"] = "WEEK";
    DatePeriodUnit2["WEEKEND"] = "WEEKEND";
    return DatePeriodUnit2;
}(DatePeriodUnit || {});
// src/utils/fallback-form-data.ts
var errorSummary = {
    egdsElementId: "search_form_error_summary",
    goToErrorLinkText: "Go to the error",
    goToFirstErrorLinkText: "Go to the first error",
    heading: "",
    body: null,
    analytics: {
        linkName: "Error summary link clicked on search form",
        referrerId: "Web.Hotels.Search.Error.Summary",
        __typename: "ClientSideAnalytics"
    },
    impressionAnalytics: {
        linkName: "Error summary displayed on search form",
        referrerId: "Web.Hotels.Search.Error.Summary.Displayed",
        __typename: "ClientSideImpressionEventAnalytics"
    },
    headingTemplate: {
        models: [
            {
                key: "errorCount",
                source: "errorCount",
                __typename: "TemplateModel"
            }
        ],
        templates: [
            {
                category: "ZERO" /* ZERO */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "ONE" /* ONE */ ,
                template: "To continue, please correct the error below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "TWO" /* TWO */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "FEW" /* FEW */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "MANY" /* MANY */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            },
            {
                category: "OTHER" /* OTHER */ ,
                template: "To continue, please correct the ${errorCount} errors below.",
                __typename: "CardinalTemplate"
            }
        ],
        __typename: "EGDSCardinalLocalizedText"
    },
    __typename: "EGDSErrorSummary"
};
var destination = {
    __typename: "EGDSSearchFormLocationField",
    egdsElementId: "destination_form_field",
    label: "Going to",
    placeholder: "Going to",
    value: null,
    errorMessage: "Please select a destination",
    required: false,
    leftIcon: {
        title: null,
        __typename: "Icon"
    },
    closeAnalytics: {
        linkName: "Location selection",
        referrerId: "Web.Hotels.Location.Open",
        __typename: "ClientSideAnalytics"
    },
    action: {
        accessibility: null,
        analytics: {
            linkName: "Location selection",
            referrerId: "Web.Hotels.Location.Open",
            __typename: "ClientSideAnalytics"
        },
        info: {
            client: "Homepage",
            drivable: true,
            isDestination: true,
            lineOfBusiness: "HOTELS",
            maxNumberOfResults: 8,
            packageType: null,
            personalize: true,
            regionType: 2047,
            typeaheadFeatures: "ta_hierarchy|postal_code|google|consistent_display",
            isMultiLocation: null,
            domain: null,
            regionId: null,
            showCurrentLocation: null,
            __typename: "TypeaheadInfo"
        },
        emptyResultsPlaceholder: "Search by destination, accommodations, or landmark",
        categorize: false,
        allowExactMatch: true,
        listTitle: false,
        selectedItemHeading: null,
        clearAllText: null,
        dismissButtonText: null,
        __typename: "OpenTypeaheadAction"
    },
    multiLocations: null,
    changeAnalytics: null
};
var today = /* @__PURE__ */ new Date();
var startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 14);
var endDate = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate() + 1);
var startDatePickerMonthValue = startDate.getMonth() + 1;
var endDatePickerMonthValue = endDate.getMonth() + 1;
var datePicker = {
    __typename: "EGDSSearchFormDatePickerField",
    egdsElementId: "date_form_field",
    label: "Dates",
    placeholder: "Dates",
    errorMessage: "Check-out date must be after check-in date",
    validations: [
        {
            errorMessage: "Check out date must be within 29 days of check in date",
            __typename: "EGDSMaxLengthInputValidation"
        },
        {
            __typename: "EGDSRequiredInputValidation"
        }
    ],
    action: {
        accessibility: null,
        analytics: {
            linkName: "Calendar selection",
            referrerId: "Web.Hotels.Calendar.Open",
            __typename: "ClientSideAnalytics"
        },
        datePicker: {
            flexibleDateContent: null,
            nextButtonAnalytics: null,
            previousButtonAnalytics: null,
            buttonText: "Done",
            clearButtonText: "Clear dates",
            firstDayOfWeek: "SUN" /* SUN */ ,
            maxNumberOfDaysSelected: 29,
            sameDaySelectionAllowed: false,
            selectedStartDate: {
                day: startDate.getDate(),
                month: startDatePickerMonthValue,
                year: startDate.getFullYear(),
                __typename: "Date"
            },
            startDatePlaceholderText: "Check-in",
            selectedEndDate: {
                day: endDate.getDate(),
                month: endDatePickerMonthValue,
                year: endDate.getFullYear(),
                __typename: "Date"
            },
            endDatePlaceholderText: "Check-out",
            validDaysLowerBoundInclusive: {
                day: 5,
                month: 8,
                year: 2022,
                __typename: "Date"
            },
            validDaysUpperBoundInclusive: {
                day: 18,
                month: 12,
                year: 2023,
                __typename: "Date"
            },
            submitButtonAnalytics: {
                __typename: "ClientSideAnalytics",
                referrerId: "date picker submit",
                linkName: "date.picker.submit"
            },
            startDateButtonAnalytics: {
                __typename: "ClientSideAnalytics",
                linkName: "date picker start date",
                referrerId: "date.picker.start.date"
            },
            endDateButtonAnalytics: {
                __typename: "ClientSideAnalytics",
                linkName: "date picker end date",
                referrerId: "date.picker.end.date"
            },
            showClearDatesButton: false,
            buttonTextTemplate: null,
            clearDatesButtonAnalytics: null,
            __typename: "EGDSDateRangePicker"
        },
        __typename: "EGDSOpenDatePickerAction"
    }
};
var travelerSelector = {
    __typename: "EGDSSearchFormTravelersField",
    readOnly: false,
    action: {
        analytics: {
            linkName: "Guests selection",
            referrerId: "Web.Hotels.Traveler.GuestPicker.Open",
            __typename: "ClientSideAnalytics"
        },
        travelerSelector: {
            addAnotherRoomButton: {
                egdsElementId: "traveler_selector_add_room",
                primary: "Add another room",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: null,
                action: null,
                __typename: "UITertiaryButton"
            },
            closeButton: {
                egdsElementId: "traveler_selector_close_button",
                primary: null,
                disabled: false,
                accessibility: null,
                icon: {
                    id: "close",
                    description: "close",
                    token: "icon__close",
                    title: "",
                    __typename: "Icon"
                },
                analytics: {
                    linkName: "Travelers results not updated",
                    referrerId: "Web.Hotels.Traveler.Close",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            doneButton: {
                egdsElementId: "traveler_selector_done_button",
                primary: "Done",
                disabled: false,
                accessibility: null,
                icon: null,
                analytics: {
                    linkName: "Travelers results updated",
                    referrerId: "Web.Hotels.Traveler.Done",
                    __typename: "ClientSideAnalytics"
                },
                action: null,
                __typename: "UIPrimaryButton"
            },
            maxRoomCount: 8,
            rooms: [
                {
                    travelerNote: null,
                    label: {
                        models: [
                            {
                                key: "roomNumber",
                                source: "roomNumber",
                                __typename: "TemplateModel"
                            }
                        ],
                        template: "Room ${roomNumber}",
                        __typename: "EGDSBasicLocalizedText"
                    },
                    adults: {
                        decreaseAnalytics: {
                            linkName: "Adult traveler removed",
                            referrerId: "Web.Hotels.Traveler.Remove.Adult",
                            __typename: "ClientSideAnalytics"
                        },
                        increaseAnalytics: {
                            linkName: "Adult traveler added",
                            referrerId: "Web.Hotels.Traveler.Add.Adult",
                            __typename: "ClientSideAnalytics"
                        },
                        decreaseText: "Decrease the number of adults",
                        decreaseTextTemplate: {
                            models: [
                                {
                                    key: "roomNumber",
                                    source: "roomNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Decrease the number of adults in room ${roomNumber}",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        increaseText: "Increase the number of adults",
                        increaseTextTemplate: {
                            models: [
                                {
                                    key: "roomNumber",
                                    source: "roomNumber",
                                    __typename: "TemplateModel"
                                }
                            ],
                            template: "Increase the number of adults in room ${roomNumber}",
                            __typename: "EGDSBasicLocalizedText"
                        },
                        egdsElementId: "traveler_selector_adult_step_input",
                        __typename: "EGDSTravelerStepInput",
                        label: "Adults",
                        max: 14,
                        min: 1,
                        step: 1,
                        subLabel: null,
                        value: 2
                    },
                    children: {
                        count: {
                            decreaseAnalytics: {
                                linkName: "Child traveler removed",
                                referrerId: "Web.Hotels.Traveler.Remove.Child",
                                __typename: "ClientSideAnalytics"
                            },
                            increaseAnalytics: {
                                linkName: "Child traveler added",
                                referrerId: "Web.Hotels.Traveler.Add.Child",
                                __typename: "ClientSideAnalytics"
                            },
                            decreaseText: "Decrease the number of children",
                            decreaseTextTemplate: {
                                models: [
                                    {
                                        key: "roomNumber",
                                        source: "roomNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Decrease the number of children in room ${roomNumber}",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            increaseText: "Increase the number of children",
                            increaseTextTemplate: {
                                models: [
                                    {
                                        key: "roomNumber",
                                        source: "roomNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Increase the number of children in room ${roomNumber}",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            egdsElementId: "traveler_selector_children_step_input",
                            __typename: "EGDSTravelerStepInput",
                            label: "Children",
                            max: 6,
                            min: 0,
                            step: 1,
                            subLabel: "Ages 0 to 17",
                            value: 0
                        },
                        ages: [],
                        ageTemplate: {
                            labelTemplate: {
                                models: [
                                    {
                                        key: "childNumber",
                                        source: "childNumber",
                                        __typename: "TemplateModel"
                                    }
                                ],
                                template: "Child ${childNumber} age",
                                __typename: "EGDSBasicLocalizedText"
                            },
                            options: [
                                {
                                    changeAnalytics: null,
                                    label: "Select age",
                                    value: "",
                                    egdsElementId: "children_age_option",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "Under 1",
                                    value: "0",
                                    egdsElementId: "children_age_option_0",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "1",
                                    value: "1",
                                    egdsElementId: "children_age_option_1",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "2",
                                    value: "2",
                                    egdsElementId: "children_age_option_2",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "3",
                                    value: "3",
                                    egdsElementId: "children_age_option_3",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "4",
                                    value: "4",
                                    egdsElementId: "children_age_option_4",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "5",
                                    value: "5",
                                    egdsElementId: "children_age_option_5",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "6",
                                    value: "6",
                                    egdsElementId: "children_age_option_6",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "7",
                                    value: "7",
                                    egdsElementId: "children_age_option_7",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "8",
                                    value: "8",
                                    egdsElementId: "children_age_option_8",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "9",
                                    value: "9",
                                    egdsElementId: "children_age_option_9",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "10",
                                    value: "10",
                                    egdsElementId: "children_age_option_10",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "11",
                                    value: "11",
                                    egdsElementId: "children_age_option_11",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "12",
                                    value: "12",
                                    egdsElementId: "children_age_option_12",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "13",
                                    value: "13",
                                    egdsElementId: "children_age_option_13",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "14",
                                    value: "14",
                                    egdsElementId: "children_age_option_14",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "15",
                                    value: "15",
                                    egdsElementId: "children_age_option_15",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "16",
                                    value: "16",
                                    egdsElementId: "children_age_option_16",
                                    __typename: "EGDSBasicOption"
                                },
                                {
                                    changeAnalytics: null,
                                    label: "17",
                                    value: "17",
                                    egdsElementId: "children_age_option_17",
                                    __typename: "EGDSBasicOption"
                                }
                            ],
                            egdsElementId: "traveler_selector_children_age_selector",
                            value: null,
                            __typename: "EGDSTravelerChildAgeSelect"
                        },
                        __typename: "EGDSTravelerChildren"
                    },
                    infants: null,
                    removeRoomButton: {
                        egdsElementId: "traveler_selector_remove_room",
                        primary: "Remove room",
                        disabled: false,
                        accessibility: null,
                        icon: null,
                        analytics: null,
                        action: null,
                        __typename: "UITertiaryButton"
                    },
                    __typename: "EGDSTravelerSelectorRoom"
                }
            ],
            infantSeatSelection: null,
            title: "Travelers",
            validations: [
                {
                    errorMessage: "We allow up to 20 travelers per booking.",
                    maxCount: 20,
                    type: "MAX_TRAVELERS" /* MAX_TRAVELERS */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: null,
                        goToFirstErrorLinkText: null,
                        heading: "We allow up to 20 travelers per booking.",
                        body: null,
                        analytics: null,
                        impressionAnalytics: {
                            linkName: "Error summary displayed on travelers",
                            referrerId: "Web.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: null,
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                },
                {
                    errorMessage: "Provide the age of the child.",
                    maxCount: null,
                    type: "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ,
                    infantsInSeatPerAdult: null,
                    errorSummary: {
                        egdsElementId: "traveler_selector_error_summary",
                        goToErrorLinkText: "Go to the error",
                        goToFirstErrorLinkText: "Go to the first error",
                        heading: "",
                        body: null,
                        analytics: {
                            linkName: "Error summary link clicked on travelers",
                            referrerId: "Web.Hotels.Traveler.Error.Summary",
                            __typename: "ClientSideAnalytics"
                        },
                        impressionAnalytics: {
                            linkName: "Error summary displayed on travelers",
                            referrerId: "Web.Hotels.Traveler.Error.Summary.Displayed",
                            __typename: "ClientSideImpressionEventAnalytics"
                        },
                        headingTemplate: {
                            models: [
                                {
                                    key: "errorCount",
                                    source: "errorCount",
                                    __typename: "TemplateModel"
                                }
                            ],
                            templates: [
                                {
                                    category: "ZERO" /* ZERO */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "ONE" /* ONE */ ,
                                    template: "To continue, please correct the error below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "TWO" /* TWO */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "FEW" /* FEW */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "MANY" /* MANY */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                },
                                {
                                    category: "OTHER" /* OTHER */ ,
                                    template: "To continue, please correct the ${errorCount} errors below.",
                                    __typename: "CardinalTemplate"
                                }
                            ],
                            __typename: "EGDSCardinalLocalizedText"
                        },
                        __typename: "EGDSErrorSummary"
                    },
                    __typename: "EGDSTravelersInputValidation"
                }
            ],
            __typename: "EGDSRoomsTravelerSelector"
        },
        __typename: "EGDSOpenTravelerSelectorAction"
    },
    label: "Travelers",
    labelTemplate: {
        models: [
            {
                key: "rooms",
                models: {
                    models: [
                        {
                            key: "roomCount",
                            source: "roomCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: [
                        {
                            category: "ZERO" /* ZERO */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "ONE" /* ONE */ ,
                            template: "${roomCount} room",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "TWO" /* TWO */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "FEW" /* FEW */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "MANY" /* MANY */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "OTHER" /* OTHER */ ,
                            template: "${roomCount} rooms",
                            __typename: "CardinalTemplate"
                        }
                    ],
                    __typename: "EGDSCardinalLocalizedText"
                },
                __typename: "CompositeLocalizedTextModel"
            },
            {
                key: "travelers",
                models: {
                    models: [
                        {
                            key: "travelerCount",
                            source: "travelerCount",
                            __typename: "TemplateModel"
                        }
                    ],
                    templates: [
                        {
                            category: "ZERO" /* ZERO */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "ONE" /* ONE */ ,
                            template: "${travelerCount} traveler",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "TWO" /* TWO */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "FEW" /* FEW */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "MANY" /* MANY */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        },
                        {
                            category: "OTHER" /* OTHER */ ,
                            template: "${travelerCount} travelers",
                            __typename: "CardinalTemplate"
                        }
                    ],
                    __typename: "EGDSCardinalLocalizedText"
                },
                __typename: "CompositeLocalizedTextModel"
            }
        ],
        template: "${travelers}, ${rooms}",
        text: "2 travelers, 1 room",
        __typename: "EGDSCompositeLocalizedText"
    },
    leftIcon: {
        id: "person",
        __typename: "Icon"
    }
};
var search = {
    egdsElementId: "submit_button",
    primary: "Search",
    disabled: false,
    accessibility: null,
    icon: null,
    analytics: null,
    action: null,
    __typename: "EGDSSearchFormButton",
    onClick: {
        analytics: {
            linkName: "Search button clicked",
            referrerId: "Web.Hotels.Search.Button.Clicked",
            __typename: "ClientSideAnalytics"
        },
        __typename: "EGDSSubmitSearchFormAction"
    }
};
var getFallbackFormData = function() {
    return {
        __typename: "LodgingSearchForm",
        egdsElementId: "lodging_search_form",
        actionURL: "/Hotel-Search",
        errorSummary: errorSummary,
        elements: [
            destination,
            datePicker,
            travelerSelector
        ],
        search: search,
        playback: null,
        softPackages: null,
        adaptExSuccessEvent: null
    };
};
// src/components/__private/lodging-search-form.tsx
import React49 from "react";
import { gql as gql41 } from "@apollo/client";
import { ITrackType, useClickstreamAnalytics, useClickTracker as useClickTracker20 } from "@shared-ui/clickstream-analytics-context";
import { useExperiment } from "@shared-ui/experiment-context";
import { useLocalization as useLocalization5 } from "@shared-ui/localization-context";
// ../internal/src/components/common/egds-error-summary.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { IntersectionTracker, useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkErrorSummary } from "uitk-react-error-summary";
// ../internal/src/utils/format-localized-token-string.ts
function formatLocalizedTokenString(localizedString, token, value) {
    return localizedString.replace("${".concat(token, "}"), value);
}
// ../internal/src/components/common/egds-error-summary.tsx
var __Fragment = gql(_templateObject());
var EGDSErrorSummary = function(param) {
    var _param_errorCount = param.errorCount, errorCount = _param_errorCount === void 0 ? 0 : _param_errorCount, inputErrorRef = param.inputErrorRef, linkClickFocusId = param.linkClickFocusId, data = param.data;
    var _impressionAnalytics, _impressionAnalytics1, _body, _inputErrorRef_current, _inputErrorRef;
    var focusHeading = React2.createRef();
    var clickTracker = useClickTracker();
    var body = data.body, goToErrorLinkText = data.goToErrorLinkText, goToFirstErrorLinkText = data.goToFirstErrorLinkText, heading = data.heading, analytics = data.analytics, impressionAnalytics = data.impressionAnalytics, headingTemplate = data.headingTemplate;
    var hasNoErrors = errorCount === 0;
    var hasOneError = errorCount === 1;
    if (hasNoErrors) {
        return null;
    }
    var getLocalizedErrorHeading = function(errors) {
        var _headingTemplate;
        if (((_headingTemplate = headingTemplate) === null || _headingTemplate === void 0 ? void 0 : _headingTemplate.__typename) === "EGDSCardinalLocalizedText") {
            var headingTemplates = headingTemplate.templates.slice(1, 3);
            var key = hasOneError ? "" : headingTemplate.models[0].key;
            var template = hasOneError ? headingTemplates[0].template : headingTemplates[1].template;
            return formatLocalizedTokenString(template, key, errors.toString());
        }
        return "";
    };
    var linkText = hasOneError ? goToErrorLinkText : goToFirstErrorLinkText;
    var handleUpdate = function() {
        var _focusHeading_current, _focusHeading;
        return (_focusHeading = focusHeading) === null || _focusHeading === void 0 ? void 0 : (_focusHeading_current = _focusHeading.current) === null || _focusHeading_current === void 0 ? void 0 : _focusHeading_current.focus();
    };
    var _impressionAnalytics_referrerId, _impressionAnalytics_linkName, _analytics_linkName;
    return /* @__PURE__ */ React2.createElement(IntersectionTracker, {
        referrerId: (_impressionAnalytics_referrerId = (_impressionAnalytics = impressionAnalytics) === null || _impressionAnalytics === void 0 ? void 0 : _impressionAnalytics.referrerId) !== null && _impressionAnalytics_referrerId !== void 0 ? _impressionAnalytics_referrerId : "",
        linkName: (_impressionAnalytics_linkName = (_impressionAnalytics1 = impressionAnalytics) === null || _impressionAnalytics1 === void 0 ? void 0 : _impressionAnalytics1.linkName) !== null && _impressionAnalytics_linkName !== void 0 ? _impressionAnalytics_linkName : ""
    }, /* @__PURE__ */ React2.createElement(UitkErrorSummary, {
        heading: heading.trim() ? heading : getLocalizedErrorHeading(errorCount),
        description: (_body = body) === null || _body === void 0 ? void 0 : _body.text,
        link: linkText !== null && linkText !== void 0 ? linkText : "",
        linkClickFocus: inputErrorRef,
        linkClickFocusId: linkClickFocusId !== null && linkClickFocusId !== void 0 ? linkClickFocusId : (_inputErrorRef = inputErrorRef) === null || _inputErrorRef === void 0 ? void 0 : (_inputErrorRef_current = _inputErrorRef.current) === null || _inputErrorRef_current === void 0 ? void 0 : _inputErrorRef_current.id,
        handleUpdate: handleUpdate,
        domRef: focusHeading,
        analytics: analytics ? {
            id: hasOneError ? "".concat(analytics.referrerId, ".One.Error") : "".concat(analytics.referrerId, ".Many.Errors"),
            description: (_analytics_linkName = analytics.linkName) !== null && _analytics_linkName !== void 0 ? _analytics_linkName : "",
            callback: function(id, description) {
                return clickTracker(id, description);
            }
        } : void 0
    }));
};
EGDSErrorSummary.displayName = "EGDSErrorSummaryFragment";
EGDSErrorSummary.fragment = __Fragment;
// ../internal/src/components/form/egds-search-form-button.tsx
import React3 from "react";
import { gql as gql3 } from "@apollo/client";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { UitkIcon } from "uitk-react-icons";
// ../internal/src/components/common/button/egds-button-fragment.ts
import { gql as gql2 } from "@apollo/client";
var EGDSButtonFragment = gql2(_templateObject1());
// ../internal/src/components/form/egds-search-form-button.tsx
var __Fragment2 = gql3(_templateObject2(), EGDSButtonFragment);
var EGDSSearchFormButton = function(param) {
    var data = param.data;
    var _icon, _icon1, _icon2;
    var track = useClickTracker2();
    var egdsElementId = data.egdsElementId, primary = data.primary, disabled = data.disabled, action = data.onClick, icon = data.icon;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_submit_button";
    var handleClick = React3.useCallback(function() {
        if (action && action.__typename === "EGDSSubmitSearchFormAction") {
            var _action_analytics = action.analytics, referrerId = _action_analytics.referrerId, linkName = _action_analytics.linkName;
            track(referrerId, linkName);
        }
    }, [
        action,
        track
    ]);
    var submitButtonProps = {
        id: id,
        disabled: disabled,
        onClick: handleClick,
        type: "submit"
    };
    var Button = function(param) {
        var children = param.children, _param_isFullWidth = param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? false : _param_isFullWidth;
        return /* @__PURE__ */ React3.createElement(UitkPrimaryButton, _object_spread_props(_object_spread({}, submitButtonProps), {
            size: UitkButtonSize.LARGE,
            "aria-label": primary !== null && primary !== void 0 ? primary : "",
            isFullWidth: isFullWidth
        }), children);
    };
    var _icon_token, _icon_title;
    return /* @__PURE__ */ React3.createElement(Viewport, null, /* @__PURE__ */ React3.createElement(ViewSmall, null, /* @__PURE__ */ React3.createElement(Button, {
        isFullWidth: true
    }, primary)), /* @__PURE__ */ React3.createElement(ViewMedium, null, icon ? /* @__PURE__ */ React3.createElement(Button, null, /* @__PURE__ */ React3.createElement(UitkIcon, {
        name: (_icon_token = (_icon = icon) === null || _icon === void 0 ? void 0 : _icon.token) !== null && _icon_token !== void 0 ? _icon_token : "search",
        title: (_icon_title = (_icon1 = icon) === null || _icon1 === void 0 ? void 0 : _icon1.title) !== null && _icon_title !== void 0 ? _icon_title : "",
        id: (_icon2 = icon) === null || _icon2 === void 0 ? void 0 : _icon2.id
    })) : /* @__PURE__ */ React3.createElement(Button, null, primary)));
};
EGDSSearchFormButton.displayName = "EGDSSearchFormButton";
EGDSSearchFormButton.fragment = __Fragment2;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-search-form-date-picker-field.tsx
import React24 from "react";
import { gql as gql21 } from "@apollo/client";
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-date-range.tsx
import React22 from "react";
import { gql as gql19 } from "@apollo/client";
import { useClickTracker as useClickTracker8 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization as useLocalization3 } from "@shared-ui/localization-context";
import { useSearchFormReflectionContext } from "@shared-ui/retail-search-tools-reflection-provider";
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector.tsx
import React20 from "react";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker7 } from "@shared-ui/clickstream-analytics-context";
import { useLocalization } from "@shared-ui/localization-context";
import { UitkDateSelector } from "uitk-react-date-selector";
import { useFormCallback as useFormCallback3 } from "uitk-react-form";
// ../internal/src/utils/trigger-input-change-event.ts
var triggerInputChangeEvent = function(value, handler, inputType) {
    var event = new CustomEvent("change");
    var input = document.createElement("input");
    if (inputType) {
        input.type = inputType;
    }
    input.value = value;
    var changeListener = function(inputEvent) {
        handler(inputEvent);
    };
    input.addEventListener("change", changeListener);
    input.dispatchEvent(event);
    input.removeEventListener("change", changeListener);
};
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-calendar-content.tsx
import React6 from "react";
import { gql as gql6 } from "@apollo/client";
import { SingleSelectPillWrapper } from "@egds/react-search-experience";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
import React5, { useRef } from "react";
import { gql as gql5 } from "@apollo/client";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback } from "uitk-react-form";
import { UitkPill } from "uitk-react-pill";
import { Level, liveAnnounce } from "uitk-react-utils";
// ../internal/src/components/common/icon.tsx
import React4 from "react";
import { gql as gql4 } from "@apollo/client";
import { UitkIcon as UitkIcon2, UitkIconSize } from "uitk-react-icons";
var __Fragment3 = gql4(_templateObject3());
var _obj;
var iconSizeMap = (_obj = {}, _define_property(_obj, "EXTRA_SMALL" /* EXTRA_SMALL */ , UitkIconSize.EXTRA_SMALL), _define_property(_obj, "SMALL" /* SMALL */ , UitkIconSize.SMALL), _define_property(_obj, "MEDIUM" /* MEDIUM */ , UitkIconSize.MEDIUM), _define_property(_obj, "MEDIUM_LARGE" /* MEDIUM_LARGE */ , UitkIconSize.MEDIUM), _define_property(_obj, "LARGE" /* LARGE */ , UitkIconSize.LARGE), _define_property(_obj, "XLARGE" /* XLARGE */ , UitkIconSize.XLARGE), _obj);
var Icon = function(props) {
    var data = props.data;
    var id = data.id, title = data.title, description = data.description, size = data.size;
    var iconSize = iconSizeMap[size !== null && size !== void 0 ? size : "LARGE"];
    return /* @__PURE__ */ React4.createElement(UitkIcon2, {
        id: id,
        name: id,
        title: title !== null && title !== void 0 ? title : description,
        description: description,
        size: iconSize
    });
};
Icon.displayName = "Icon";
Icon.fragment = __Fragment3;
// ../internal/src/components/common/egds-pill/egds-basic-pill.tsx
var EGDS_BASIC_PILL_PREFIX = "EGDSBasicPill";
var __Fragment4 = gql5(_templateObject4(), Icon.fragment);
var EGDSBasicPill = function(props) {
    var _icon;
    var data = props.data, onChange = props.onChange, triggerPill = props.triggerPill, onClick = props.onClick, active = props.active;
    var accessibility = data.accessibility, name = data.name, primary = data.primary, selected = data.selected, value = data.value, disabled = data.disabled, icon = data.icon, selectAnalytics = data.selectAnalytics, deselectAnalytics = data.deselectAnalytics, selectedText = data.selectedText;
    var clickTracker = useClickTracker3();
    var id = name !== null && name !== void 0 ? name : "egds-basic-pill";
    var _React5_useState = _sliced_to_array(React5.useState(selected), 2), checked = _React5_useState[0], setCheckState = _React5_useState[1];
    var pillRef = useRef(false);
    var onPillSelectText = selectedText || primary;
    var handleOnChange = useFormCallback(id, function(event) {
        var _event_currentTarget = event.currentTarget, newSelection = _event_currentTarget.checked;
        setCheckState(newSelection);
        if (!pillRef.current) {
            pillRef.current = true;
        }
        if (onChange) {
            onChange(event);
        }
        if (selectAnalytics && newSelection) {
            var linkName = selectAnalytics.linkName, referrerId = selectAnalytics.referrerId;
            clickTracker(referrerId, linkName);
            return event;
        }
        if (deselectAnalytics && !newSelection) {
            var linkName1 = deselectAnalytics.linkName, referrerId1 = deselectAnalytics.referrerId;
            clickTracker(referrerId1, linkName1);
        }
        return event;
    });
    var handleOnClick = function() {
        if (onClick) {
            onClick();
        }
    };
    React5.useEffect(function() {
        if (pillRef.current) {
            liveAnnounce(accessibility !== null && accessibility !== void 0 ? accessibility : void 0, Level.POLITE);
        }
    }, [
        accessibility
    ]);
    React5.useEffect(function() {
        setCheckState(selected);
    }, [
        selected
    ]);
    return /* @__PURE__ */ React5.createElement(UitkPill, {
        checked: checked,
        active: active,
        disabled: disabled,
        icon: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.__typename) === "Icon" ? icon.token : "",
        id: id,
        name: "".concat(EGDS_BASIC_PILL_PREFIX, "-").concat(name),
        onChange: handleOnChange,
        value: value !== null && value !== void 0 ? value : "",
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        triggerPill: triggerPill,
        onClick: handleOnClick
    }, checked ? onPillSelectText : primary);
};
EGDSBasicPill.displayName = "EGDSBasicPill";
EGDSBasicPill.fragment = __Fragment4;
EGDSBasicPill.fragment.__typename = "EGDSBasicPill";
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-calendar-content.tsx
var __Fragment5 = gql6(_templateObject5(), EGDSBasicPill.fragment);
var DISPLAY_NAME = "EGDSDatePickerFlexibilityCalendarContent";
var FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX = "".concat(DISPLAY_NAME, "-SelectedOption");
var EGDSDatePickerFlexibilityCalendarContent = function(param) {
    var data = param.data, onSelect = param.onSelect, currentlySelectedPillValue = param.currentlySelectedPillValue, className = param.className;
    var _data;
    var handleSelectedPill = function(selectedPillValue) {
        onSelect(selectedPillValue);
    };
    var _pillData_primary, _pillData_value, _pillData_value1, _pillData_accessibility, _data_flexibleDateOptions_map;
    var singleSelectOptions = (_data_flexibleDateOptions_map = (_data = data) === null || _data === void 0 ? void 0 : _data.flexibleDateOptions.map(function(pillData) {
        return {
            selected: pillData.value === currentlySelectedPillValue,
            checked: pillData.value === currentlySelectedPillValue,
            text: (_pillData_primary = pillData.primary) !== null && _pillData_primary !== void 0 ? _pillData_primary : "",
            disabled: pillData.disabled,
            value: (_pillData_value = pillData.value) !== null && _pillData_value !== void 0 ? _pillData_value : "",
            id: (_pillData_value1 = pillData.value) !== null && _pillData_value1 !== void 0 ? _pillData_value1 : "",
            altText: (_pillData_accessibility = pillData.accessibility) !== null && _pillData_accessibility !== void 0 ? _pillData_accessibility : void 0
        };
    })) !== null && _data_flexibleDateOptions_map !== void 0 ? _data_flexibleDateOptions_map : [];
    return /* @__PURE__ */ React6.createElement(UitkSpacing2, {
        padding: {
            large: {
                blockstart: "four"
            },
            medium: {
                blockend: "half"
            },
            small: {
                blockend: "half"
            }
        },
        margin: {
            medium: {
                inlinestart: "two",
                blockend: "three",
                blockstart: "one"
            },
            small: {
                inlinestart: "two",
                blockend: "three",
                blockstart: "one"
            }
        }
    }, /* @__PURE__ */ React6.createElement("div", {
        className: className
    }, /* @__PURE__ */ React6.createElement(SingleSelectPillWrapper, {
        data: singleSelectOptions,
        handleSelectedPill: handleSelectedPill
    })));
};
EGDSDatePickerFlexibilityCalendarContent.displayName = DISPLAY_NAME;
EGDSDatePickerFlexibilityCalendarContent.fragment = __Fragment5;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-content.tsx
import React18 from "react";
import { gql as gql18 } from "@apollo/client";
import { UitkTabsBackGroundColorType as UitkTabsBackGroundColorType2, UitkTabsType as UitkTabsType2 } from "uitk-react-tabs";
// ../internal/src/components/common/egds-basic-tabs/egds-basic-tabs.tsx
import React7, { useState } from "react";
import { gql as gql7 } from "@apollo/client";
import { defaultViewSizes, useMediaQueries } from "@shared-ui/viewport-context";
import { UitkTab, UitkTabs, UitkTabsBackGroundColorType, UitkTabsType } from "uitk-react-tabs";
var __Fragment6 = gql7(_templateObject6());
var EGDSBasicTabs = function(param) {
    var data = param.data, onTabSelected = param.onTabSelected, backgroundColor = param.backgroundColor, tabsType = param.tabsType;
    var tabs = data.tabs, selectedTabId = data.selectedTabId;
    var defaultTabSelected = 0;
    var initialSelectedTab = selectedTabId ? tabs.findIndex(function(tab) {
        return tab.tabId === selectedTabId;
    }) : defaultTabSelected;
    var _useState = _sliced_to_array(useState(initialSelectedTab), 2), selectedTab = _useState[0], setSelectedTab = _useState[1];
    var viewportSize = useMediaQueries({
        viewSizes: defaultViewSizes
    });
    var isSmallViewportSize = viewportSize <= defaultViewSizes.SMALL;
    var onTabSelect = function(selectedIndex) {
        setSelectedTab(selectedIndex);
        if (onTabSelected) {
            var tab = tabs[selectedIndex];
            onTabSelected(tab.tabId);
        }
    };
    var defaultTabsType = isSmallViewportSize ? UitkTabsType.EQUAL_WIDTH : UitkTabsType.NATURAL;
    var tabProps = {
        selectedTab: selectedTab !== -1 ? selectedTab : defaultTabSelected,
        onTabSelect: onTabSelect,
        tabsType: tabsType !== null && tabsType !== void 0 ? tabsType : defaultTabsType,
        backgroundColor: backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : UitkTabsBackGroundColorType.PRIMARY
    };
    return /* @__PURE__ */ React7.createElement(UitkTabs, _object_spread({}, tabProps), tabs.map(function(param) {
        var tabId = param.tabId, label = param.label;
        return /* @__PURE__ */ React7.createElement(UitkTab, {
            id: tabId,
            key: tabId,
            name: label,
            targetURI: "#EGDSBasicTabSearchForm_".concat(tabId)
        });
    }));
};
EGDSBasicTabs.fragment = __Fragment6;
EGDSBasicTabs.displayName = "EGDSBasicTabs";
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-dates-content.tsx
import React17 from "react";
import { gql as gql17 } from "@apollo/client";
import { UitkSpacing as UitkSpacing4, UitkSpacingHr } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-months-section.tsx
import React10 from "react";
import { gql as gql10 } from "@apollo/client";
import { defaultViewSizes as defaultViewSizes2, useMediaQueries as useMediaQueries2 } from "@shared-ui/viewport-context";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing3 } from "uitk-react-spacing";
import { UitkHeading, UitkSubheading } from "uitk-react-text";
// ../internal/src/components/common/button/toggle/egds-toggle-button.tsx
import React8 from "react";
import { gql as gql8 } from "@apollo/client";
import { UitkButtonToggle } from "uitk-react-button-toggle";
import { UitkIconSize as UitkIconSize2 } from "uitk-react-icons";
var __Fragment7 = gql8(_templateObject7());
var EGDSToggleButton = function(param) {
    var data = param.data, onChange = param.onChange;
    var _icon;
    var primary = data.primary, subText = data.subText, icon = data.icon, disabled = data.disabled, selected = data.selected, name = data.name;
    var handleChange = function(event) {
        if (onChange) {
            onChange(event);
        }
    };
    return /* @__PURE__ */ React8.createElement(UitkButtonToggle, {
        id: name !== null && name !== void 0 ? name : "",
        icon: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.__typename) === "Icon" ? icon.description : "calendar",
        labelText: primary !== null && primary !== void 0 ? primary : "",
        altText: "".concat(primary, " ").concat(subText),
        subLabelText: subText !== null && subText !== void 0 ? subText : "",
        name: name !== null && name !== void 0 ? name : "",
        onChange: handleChange,
        disabled: disabled,
        checked: selected,
        iconSize: UitkIconSize2.SMALL,
        stacked: true
    });
};
EGDSToggleButton.displayName = "EGDSToggleButton";
EGDSToggleButton.fragment = __Fragment7;
// ../internal/src/components/common/button/toggle/egds-toggle-button-group.tsx
import React9 from "react";
import { gql as gql9 } from "@apollo/client";
import { UitkButtonToggleGroup } from "uitk-react-button-toggle";
var __Fragment8 = gql9(_templateObject8(), EGDSToggleButton.fragment);
var EGDSToggleButtonGroup = function(param) {
    var data = param.data;
    var options = data.options;
    var _React9_useState = _sliced_to_array(React9.useState(options), 2), buttons = _React9_useState[0], setButtons = _React9_useState[1];
    var handleChange = function(event) {
        setButtons(function(prevState) {
            return prevState.map(function(buttonToggleState) {
                return buttonToggleState.name === event.target.name ? _object_spread_props(_object_spread({}, buttonToggleState), {
                    selected: !buttonToggleState.selected
                }) : buttonToggleState;
            });
        });
    };
    return /* @__PURE__ */ React9.createElement(UitkButtonToggleGroup, {
        wrapButtons: true
    }, buttons.map(function(option, index) {
        return /* @__PURE__ */ React9.createElement(EGDSToggleButton, {
            key: index,
            data: option,
            onChange: handleChange
        });
    }));
};
EGDSToggleButtonGroup.displayName = "EGDSToggleButtonGroup";
EGDSToggleButtonGroup.fragment = __Fragment8;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-months-section.tsx
var __Fragment9 = gql10(_templateObject9(), EGDSToggleButtonGroup.fragment);
var DISPLAY_NAME2 = "EGDSDatePickerFlexibleMonths";
var EGDSDatePickerFlexibleMonths = function(param) {
    var data = param.data, monthsSelectionToggleButtons = param.monthsSelectionToggleButtons, onMonthSelectionToggle = param.onMonthSelectionToggle;
    var heading = data.heading, subHeading = data.subHeading;
    var viewportSize = useMediaQueries2({
        viewSizes: defaultViewSizes2
    });
    var isSmallViewportSize = viewportSize <= defaultViewSizes2.SMALL;
    var buttonToggleLayoutItemProps = {
        grow: 1,
        maxWidth: isSmallViewportSize ? void 0 : "twenty_four",
        minWidth: isSmallViewportSize ? "quarter_width" : void 0
    };
    return /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(UitkLayoutFlex, {
        alignItems: "center",
        direction: "column",
        space: "three"
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(UitkHeading, {
        size: 6,
        align: "center"
    }, heading), /* @__PURE__ */ React10.createElement(UitkSubheading, null, subHeading)))), monthsSelectionToggleButtons && /* @__PURE__ */ React10.createElement(UitkSpacing3, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React10.createElement(UitkLayoutFlex, {
        direction: "row",
        justifyContent: "space-around",
        wrap: "wrap",
        space: "three"
    }, monthsSelectionToggleButtons.options.map(function(option, index) {
        return /* @__PURE__ */ React10.createElement(UitkLayoutFlexItem, _object_spread_props(_object_spread({}, buttonToggleLayoutItemProps), {
            key: index
        }), /* @__PURE__ */ React10.createElement("div", null, /* @__PURE__ */ React10.createElement(EGDSToggleButton, {
            data: option,
            onChange: onMonthSelectionToggle
        })));
    }))));
};
EGDSDatePickerFlexibleMonths.displayName = DISPLAY_NAME2;
EGDSDatePickerFlexibleMonths.fragment = __Fragment9;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-nights-section.tsx
import React16 from "react";
import { gql as gql16 } from "@apollo/client";
import { SingleSelectPillWrapper as SingleSelectPillWrapper2 } from "@egds/react-search-experience";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkHeading as UitkHeading2 } from "uitk-react-text";
// ../internal/src/components/common/checkbox/egds-checkbox.tsx
import React12 from "react";
import { gql as gql12 } from "@apollo/client";
// ../internal/src/components/common/checkbox/egds-basic-checkbox.tsx
import React11 from "react";
import { gql as gql11 } from "@apollo/client";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { UitkCheckbox } from "uitk-react-checkbox";
var __Fragment10 = gql11(_templateObject10());
var EGDSBasicCheckBox = function(param) {
    var data = param.data, checked = param.checked, onChange = param.onChange;
    var _label;
    var egdsElementId = data.egdsElementId, description = data.description, enabled = data.enabled, name = data.name, required = data.required, label = data.label, checkedAnalytics = data.checkedAnalytics, uncheckedAnalytics = data.uncheckedAnalytics, state = data.state;
    var _React11_useState = _sliced_to_array(React11.useState(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ ), 2), isChecked = _React11_useState[0], setIsChecked = _React11_useState[1];
    React11.useEffect(function() {
        setIsChecked(checked !== null && checked !== void 0 ? checked : state === "CHECKED" /* CHECKED */ );
    }, [
        checked,
        state
    ]);
    var track = useClickTracker4();
    var handleChange = React11.useCallback(function(event) {
        var _onChange;
        setIsChecked(event.currentTarget.checked);
        if (checkedAnalytics && !isChecked) {
            var referrerId = checkedAnalytics.referrerId, linkName = checkedAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (uncheckedAnalytics && isChecked) {
            var referrerId1 = uncheckedAnalytics.referrerId, linkName1 = uncheckedAnalytics.linkName;
            track(referrerId1, linkName1);
        }
        (_onChange = onChange) === null || _onChange === void 0 ? void 0 : _onChange(event);
    }, [
        checkedAnalytics,
        isChecked,
        onChange,
        track,
        uncheckedAnalytics
    ]);
    return /* @__PURE__ */ React11.createElement(UitkCheckbox, {
        id: egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "",
        checked: isChecked,
        description: description !== null && description !== void 0 ? description : void 0,
        disabled: !enabled,
        name: name !== null && name !== void 0 ? name : void 0,
        onChange: handleChange,
        required: required
    }, (_label = label) === null || _label === void 0 ? void 0 : _label.text);
};
EGDSBasicCheckBox.displayName = "EGDSBasicCheckBoxFragment";
EGDSBasicCheckBox.fragment = __Fragment10;
EGDSBasicCheckBox.fragment.__typename = "EGDSBasicCheckBox";
// ../internal/src/components/common/checkbox/egds-checkbox.tsx
var __Fragment11 = gql12(_templateObject11(), EGDSBasicCheckBox.fragment);
var EGDSCheckBox = function(param) {
    var data = param.data, onChange = param.onChange;
    switch(data.__typename){
        case "EGDSBasicCheckBox":
            return /* @__PURE__ */ React12.createElement(EGDSBasicCheckBox, {
                onChange: onChange,
                data: data
            });
        default:
            return null;
    }
};
EGDSCheckBox.displayName = "EGDSCheckBox";
EGDSCheckBox.fragment = __Fragment11;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
import React15 from "react";
import { gql as gql15 } from "@apollo/client";
// ../internal/src/components/common/egds-pill/egds-basic-removable-pill.tsx
import React13 from "react";
import { gql as gql13 } from "@apollo/client";
import { useClickTracker as useClickTracker5 } from "@shared-ui/clickstream-analytics-context";
import { UitkRemovablePill } from "uitk-react-pill";
var __Fragment12 = gql13(_templateObject12());
var EGDSBasicRemovablePill = function(param) {
    var data = param.data, onClick = param.onClick;
    var id = data.id, primary = data.primary, accessibility = data.accessibility, removeAnalytics = data.removeAnalytics, name = data.name;
    var _ref;
    var title = (_ref = id !== null && id !== void 0 ? id : name) !== null && _ref !== void 0 ? _ref : "egds-basic-removable-pill";
    var clickTracker = useClickTracker5();
    var handleOnClick = function() {
        if (onClick) {
            onClick();
        }
        if (removeAnalytics) {
            var referrerId = removeAnalytics.referrerId, linkName = removeAnalytics.linkName;
            clickTracker(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React13.createElement(UitkRemovablePill, {
        id: title,
        onClick: handleOnClick,
        a11yRemoveText: accessibility || ""
    }, primary);
};
EGDSBasicRemovablePill.displayName = "EGDSBasicRemovablePill";
EGDSBasicRemovablePill.fragment = __Fragment12;
// ../internal/src/components/common/egds-pill/egds-basic-trigger-pill.tsx
import React14 from "react";
import { gql as gql14 } from "@apollo/client";
import { useClickTracker as useClickTracker6 } from "@shared-ui/clickstream-analytics-context";
import { useFormCallback as useFormCallback2 } from "uitk-react-form";
import { UitkPill as UitkPill2 } from "uitk-react-pill";
var EGDS_BASIC_TRIGGER_PILL_PREFIX = "EGDSBasicTriggerPill";
var __Fragment13 = gql14(_templateObject13(), Icon.fragment);
var EGDSBasicTriggerPill = function(props) {
    var _icon;
    var data = props.data, onChange = props.onChange, triggerPill = props.triggerPill, onClick = props.onClick, domRef = props.domRef, active = props.active;
    var id = data.id, primary = data.primary, selected = data.selected, disabled = data.disabled, icon = data.icon, selectAnalytics = data.selectAnalytics, deselectAnalytics = data.deselectAnalytics, accessibility = data.accessibility;
    var clickTracker = useClickTracker6();
    var name = id !== null && id !== void 0 ? id : "egds-basic-pill";
    var _React14_useState = _sliced_to_array(React14.useState(active || selected), 2), checked = _React14_useState[0], check = _React14_useState[1];
    React14.useEffect(function() {
        check(active !== null && active !== void 0 ? active : false);
    }, [
        active
    ]);
    var handleOnClick = useFormCallback2(name, function(event) {
        check(!checked);
        if (onChange) {
            onChange(event);
        }
        if (onClick) {
            onClick();
        }
        if (selectAnalytics && checked) {
            var linkName = selectAnalytics.linkName, referrerId = selectAnalytics.referrerId;
            clickTracker(referrerId, linkName);
            return event;
        }
        if (deselectAnalytics && !checked) {
            var linkName1 = deselectAnalytics.linkName, referrerId1 = deselectAnalytics.referrerId;
            clickTracker(referrerId1, linkName1);
        }
        return event;
    });
    return /* @__PURE__ */ React14.createElement(UitkPill2, {
        checked: checked,
        active: checked,
        selected: selected,
        disabled: disabled,
        icon: ((_icon = icon) === null || _icon === void 0 ? void 0 : _icon.__typename) === "Icon" ? icon.token : "",
        id: name,
        name: "".concat(EGDS_BASIC_TRIGGER_PILL_PREFIX, "-").concat(name),
        triggerPill: triggerPill,
        onClick: handleOnClick,
        altText: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        domRef: domRef
    }, primary);
};
EGDSBasicTriggerPill.displayName = "EGDSBasicTriggerPillFragment";
EGDSBasicTriggerPill.fragment = __Fragment13;
// ../internal/src/components/common/egds-pill/egds-pill.tsx
var __Fragment14 = gql15(_templateObject14(), EGDSBasicPill.fragment, EGDSBasicTriggerPill.fragment, EGDSBasicRemovablePill.fragment);
var EGDSPill = function(props) {
    var data = props.data;
    switch(data.__typename){
        case "EGDSBasicPill":
            return /* @__PURE__ */ React15.createElement(EGDSBasicPill, _object_spread_props(_object_spread({}, props), {
                data: data
            }));
        case "EGDSBasicTriggerPill":
            return /* @__PURE__ */ React15.createElement(EGDSBasicTriggerPill, _object_spread_props(_object_spread({}, props), {
                data: data
            }));
        case "EGDSBasicRemovablePill":
            return /* @__PURE__ */ React15.createElement(EGDSBasicRemovablePill, _object_spread_props(_object_spread({}, props), {
                data: data
            }));
        default:
            return null;
    }
};
EGDSPill.displayName = "EGDSPill";
EGDSPill.fragment = __Fragment14;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-nights-section.tsx
var __Fragment15 = gql16(_templateObject15(), EGDSPill.fragment, EGDSCheckBox.fragment);
var DISPLAY_NAME3 = "EGDSDatePickerFlexibleNights";
var EGDSDatePickerFlexibleNights = function(param) {
    var data = param.data, onNightSelectionPillChange = param.onNightSelectionPillChange, nightsSelectionPills = param.nightsSelectionPills, onIncludeWeekendCheck = param.onIncludeWeekendCheck, includeWeekendCheckbox = param.includeWeekendCheckbox;
    var heading = data.heading;
    return /* @__PURE__ */ React16.createElement("div", null, /* @__PURE__ */ React16.createElement(UitkLayoutFlex2, {
        alignItems: "center",
        direction: "column",
        space: "three"
    }, /* @__PURE__ */ React16.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React16.createElement(UitkHeading2, {
        size: 6
    }, heading)), /* @__PURE__ */ React16.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React16.createElement(SingleSelectPillWrapper2, {
        data: nightsSelectionPills,
        handleSelectedPill: onNightSelectionPillChange
    }), ";"), includeWeekendCheckbox && /* @__PURE__ */ React16.createElement(UitkLayoutFlexItem2, null, /* @__PURE__ */ React16.createElement(EGDSCheckBox, {
        data: includeWeekendCheckbox,
        onChange: onIncludeWeekendCheck
    }))));
};
EGDSDatePickerFlexibleNights.displayName = DISPLAY_NAME3;
EGDSDatePickerFlexibleNights.fragment = __Fragment15;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-dates-content.tsx
var __Fragment16 = gql17(_templateObject16(), EGDSDatePickerFlexibleMonths.fragment, EGDSDatePickerFlexibleNights.fragment);
var DISPLAY_NAME4 = "EGDSDatePickerFlexibilityDatesContent";
var EGDSDatePickerFlexibilityDatesContent = function(param) {
    var data = param.data, className = param.className, onNightSelectionPillChange = param.onNightSelectionPillChange, nightsSelectionPills = param.nightsSelectionPills, onIncludeWeekendCheck = param.onIncludeWeekendCheck, includeWeekendCheckbox = param.includeWeekendCheckbox, monthsSelectionToggleButtons = param.monthsSelectionToggleButtons, onMonthSelectionToggle = param.onMonthSelectionToggle;
    var nightsSelection = data.nightsSelection, monthsSelection = data.monthsSelection;
    return /* @__PURE__ */ React17.createElement(UitkSpacing4, {
        padding: "four"
    }, /* @__PURE__ */ React17.createElement("div", {
        className: className
    }, nightsSelection && /* @__PURE__ */ React17.createElement(EGDSDatePickerFlexibleNights, {
        data: nightsSelection,
        onNightSelectionPillChange: onNightSelectionPillChange,
        nightsSelectionPills: nightsSelectionPills,
        onIncludeWeekendCheck: onIncludeWeekendCheck,
        includeWeekendCheckbox: includeWeekendCheckbox
    }), /* @__PURE__ */ React17.createElement(UitkSpacingHr, {
        blockMargin: "six"
    }), monthsSelection && /* @__PURE__ */ React17.createElement(EGDSDatePickerFlexibleMonths, {
        data: monthsSelection,
        monthsSelectionToggleButtons: monthsSelectionToggleButtons,
        onMonthSelectionToggle: onMonthSelectionToggle
    })));
};
EGDSDatePickerFlexibilityDatesContent.displayName = DISPLAY_NAME4;
EGDSDatePickerFlexibilityDatesContent.fragment = __Fragment16;
// ../internal/src/components/form/egds-search-form-date-picker-field/flexible-content/egds-date-picker-flexibility-content.tsx
var __Fragment17 = gql18(_templateObject17(), EGDSBasicTabs.fragment, EGDSDatePickerFlexibilityCalendarContent.fragment, EGDSDatePickerFlexibilityDatesContent.fragment);
var DISPLAY_NAME5 = "EGDSDatePickerFlexibilityContent";
var EGDSDatePickerFlexibilityContent = function(param) {
    var data = param.data, children = param.children, className = param.className, onContentSelectorSelection = param.onContentSelectorSelection, onNightSelectionPillChange = param.onNightSelectionPillChange, nightsSelectionPills = param.nightsSelectionPills, onIncludeWeekendCheck = param.onIncludeWeekendCheck, includeWeekendCheckbox = param.includeWeekendCheckbox, monthsSelectionToggleButtons = param.monthsSelectionToggleButtons, onMonthSelectionToggle = param.onMonthSelectionToggle, contentSelector = param.contentSelector;
    var _contentSelector, _contentSelector1, _contentSelector2, _contentSelector3;
    var flexibleDatesContent = data.flexibleDatesContent;
    var activeTab = ((_contentSelector = contentSelector) === null || _contentSelector === void 0 ? void 0 : _contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.selectedTabId : "";
    var calendarTabId = ((_contentSelector1 = contentSelector) === null || _contentSelector1 === void 0 ? void 0 : _contentSelector1.__typename) === "EGDSBasicTabs" ? contentSelector.tabs[0].tabId : "";
    var flexibleTabId = ((_contentSelector2 = contentSelector) === null || _contentSelector2 === void 0 ? void 0 : _contentSelector2.__typename) === "EGDSBasicTabs" ? contentSelector.tabs[1].tabId : "";
    return /* @__PURE__ */ React18.createElement("div", {
        className: className
    }, ((_contentSelector3 = contentSelector) === null || _contentSelector3 === void 0 ? void 0 : _contentSelector3.__typename) === "EGDSBasicTabs" && /* @__PURE__ */ React18.createElement(EGDSBasicTabs, {
        data: contentSelector,
        onTabSelected: onContentSelectorSelection,
        backgroundColor: UitkTabsBackGroundColorType2.SECONDARY,
        tabsType: UitkTabsType2.EQUAL_WIDTH
    }), activeTab === calendarTabId && children, activeTab === flexibleTabId && flexibleDatesContent && /* @__PURE__ */ React18.createElement(EGDSDatePickerFlexibilityDatesContent, {
        data: flexibleDatesContent,
        onNightSelectionPillChange: onNightSelectionPillChange,
        nightsSelectionPills: nightsSelectionPills,
        onIncludeWeekendCheck: onIncludeWeekendCheck,
        includeWeekendCheckbox: includeWeekendCheckbox,
        monthsSelectionToggleButtons: monthsSelectionToggleButtons,
        onMonthSelectionToggle: onMonthSelectionToggle
    }));
};
EGDSDatePickerFlexibilityContent.displayName = DISPLAY_NAME5;
EGDSDatePickerFlexibilityContent.fragment = __Fragment17;
// ../internal/src/components/form/egds-search-form-date-picker-field/helpers.tsx
import React19 from "react";
import { DayName } from "uitk-react-date-picker";
// ../internal/src/utils/search-form-plural-category.tsx
var getPluralCategory = function(value) {
    if (value === 0) {
        return "ZERO" /* ZERO */ ;
    }
    if (value === 1) {
        return "ONE" /* ONE */ ;
    }
    if (value === 2) {
        return "TWO" /* TWO */ ;
    }
    if (value > 2 && value < 5) {
        return "FEW" /* FEW */ ;
    }
    if (value >= 5 && value < 10) {
        return "MANY" /* MANY */ ;
    }
    return "OTHER" /* OTHER */ ;
};
// ../internal/src/components/form/egds-search-form-date-picker-field/helpers.tsx
var TO_DAY_MULTIPLIER = 1e3 * 60 * 60 * 24;
var addMaxDateToToday = function(daysInAdvance) {
    var today2 = /* @__PURE__ */ new Date();
    var daysInAdvanceInMiliseconds = daysInAdvance * TO_DAY_MULTIPLIER;
    var todayPlusDaysInAdvance = new Date(today2.getTime() + daysInAdvanceInMiliseconds);
    return todayPlusDaysInAdvance;
};
var convertFromMiliSecondsToDays = function(miliseconds) {
    return Math.ceil(miliseconds / 1e3 / 60 / 60 / 24);
};
var convertToDateObject = function(param) {
    var year = param.year, month = param.month, day = param.day;
    return new Date(year, month - 1, day);
};
var dialogWrapper = function(DialogWrapper) {
    return(// eslint-disable-next-line react/display-name
    function(children) {
        return /* @__PURE__ */ React19.createElement(DialogWrapper, null, children);
    });
};
var routerLinkWrapper = function(children) {
    return /* @__PURE__ */ React19.createElement(React19.Fragment, null, children);
};
var _obj1;
var EGDSDayNameMap = (_obj1 = {}, _define_property(_obj1, "SUN" /* SUN */ , DayName.SUN), _define_property(_obj1, "MON" /* MON */ , DayName.MON), _define_property(_obj1, "TUE" /* TUE */ , DayName.TUE), _define_property(_obj1, "WED" /* WED */ , DayName.WED), _define_property(_obj1, "THU" /* THU */ , DayName.THU), _define_property(_obj1, "FRI" /* FRI */ , DayName.FRI), _define_property(_obj1, "SAT" /* SAT */ , DayName.SAT), _obj1);
var formatCardinalText = function(cardinalText, value) {
    var templateKey = "templates";
    var cardinalTemplate = cardinalText[templateKey].find(function(template) {
        return template.category === getPluralCategory(value);
    });
    if (!cardinalTemplate) {
        return "";
    }
    return formatLocalizedTokenString(cardinalTemplate.template, cardinalText.models[0].key, value.toString());
};
var EXACT_DATES_PREFIX = "0";
var isFlexibleOptionExactDates = function(flexibleOption) {
    var _flexibleOption_value, _flexibleOption;
    return !!((_flexibleOption = flexibleOption) === null || _flexibleOption === void 0 ? void 0 : (_flexibleOption_value = _flexibleOption.value) === null || _flexibleOption_value === void 0 ? void 0 : _flexibleOption_value.startsWith(EXACT_DATES_PREFIX));
};
// ../internal/src/components/form/egds-search-form-date-picker-field/date-range-selector.tsx
var DEFAULT_LOCALE = "en-US";
var TYPENAME_REFERENCE = "EGDSSearchFormDatePickerField";
var formatLocale = function(locale) {
    return locale.replace("_", "-");
};
var DateRangeSelector = function(props) {
    var _buttonTextTemplate, _flexibleDateContent_calendarContent, _flexibleDateContent, _flexibleDateOptions_find, _flexibleDateOptions, _flexibleDateContent1, _contentSelector, _flexibleDateContent_flexibleDatesContent_nightsSelection, _flexibleDateContent_flexibleDatesContent, _flexibleDateContent2, _flexibleDateContent_flexibleDatesContent_nightsSelection1, _flexibleDateContent_flexibleDatesContent1, _flexibleDateContent3, _flexibleDateContent_flexibleDatesContent_monthsSelection, _flexibleDateContent_flexibleDatesContent2, _flexibleDateContent4, _flexibleDateContent5, _flexibleContentConfig, _flexibleContentConfig1, _flexibleDateContent6, _contentSelector1, _contentSelector2, _flexibleDateContent7, _flexibleDateContent_calendarContent1;
    var autoOpen = props.autoOpen, startDate2 = props.startDate, endDate2 = props.endDate, enableSameDayDateRange = props.enableSameDayDateRange, buttonText = props.buttonText, clearButtonText = props.clearButtonText, startButtonLabel = props.inputLabel1, endStartButtonLabel = props.inputLabel2, allowClearDates = props.allowClearDates, validDaysLowerBoundInclusive = props.validDaysLowerBoundInclusive, validDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive, skipQuery = props.skipQuery, typename = props.typename, startDateErrorMessage = props.errorMessage, buttonTextTemplate = props.buttonTextTemplate, onClearDates = props.onClearDates, onSelectEndDate = props.onSelectEndDate, onSelectStartDate = props.onSelectStartDate, onChangeEndDate = props.onChangeEndDate, onChangeStartDate = props.onChangeStartDate, onSubmit = props.onSubmit, onOpen = props.onOpen, setFieldRefByTypename = props.setFieldRefByTypename, onNextCalendarClick = props.onNextCalendarClick, onPreviousCalendarClick = props.onPreviousCalendarClick, flexibleDateContent = props.flexibleDateContent, flexibleContentConfig = props.flexibleContentConfig, dialogId = props.dialogId, startDateString = props.startDateString, endDateString = props.endDateString;
    var context = useBexApi().context;
    var locale = context.locale ? formatLocale(context.locale) : DEFAULT_LOCALE;
    var clickTracker = useClickTracker7();
    var formatDateString = useLocalization().formatDateString;
    var startDateRef = React20.useRef(null);
    var formattedStartDate = startDate2 ? formatDateString(startDateString !== null && startDateString !== void 0 ? startDateString : convertToDateObject(startDate2), {
        raw: "yyyy-MM-dd"
    }) : null;
    var formattedEndDate = endDate2 ? formatDateString(endDateString !== null && endDateString !== void 0 ? endDateString : convertToDateObject(endDate2), {
        raw: "yyyy-MM-dd"
    }) : null;
    var _React20_useState = _sliced_to_array(React20.useState(formattedStartDate), 2), checkInDateString = _React20_useState[0], setCheckInDateString = _React20_useState[1];
    var _React20_useState1 = _sliced_to_array(React20.useState(formattedEndDate), 2), checkOutDateString = _React20_useState1[0], setCheckOutDateString = _React20_useState1[1];
    var _React20_useState2 = _sliced_to_array(React20.useState(500), 2), daysBookableInAdvance = _React20_useState2[0], setDaysBookableInAdvance = _React20_useState2[1];
    var _React20_useState3 = _sliced_to_array(React20.useState(false), 2), shouldFireChangeEvent = _React20_useState3[0], setShouldFireChangeEvent = _React20_useState3[1];
    var _React20_useState4 = _sliced_to_array(React20.useState(autoOpen !== null && autoOpen !== void 0 ? autoOpen : false), 2), initialOpenState = _React20_useState4[0], setInitialOpenState = _React20_useState4[1];
    var _React20_useState5 = _sliced_to_array(React20.useState(((_buttonTextTemplate = buttonTextTemplate) === null || _buttonTextTemplate === void 0 ? void 0 : _buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText" ? buttonTextTemplate.text : buttonText), 2), dynamicButtonText = _React20_useState5[0], setDynamicButtonText = _React20_useState5[1];
    var flexibleDateOptions = (_flexibleDateContent = flexibleDateContent) === null || _flexibleDateContent === void 0 ? void 0 : (_flexibleDateContent_calendarContent = _flexibleDateContent.calendarContent) === null || _flexibleDateContent_calendarContent === void 0 ? void 0 : _flexibleDateContent_calendarContent.flexibleDateOptions;
    var _flexibleDateOptions_find_value;
    var submittedDateOptionValue = React20.useRef((_flexibleDateOptions_find_value = (_flexibleDateOptions = flexibleDateOptions) === null || _flexibleDateOptions === void 0 ? void 0 : (_flexibleDateOptions_find = _flexibleDateOptions.find(function(option) {
        return checkInDateString && checkOutDateString ? option.selected : isFlexibleOptionExactDates(option);
    })) === null || _flexibleDateOptions_find === void 0 ? void 0 : _flexibleDateOptions_find.value) !== null && _flexibleDateOptions_find_value !== void 0 ? _flexibleDateOptions_find_value : "");
    var _React20_useState6 = _sliced_to_array(React20.useState(submittedDateOptionValue.current || ""), 2), currentDateOptionValue = _React20_useState6[0], setCurrentDateOptionValue = _React20_useState6[1];
    var handleSubmit = useFormCallback3(typename, function(event) {
        return event;
    });
    React20.useEffect(function() {
        if (shouldFireChangeEvent && checkInDateString && checkOutDateString) {
            setShouldFireChangeEvent(false);
            triggerInputChangeEvent("".concat(checkInDateString, " - ").concat(checkOutDateString), handleSubmit);
        }
    }, [
        shouldFireChangeEvent
    ]);
    React20.useEffect(function() {
        if (!skipQuery) {
            if (formattedStartDate) {
                setCheckInDateString(formattedStartDate);
            }
            if (formattedEndDate) {
                setCheckOutDateString(formattedEndDate);
            }
            if (!formattedStartDate && !formattedEndDate) {
                setCheckInDateString("");
                setCheckOutDateString("");
            }
        }
        if (validDaysUpperBoundInclusive) {
            var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */ new Date().getTime();
            setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
        }
    }, [
        formattedEndDate,
        formattedStartDate,
        skipQuery,
        validDaysLowerBoundInclusive,
        validDaysUpperBoundInclusive
    ]);
    React20.useEffect(function() {
        setFieldRefByTypename(TYPENAME_REFERENCE, startDateRef);
    }, []);
    var calendarHandlerOnScroll = React20.useCallback(function() {
        var _startDateRef_current, _startDateRef;
        var distanceToTopOfViewportToClose = 20;
        var _startDateRef_current_getBoundingClientRect_top;
        if (initialOpenState && ((_startDateRef_current_getBoundingClientRect_top = (_startDateRef = startDateRef) === null || _startDateRef === void 0 ? void 0 : (_startDateRef_current = _startDateRef.current) === null || _startDateRef_current === void 0 ? void 0 : _startDateRef_current.getBoundingClientRect().top) !== null && _startDateRef_current_getBoundingClientRect_top !== void 0 ? _startDateRef_current_getBoundingClientRect_top : distanceToTopOfViewportToClose) <= distanceToTopOfViewportToClose) {
            setInitialOpenState(false);
            document.body.click();
        }
    }, [
        initialOpenState
    ]);
    React20.useEffect(function() {
        if (initialOpenState) {
            window.addEventListener("scroll", calendarHandlerOnScroll);
            return function() {
                return window.removeEventListener("scroll", calendarHandlerOnScroll);
            };
        }
    }, [
        initialOpenState,
        calendarHandlerOnScroll
    ]);
    var updateButtonSubmitText = function(newStartDate, newEndDate) {
        var _buttonTextTemplate;
        if (((_buttonTextTemplate = buttonTextTemplate) === null || _buttonTextTemplate === void 0 ? void 0 : _buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText" && newStartDate && newEndDate) {
            var startDateInMiliSeconds = Number(new Date(newStartDate));
            var formateCurrentEndDate = newEndDate !== null && newEndDate !== void 0 ? newEndDate : "";
            var endDateInMiliSeconds = Number(new Date(formateCurrentEndDate));
            var durationOfDays = convertFromMiliSecondsToDays(endDateInMiliSeconds - startDateInMiliSeconds);
            setDynamicButtonText(formatCardinalText(buttonTextTemplate, durationOfDays));
        }
    };
    var onDateRangeChange = function(newStartDate, newEndDate) {
        var _nextTostartDate_toISOString, _nextTostartDate, _formatedDefaultEndDate;
        setShouldFireChangeEvent(false);
        if (!(newStartDate === null && checkInDateString !== null)) {
            setCheckInDateString(newStartDate);
        }
        if (newStartDate) {
            onChangeStartDate(newStartDate);
            onSelectStartDate();
        }
        var nextTostartDate = newStartDate && new Date(newStartDate);
        if (nextTostartDate) {
            var _nextTostartDate1;
            (_nextTostartDate1 = nextTostartDate) === null || _nextTostartDate1 === void 0 ? void 0 : _nextTostartDate1.setDate(nextTostartDate.getDate() + 1);
        }
        var formatedDefaultEndDate = (_nextTostartDate = nextTostartDate) === null || _nextTostartDate === void 0 ? void 0 : (_nextTostartDate_toISOString = _nextTostartDate.toISOString()) === null || _nextTostartDate_toISOString === void 0 ? void 0 : _nextTostartDate_toISOString.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}/gi);
        if (newEndDate || ((_formatedDefaultEndDate = formatedDefaultEndDate) === null || _formatedDefaultEndDate === void 0 ? void 0 : _formatedDefaultEndDate[0])) {
            var _formatedDefaultEndDate1;
            var finalEndDate = newEndDate || ((_formatedDefaultEndDate1 = formatedDefaultEndDate) === null || _formatedDefaultEndDate1 === void 0 ? void 0 : _formatedDefaultEndDate1[0]) || null;
            setCheckOutDateString(finalEndDate);
            onSelectEndDate();
            onChangeEndDate(finalEndDate);
            updateButtonSubmitText(newStartDate, finalEndDate);
        } else if (newStartDate) {
            setCheckInDateString(newStartDate);
        }
    };
    var updateFlexibleDateContent = function(shouldReset) {
        if (shouldReset) {
            var _flexibleDateOptions_find, _flexibleDateOptions;
            var _flexibleDateOptions_find_value;
            var newFlexibleDateOptionValue = (_flexibleDateOptions_find_value = (_flexibleDateOptions = flexibleDateOptions) === null || _flexibleDateOptions === void 0 ? void 0 : (_flexibleDateOptions_find = _flexibleDateOptions.find(function(pill) {
                return isFlexibleOptionExactDates(pill);
            })) === null || _flexibleDateOptions_find === void 0 ? void 0 : _flexibleDateOptions_find.value) !== null && _flexibleDateOptions_find_value !== void 0 ? _flexibleDateOptions_find_value : "";
            submittedDateOptionValue.current = newFlexibleDateOptionValue;
            setCurrentDateOptionValue(newFlexibleDateOptionValue);
        } else {
            submittedDateOptionValue.current = currentDateOptionValue;
        }
    };
    var onDateRangeClear = function() {
        setCheckInDateString(null);
        setCheckOutDateString(null);
        updateFlexibleDateContent(true);
        onClearDates();
    };
    var onOpenCB = function() {
        onOpen();
        return {};
    };
    var onCloseCB = function() {
        setCurrentDateOptionValue(submittedDateOptionValue.current);
    };
    var onSubmitCB = function(start, end) {
        if (!startDate2 && !endDate2 && start && end) {
            setShouldFireChangeEvent(true);
            if (submittedDateOptionValue.current !== currentDateOptionValue) {
                updateFlexibleDateContent();
            }
            return;
        }
        if ((formattedStartDate !== null && formattedStartDate !== void 0 ? formattedStartDate : "") !== start || (formattedEndDate !== null && formattedEndDate !== void 0 ? formattedEndDate : "") !== end) {
            setShouldFireChangeEvent(true);
        }
        if (start && end && submittedDateOptionValue.current !== currentDateOptionValue) {
            setShouldFireChangeEvent(true);
            updateFlexibleDateContent();
        }
        onSubmit();
    };
    var handleFlexibleContentOptionSelection = function(newValue) {
        var _flexibleDateOptions;
        if ((_flexibleDateOptions = flexibleDateOptions) === null || _flexibleDateOptions === void 0 ? void 0 : _flexibleDateOptions.length) {
            var _flexibleDateOptions_find, _setCurrentDateOptionValue, _flexibleDateOptions_find1;
            var deselectAnalytics = (_flexibleDateOptions_find = flexibleDateOptions.find(function(selected) {
                return selected.value === currentDateOptionValue;
            })) === null || _flexibleDateOptions_find === void 0 ? void 0 : _flexibleDateOptions_find.deselectAnalytics;
            if (deselectAnalytics) {
                clickTracker(deselectAnalytics.referrerId, deselectAnalytics.linkName);
            }
            (_setCurrentDateOptionValue = setCurrentDateOptionValue) === null || _setCurrentDateOptionValue === void 0 ? void 0 : _setCurrentDateOptionValue(newValue);
            var selectAnalytics = (_flexibleDateOptions_find1 = flexibleDateOptions.find(function(selected) {
                return selected.value === newValue;
            })) === null || _flexibleDateOptions_find1 === void 0 ? void 0 : _flexibleDateOptions_find1.selectAnalytics;
            if (selectAnalytics) {
                clickTracker(selectAnalytics.referrerId, selectAnalytics.linkName);
            }
        }
    };
    var flexibleOptionTrailingText = React20.useMemo(function() {
        var _flexibleDateOptions, _flexibleOptionSelected;
        var flexibleOptionSelected = (_flexibleDateOptions = flexibleDateOptions) === null || _flexibleDateOptions === void 0 ? void 0 : _flexibleDateOptions.find(function(option) {
            return option.value === submittedDateOptionValue.current;
        });
        if (!((_flexibleOptionSelected = flexibleOptionSelected) === null || _flexibleOptionSelected === void 0 ? void 0 : _flexibleOptionSelected.primary) || isFlexibleOptionExactDates(flexibleOptionSelected)) {
            return void 0;
        }
        return "(".concat(flexibleOptionSelected.primary, ")");
    }, [
        flexibleDateOptions,
        submittedDateOptionValue.current
    ]);
    var DATE_SELECTOR_NAME_PREFIX = "EGDSDateRange-date-selector-trigger";
    var _React20_useState7 = _sliced_to_array(React20.useState((_flexibleDateContent1 = flexibleDateContent) === null || _flexibleDateContent1 === void 0 ? void 0 : _flexibleDateContent1.contentSelector), 2), contentSelector = _React20_useState7[0], setContentSelector = _React20_useState7[1];
    var calendarTabId = ((_contentSelector = contentSelector) === null || _contentSelector === void 0 ? void 0 : _contentSelector.__typename) === "EGDSBasicTabs" ? contentSelector.tabs[0].tabId : "";
    var onContentSelectorSelection = function(tabId) {
        setContentSelector(function(prevState) {
            if (prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    selectedTabId: tabId
                });
            }
            return null;
        });
    };
    var _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend;
    var _React20_useState8 = _sliced_to_array(React20.useState((_flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend = (_flexibleDateContent2 = flexibleDateContent) === null || _flexibleDateContent2 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent = _flexibleDateContent2.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection = _flexibleDateContent_flexibleDatesContent.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection.includeWeekend) !== null && _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend !== void 0 ? _flexibleDateContent_flexibleDatesContent_nightsSelection_includeWeekend : null), 2), includeWeekendCheckbox = _React20_useState8[0], setIncludeWeekendCheckbox = _React20_useState8[1];
    var onIncludeWeekendCheck = function(event) {
        setIncludeWeekendCheckbox(function(prevState) {
            if (prevState != null) {
                return _object_spread_props(_object_spread({}, prevState), {
                    state: event.target.checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ 
                });
            }
            return null;
        });
    };
    var _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map;
    var defaultNightsSelectionPills = (_flexibleDateContent_flexibleDatesContent_nightsSelection_options_map = (_flexibleDateContent3 = flexibleDateContent) === null || _flexibleDateContent3 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent1 = _flexibleDateContent3.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent1 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_nightsSelection1 = _flexibleDateContent_flexibleDatesContent1.nightsSelection) === null || _flexibleDateContent_flexibleDatesContent_nightsSelection1 === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_nightsSelection1.options.map(function(option) {
        var _option_primary, _option_value, _option_name;
        return {
            selected: option.selected,
            checked: false,
            text: (_option_primary = option.primary) !== null && _option_primary !== void 0 ? _option_primary : "",
            disabled: option.disabled,
            value: (_option_value = option.value) !== null && _option_value !== void 0 ? _option_value : "",
            id: (_option_name = option.name) !== null && _option_name !== void 0 ? _option_name : "",
            altText: ""
        };
    })) !== null && _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map !== void 0 ? _flexibleDateContent_flexibleDatesContent_nightsSelection_options_map : [];
    var _React20_useState9 = _sliced_to_array(React20.useState(defaultNightsSelectionPills), 2), nightsSelectionPills = _React20_useState9[0], setNightsSelectionPills = _React20_useState9[1];
    var onNightSelectionPillChange = function(selectedPillValue) {
        setNightsSelectionPills(function(prevState) {
            return prevState.map(function(option) {
                return option.value === selectedPillValue ? _object_spread_props(_object_spread({}, option), {
                    selected: true
                }) : _object_spread_props(_object_spread({}, option), {
                    selected: false
                });
            });
        });
    };
    var _flexibleDateContent_flexibleDatesContent_monthsSelection_options;
    var _React20_useState10 = _sliced_to_array(React20.useState((_flexibleDateContent_flexibleDatesContent_monthsSelection_options = (_flexibleDateContent4 = flexibleDateContent) === null || _flexibleDateContent4 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent2 = _flexibleDateContent4.flexibleDatesContent) === null || _flexibleDateContent_flexibleDatesContent2 === void 0 ? void 0 : (_flexibleDateContent_flexibleDatesContent_monthsSelection = _flexibleDateContent_flexibleDatesContent2.monthsSelection) === null || _flexibleDateContent_flexibleDatesContent_monthsSelection === void 0 ? void 0 : _flexibleDateContent_flexibleDatesContent_monthsSelection.options) !== null && _flexibleDateContent_flexibleDatesContent_monthsSelection_options !== void 0 ? _flexibleDateContent_flexibleDatesContent_monthsSelection_options : null), 2), monthsSelectionToggleButtons = _React20_useState10[0], setMonthsSelectionToggleButtons = _React20_useState10[1];
    var onMonthSelectionToggle = function(selectedButton) {
        setMonthsSelectionToggleButtons(function(prevState) {
            if (prevState) {
                var options = prevState.options.map(function(option) {
                    if (option.name === selectedButton.target.name) {
                        return _object_spread_props(_object_spread({}, option), {
                            selected: !option.selected
                        });
                    }
                    return option;
                });
                return _object_spread_props(_object_spread({}, prevState), {
                    options: options
                });
            }
            return null;
        });
    };
    var calendarWrapperProps = {
        data: flexibleDateContent,
        onNightSelectionPillChange: onNightSelectionPillChange,
        nightsSelectionPills: nightsSelectionPills,
        includeWeekendCheckbox: includeWeekendCheckbox,
        onIncludeWeekendCheck: onIncludeWeekendCheck,
        onMonthSelectionToggle: onMonthSelectionToggle,
        monthsSelectionToggleButtons: monthsSelectionToggleButtons,
        onContentSelectorSelection: onContentSelectorSelection,
        contentSelector: contentSelector
    };
    var calendarWrapper = ((_flexibleDateContent5 = flexibleDateContent) === null || _flexibleDateContent5 === void 0 ? void 0 : _flexibleDateContent5.contentSelector) && ((_flexibleContentConfig = flexibleContentConfig) === null || _flexibleContentConfig === void 0 ? void 0 : _flexibleContentConfig.includeFlexibleDatesContent) ? {
        component: EGDSDatePickerFlexibilityContent,
        props: calendarWrapperProps
    } : void 0;
    var alertTemplateComponent = ((_flexibleContentConfig1 = flexibleContentConfig) === null || _flexibleContentConfig1 === void 0 ? void 0 : _flexibleContentConfig1.includeFlexibleCalendarContent) && ((_flexibleDateContent6 = flexibleDateContent) === null || _flexibleDateContent6 === void 0 ? void 0 : _flexibleDateContent6.calendarContent) ? EGDSDatePickerFlexibilityCalendarContent : void 0;
    var hasFlexibleDates = !!calendarWrapper;
    var alertTemplateDataClassName = ((_contentSelector1 = contentSelector) === null || _contentSelector1 === void 0 ? void 0 : _contentSelector1.__typename) === "EGDSBasicTabs" && ((_contentSelector2 = contentSelector) === null || _contentSelector2 === void 0 ? void 0 : _contentSelector2.selectedTabId) === calendarTabId ? "" : "is-visually-hidden is-hidden";
    var dateSelectorProps = {
        inputName1: DATE_SELECTOR_NAME_PREFIX,
        autoCloseOnSelection: false,
        allowClearDates: allowClearDates !== null && allowClearDates !== void 0 ? allowClearDates : false,
        clearButtonLabel: clearButtonText,
        dateFormatOptions: {
            month: "short",
            day: "numeric"
        },
        dayNameLength: "narrow",
        endDate: checkOutDateString,
        enableSameDayDateRange: enableSameDayDateRange,
        inputLabel1: startButtonLabel,
        inputLabel2: endStartButtonLabel,
        locale: locale,
        maxDate: addMaxDateToToday(daysBookableInAdvance),
        minDate: validDaysLowerBoundInclusive ? convertToDateObject(validDaysLowerBoundInclusive) : void 0,
        onDateRangeChange: onDateRangeChange,
        onDateRangeClear: onDateRangeClear,
        onClose: onCloseCB,
        onSubmit: onSubmitCB,
        onOpen: onOpenCB,
        invalidInput1: startDateErrorMessage,
        startDate: checkInDateString,
        submitButtonLabel: dynamicButtonText,
        useSingleTrigger: true,
        initialOpenState: initialOpenState,
        startDateRef: startDateRef,
        onNextClicked: onNextCalendarClick,
        onPrevClicked: onPreviousCalendarClick,
        handleShape: "circle",
        alertTemplateComponent: alertTemplateComponent,
        alertTemplateData: {
            data: (_flexibleDateContent7 = flexibleDateContent) === null || _flexibleDateContent7 === void 0 ? void 0 : _flexibleDateContent7.calendarContent,
            onSelect: handleFlexibleContentOptionSelection,
            currentlySelectedPillValue: currentDateOptionValue,
            className: hasFlexibleDates ? alertTemplateDataClassName : ""
        },
        calendarWrapper: calendarWrapper,
        trailingText1: flexibleOptionTrailingText,
        dialogId: dialogId
    };
    return /* @__PURE__ */ React20.createElement(React20.Fragment, null, /* @__PURE__ */ React20.createElement(UitkDateSelector, _object_spread({}, dateSelectorProps)), flexibleDateContent !== null && /* @__PURE__ */ React20.createElement("input", {
        type: "hidden",
        "data-stid": FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX,
        name: "".concat(FLEXIBILITY_CALENDAR_CONTENT_NAME_PREFIX, "-").concat((_flexibleDateContent_calendarContent1 = flexibleDateContent.calendarContent) === null || _flexibleDateContent_calendarContent1 === void 0 ? void 0 : _flexibleDateContent_calendarContent1.formElementId),
        value: submittedDateOptionValue.current
    }));
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-date-range-picker.tsx
import React21 from "react";
import { useDialog } from "@shared-ui/dialog-context";
import { useLocalization as useLocalization2 } from "@shared-ui/localization-context";
import { UitkDatePicker } from "uitk-react-date-picker";
import { useFormCallback as useFormCallback4 } from "uitk-react-form";
var DISPLAY_NAME6 = "EGDSDateRangePicker";
var START_DATE_NAME_PREFIX = "".concat(DISPLAY_NAME6, "-StartDate");
var END_DATE_NAME_PREFIX = "".concat(DISPLAY_NAME6, "-EndDate");
var DATE_FORMAT = "yyyy-MM-dd";
var DateRangePicker = function(props) {
    var _buttonTextTemplate, _nextButtonAnalytics, _nextButtonAnalytics1, _previousButtonAnalytics, _previousButtonAnalytics1;
    var __typename = props.__typename, buttonText = props.buttonText, buttonTextTemplate = props.buttonTextTemplate, clearButtonText = props.clearButtonText, firstDayOfWeek = props.firstDayOfWeek, selectedEndDate = props.selectedEndDate, endDatePlaceholderText = props.endDatePlaceholderText, selectedStartDate = props.selectedStartDate, startDatePlaceholderText = props.startDatePlaceholderText, validDaysLowerBoundInclusive = props.validDaysLowerBoundInclusive, validDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive, sameDaySelectionAllowed = props.sameDaySelectionAllowed, showClearDatesButton = props.showClearDatesButton, nextButtonAnalytics = props.nextButtonAnalytics, previousButtonAnalytics = props.previousButtonAnalytics, egdsElementId = props.egdsElementId, label = props.label, setFieldRefByTypename = props.setFieldRefByTypename, errorMessage = props.errorMessage, autoOpen = props.autoOpen, skipQuery = props.skipQuery, showCalendar = props.showCalendar, toggleCalendar = props.toggleCalendar, onClearDates = props.onClearDates, onSelectEndDate = props.onSelectEndDate, onSelectStartDate = props.onSelectStartDate, onChangeStartDate = props.onChangeStartDate, onChangeEndDate = props.onChangeEndDate, onSubmit = props.onSubmit, onOpen = props.onOpen, onNextCalendarClick = props.onNextCalendarClick, onPreviousCalendarClick = props.onPreviousCalendarClick, startDateString = props.startDateString, endDateString = props.endDateString;
    var formatDateString = useLocalization2().formatDateString;
    var datePickerRef = React21.useRef(null);
    var _useDialog = _sliced_to_array(useDialog("search_form_date_picker_dialog"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogWrapper = _useDialog[2];
    var closeDialog = dialogActions.closeDialog, openDialog = dialogActions.openDialog;
    var externalStateControl = showCalendar !== void 0 && !!toggleCalendar;
    var _React21_useState = _sliced_to_array(React21.useState(externalStateControl ? showCalendar : autoOpen !== null && autoOpen !== void 0 ? autoOpen : false), 2), showCalendarLocal = _React21_useState[0], toggleCalendarLocal = _React21_useState[1];
    var didSkipDialogStatusCheckOnMount = React21.useRef(false);
    var _React21_useState1 = _sliced_to_array(React21.useState(autoOpen), 2), isAutoOpened = _React21_useState1[0], setAutoOpened = _React21_useState1[1];
    var setShowDatePicker = React21.useCallback(function(shouldOpen) {
        if (externalStateControl) {
            toggleCalendar(shouldOpen);
        } else {
            toggleCalendarLocal(shouldOpen);
        }
    }, [
        toggleCalendar,
        toggleCalendarLocal,
        externalStateControl
    ]);
    React21.useEffect(function() {
        if (externalStateControl && showCalendar !== showCalendarLocal) {
            toggleCalendarLocal(showCalendar);
        }
    }, [
        showCalendar
    ]);
    var calendarHandlerOnScroll = React21.useCallback(function() {
        var _datePickerRef_current, _datePickerRef;
        var distanceToTopOfViewportToClose = 20;
        var _datePickerRef_current_getBoundingClientRect_top;
        if (isAutoOpened && ((_datePickerRef_current_getBoundingClientRect_top = (_datePickerRef = datePickerRef) === null || _datePickerRef === void 0 ? void 0 : (_datePickerRef_current = _datePickerRef.current) === null || _datePickerRef_current === void 0 ? void 0 : _datePickerRef_current.getBoundingClientRect().top) !== null && _datePickerRef_current_getBoundingClientRect_top !== void 0 ? _datePickerRef_current_getBoundingClientRect_top : distanceToTopOfViewportToClose) <= distanceToTopOfViewportToClose) {
            setAutoOpened(false);
            setShowDatePicker(false);
        }
    }, [
        isAutoOpened,
        setShowDatePicker,
        setAutoOpened
    ]);
    React21.useEffect(function() {
        if (isAutoOpened) {
            window.addEventListener("scroll", calendarHandlerOnScroll);
            return function() {
                return window.removeEventListener("scroll", calendarHandlerOnScroll);
            };
        }
    }, [
        isAutoOpened,
        calendarHandlerOnScroll
    ]);
    React21.useEffect(function() {
        if (didSkipDialogStatusCheckOnMount.current) {
            if (externalStateControl && !isDialogOpen && showCalendar !== isDialogOpen) {
                toggleCalendar(isDialogOpen);
            }
        } else {
            didSkipDialogStatusCheckOnMount.current = true;
        }
    }, [
        isDialogOpen
    ]);
    var _React21_useState2 = _sliced_to_array(React21.useState({
        startDate: formatDateString(selectedStartDate ? convertToDateObject(selectedStartDate) : "", {
            raw: DATE_FORMAT
        }),
        endDate: formatDateString(selectedEndDate ? convertToDateObject(selectedEndDate) : "", {
            raw: DATE_FORMAT
        }),
        shouldFireChangeEvent: false
    }), 2), dateState = _React21_useState2[0], setDateState = _React21_useState2[1];
    var _React21_useState3 = _sliced_to_array(React21.useState(formatDateString(/* @__PURE__ */ new Date(), {
        raw: DATE_FORMAT
    })), 2), validStartDate = _React21_useState3[0], setValidStartDate = _React21_useState3[1];
    var defaultDaysBookableInAdvance = 500;
    var _React21_useState4 = _sliced_to_array(React21.useState(defaultDaysBookableInAdvance), 2), daysBookableInAdvance = _React21_useState4[0], setDaysBookableInAdvance = _React21_useState4[1];
    var handleSubmit = useFormCallback4(__typename, function(event) {
        return event;
    });
    var startDate2 = dateState.startDate, endDate2 = dateState.endDate, shouldFireChangeEvent = dateState.shouldFireChangeEvent;
    var _React21_useState5 = _sliced_to_array(React21.useState(((_buttonTextTemplate = buttonTextTemplate) === null || _buttonTextTemplate === void 0 ? void 0 : _buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText" ? buttonTextTemplate.text : buttonText), 2), dynamicButtonText = _React21_useState5[0], setDynamicButtonText = _React21_useState5[1];
    var _React21_useState6 = _sliced_to_array(React21.useState(true), 2), isFirstDateSelection = _React21_useState6[0], setIsFirstDateSelection = _React21_useState6[1];
    React21.useEffect(function() {
        var dateFormatOptions = {
            raw: DATE_FORMAT
        };
        if (startDateString) {
            setDateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    startDate: startDateString
                });
            });
        } else if (!startDateString && selectedStartDate && !skipQuery) {
            setDateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    startDate: formatDateString(selectedStartDate ? convertToDateObject(selectedStartDate) : "", dateFormatOptions)
                });
            });
        }
        if (endDateString) {
            setDateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    endDate: endDateString
                });
            });
        } else if (selectedEndDate && !skipQuery) {
            setDateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    endDate: formatDateString(selectedEndDate ? convertToDateObject(selectedEndDate) : "", dateFormatOptions)
                });
            });
        }
        if (!selectedStartDate && !selectedEndDate && !skipQuery) {
            setDateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    endDate: "",
                    startDate: ""
                });
            });
        }
        if (validDaysLowerBoundInclusive) {
            setValidStartDate(formatDateString(convertToDateObject(validDaysLowerBoundInclusive), dateFormatOptions));
        }
        if (validDaysUpperBoundInclusive) {
            var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */ new Date().getTime();
            setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
        }
    }, [
        formatDateString,
        selectedEndDate,
        selectedStartDate,
        validDaysLowerBoundInclusive,
        validDaysUpperBoundInclusive,
        skipQuery,
        startDateString,
        endDateString
    ]);
    React21.useEffect(function() {
        if (shouldFireChangeEvent) {
            setDateState(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    shouldFireChangeEvent: false
                });
            });
            triggerInputChangeEvent("".concat(startDate2, " - ").concat(endDate2), handleSubmit);
        }
    }, [
        dateState
    ]);
    var onOpenCB = function(_, isSmallViewportSize) {
        onOpen();
        setShowDatePicker(true);
        if (isSmallViewportSize) {
            openDialog();
        }
    };
    var onChangeStartDateCB = function(currentStartDate) {
        var _buttonTextTemplate;
        if (((_buttonTextTemplate = buttonTextTemplate) === null || _buttonTextTemplate === void 0 ? void 0 : _buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText") {
            var formateCurrentStartDate = formatDateString(currentStartDate, {
                raw: DATE_FORMAT
            });
            setDateState({
                startDate: formateCurrentStartDate,
                endDate: "",
                shouldFireChangeEvent: false
            });
            if (isFirstDateSelection) {
                setDynamicButtonText(buttonTextTemplate.text);
                setIsFirstDateSelection(false);
            } else {
                setDynamicButtonText(formatCardinalText(buttonTextTemplate, 1));
            }
        }
    };
    var onChangeEndDateCB = function(currentEndDate) {
        var _buttonTextTemplate;
        if (((_buttonTextTemplate = buttonTextTemplate) === null || _buttonTextTemplate === void 0 ? void 0 : _buttonTextTemplate.__typename) === "EGDSCardinalLocalizedText") {
            var startDateInMiliSeconds = Number(new Date(dateState.startDate));
            var formateCurrentEndDate = formatDateString(currentEndDate, {
                raw: DATE_FORMAT
            });
            var endDateInMiliSeconds = Number(new Date(formateCurrentEndDate));
            var durationOfDays = convertFromMiliSecondsToDays(endDateInMiliSeconds - startDateInMiliSeconds);
            setDynamicButtonText(formatCardinalText(buttonTextTemplate, durationOfDays));
        }
    };
    var onSubmitCB = function(start, end, isSmallViewportSize) {
        onSubmit();
        if (isSmallViewportSize) {
            closeDialog();
        }
        setShowDatePicker(false);
        if (!start && !end) {
            if (startDate2 && endDate2) {
                onChangeStartDate("");
                onChangeEndDate("");
                setDateState({
                    startDate: "",
                    endDate: "",
                    shouldFireChangeEvent: true
                });
            }
            return;
        }
        var newEndDate = end || new Date(start.getFullYear(), start.getMonth(), start.getDate() + 1);
        var startDateStr = formatDateString(start, {
            raw: DATE_FORMAT
        });
        var endDateStr = formatDateString(newEndDate, {
            raw: DATE_FORMAT
        });
        if (startDateStr !== startDate2 || endDateStr !== endDate2) {
            onChangeStartDate(startDateStr);
            onChangeEndDate(endDateStr);
            setDateState({
                startDate: startDateStr,
                endDate: endDateStr,
                shouldFireChangeEvent: true
            });
        }
    };
    var onDismissCB = function(isSmallViewportSize, noUpdate) {
        if (isSmallViewportSize) {
            closeDialog();
        }
        if (!noUpdate) {
            setShowDatePicker(false);
        }
    };
    var handleMountCB = function(ref) {
        return setFieldRefByTypename("EGDSSearchFormDatePickerField", ref);
    };
    var datePickerAnalytics = {
        nextPageAnalytics: {
            callback: function() {
                return onNextCalendarClick();
            },
            description: (_nextButtonAnalytics = nextButtonAnalytics) === null || _nextButtonAnalytics === void 0 ? void 0 : _nextButtonAnalytics.linkName,
            id: (_nextButtonAnalytics1 = nextButtonAnalytics) === null || _nextButtonAnalytics1 === void 0 ? void 0 : _nextButtonAnalytics1.referrerId
        },
        previousPageAnalytics: {
            callback: function() {
                return onPreviousCalendarClick();
            },
            description: (_previousButtonAnalytics = previousButtonAnalytics) === null || _previousButtonAnalytics === void 0 ? void 0 : _previousButtonAnalytics.linkName,
            id: (_previousButtonAnalytics1 = previousButtonAnalytics) === null || _previousButtonAnalytics1 === void 0 ? void 0 : _previousButtonAnalytics1.referrerId
        }
    };
    var dateFieldProps = {
        startName: egdsElementId,
        startLabel: label,
        endLabel: label,
        startId: egdsElementId,
        startPlaceholder: startDatePlaceholderText,
        endPlaceholder: endDatePlaceholderText,
        routerLinkWrapper: routerLinkWrapper,
        showDatePicker: showCalendarLocal,
        startInvalid: errorMessage,
        mediumDateFormatProp: "MMMd",
        onChange: function() {}
    };
    var datePickerProps = {
        analytics: datePickerAnalytics,
        buttonText: dynamicButtonText,
        dateFieldProps: dateFieldProps,
        daysBookableInAdvance: daysBookableInAdvance,
        dialogWrapper: dialogWrapper(DialogWrapper),
        doubleMonths: true,
        firstDayOfWeek: EGDSDayNameMap[firstDayOfWeek],
        onDismissCB: onDismissCB,
        onOpenCB: onOpenCB,
        onSubmitCB: onSubmitCB,
        onSelectStartModeCB: onSelectStartDate,
        onSelectEndModeCB: onSelectEndDate,
        onChangeStartDateCB: onChangeStartDateCB,
        onChangeEndDateCB: onChangeEndDateCB,
        onClearDatesCB: onClearDates,
        startDate: startDate2,
        endDate: endDate2,
        validStartDate: validStartDate,
        useSingleTrigger: true,
        onMountCB: handleMountCB,
        singleDateSelect: sameDaySelectionAllowed,
        useClearDates: showClearDatesButton !== null && showClearDatesButton !== void 0 ? showClearDatesButton : false,
        clearButtonText: clearButtonText !== null && clearButtonText !== void 0 ? clearButtonText : void 0,
        startDateRef: datePickerRef
    };
    return /* @__PURE__ */ React21.createElement(UitkDatePicker, _object_spread({}, datePickerProps));
};
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-date-range.tsx
var __Fragment18 = gql19(_templateObject18(), EGDSDatePickerFlexibilityContent.fragment);
var DISPLAY_NAME7 = "EGDSDateRangePicker";
var START_DATE_NAME_PREFIX2 = "".concat(DISPLAY_NAME7, "-StartDate");
var END_DATE_NAME_PREFIX2 = "".concat(DISPLAY_NAME7, "-EndDate");
var DATE_FORMAT2 = "yyyy-MM-dd";
var EGDSDateRangePicker = function(props) {
    var clickTracker = useClickTracker8();
    var data = props.data, useDateSelector = props.useDateSelector, analytics = props.analytics, autoOpen = props.autoOpen, egdsElementId = props.egdsElementId, label = props.label, errorMessage = props.errorMessage, setFieldRefByTypename = props.setFieldRefByTypename, flexibleContentConfig = props.flexibleContentConfig, dialogId = props.dialogId, overrideValidDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive, skipReflection = props.skipReflection;
    var __typename = data.__typename, selectedStartDate = data.selectedStartDate, selectedEndDate = data.selectedEndDate, validDaysLowerBoundInclusive = data.validDaysLowerBoundInclusive, validDaysUpperBoundInclusive = data.validDaysUpperBoundInclusive, sameDaySelectionAllowed = data.sameDaySelectionAllowed, buttonText = data.buttonText, clearButtonText = data.clearButtonText, showClearDatesButton = data.showClearDatesButton, startDatePlaceholderText = data.startDatePlaceholderText, endDatePlaceholderText = data.endDatePlaceholderText, clearDatesButtonAnalytics = data.clearDatesButtonAnalytics, endDateButtonAnalytics = data.endDateButtonAnalytics, startDateButtonAnalytics = data.startDateButtonAnalytics, submitButtonAnalytics = data.submitButtonAnalytics, nextButtonAnalytics = data.nextButtonAnalytics, previousButtonAnalytics = data.previousButtonAnalytics, buttonTextTemplate = data.buttonTextTemplate, flexibleDateContent = data.flexibleDateContent;
    var _useSearchFormReflectionContext = useSearchFormReflectionContext(), state = _useSearchFormReflectionContext.state, dispatchReflectionAction = _useSearchFormReflectionContext.dispatch;
    var _state_dates;
    var _ref = (_state_dates = state.dates) !== null && _state_dates !== void 0 ? _state_dates : {}, reflectionStartDate = _ref.start, reflectionEndDate = _ref.end;
    var formatDateString = useLocalization3().formatDateString;
    var defaultStartDate = selectedStartDate ? formatDateString(convertToDateObject(selectedStartDate), {
        raw: DATE_FORMAT2
    }) : "";
    var defaultEndDate = selectedEndDate ? formatDateString(convertToDateObject(selectedEndDate), {
        raw: DATE_FORMAT2
    }) : "";
    var _React22_useState = _sliced_to_array(React22.useState({
        startDate: defaultStartDate,
        endDate: defaultEndDate
    }), 2), dateState = _React22_useState[0], setDateState = _React22_useState[1];
    var trackAction = function(action) {
        var _action, _action1;
        var _action_referrerId;
        var referrerId = (_action_referrerId = (_action = action) === null || _action === void 0 ? void 0 : _action.referrerId) !== null && _action_referrerId !== void 0 ? _action_referrerId : "";
        var _action_linkName;
        var linkName = (_action_linkName = (_action1 = action) === null || _action1 === void 0 ? void 0 : _action1.linkName) !== null && _action_linkName !== void 0 ? _action_linkName : "";
        if (referrerId && linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    var onClearDates = function() {
        return trackAction(clearDatesButtonAnalytics);
    };
    var onSelectEndDate = function() {
        return trackAction(endDateButtonAnalytics);
    };
    var onSelectStartDate = function() {
        return trackAction(startDateButtonAnalytics);
    };
    var onChangeStartDate = function(startDate2) {
        setDateState(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), {
                startDate: startDate2 !== null && startDate2 !== void 0 ? startDate2 : prevState.startDate
            });
        });
    };
    var onChangeEndDate = function(endDate2) {
        setDateState(function(prevState) {
            if (!skipReflection) {
                dispatchReflectionAction({
                    type: "UPDATE_DATES",
                    end: endDate2,
                    start: prevState.startDate
                });
            }
            return _object_spread_props(_object_spread({}, prevState), {
                endDate: endDate2 !== null && endDate2 !== void 0 ? endDate2 : prevState.endDate
            });
        });
    };
    var onSubmit = function() {
        return trackAction(submitButtonAnalytics);
    };
    var onOpen = function() {
        return trackAction(analytics);
    };
    var onNextCalendarClick = function() {
        return trackAction(nextButtonAnalytics);
    };
    var onPreviousCalendarClick = function() {
        return trackAction(previousButtonAnalytics);
    };
    var sharedDateRangeProps = _object_spread({
        onClearDates: onClearDates,
        onSelectEndDate: onSelectEndDate,
        onSelectStartDate: onSelectStartDate,
        onSubmit: onSubmit,
        onOpen: onOpen,
        onChangeStartDate: onChangeStartDate,
        onChangeEndDate: onChangeEndDate,
        onNextCalendarClick: onNextCalendarClick,
        onPreviousCalendarClick: onPreviousCalendarClick
    }, !skipReflection ? {
        startDateString: reflectionStartDate,
        endDateString: reflectionEndDate
    } : {});
    var dateRangePickerProps = _object_spread_props(_object_spread({}, props, data, sharedDateRangeProps), {
        validDaysUpperBoundInclusive: overrideValidDaysUpperBoundInclusive !== null && overrideValidDaysUpperBoundInclusive !== void 0 ? overrideValidDaysUpperBoundInclusive : validDaysUpperBoundInclusive
    });
    var dateRangeSelectorProps = _object_spread_props(_object_spread({
        typename: __typename,
        startDate: selectedStartDate,
        endDate: selectedEndDate,
        validDaysLowerBoundInclusive: validDaysLowerBoundInclusive,
        validDaysUpperBoundInclusive: overrideValidDaysUpperBoundInclusive !== null && overrideValidDaysUpperBoundInclusive !== void 0 ? overrideValidDaysUpperBoundInclusive : validDaysUpperBoundInclusive,
        enableSameDayDateRange: sameDaySelectionAllowed,
        buttonText: buttonText,
        clearButtonText: clearButtonText !== null && clearButtonText !== void 0 ? clearButtonText : "",
        inputLabel1: label !== null && label !== void 0 ? label : startDatePlaceholderText,
        inputLabel2: label !== null && label !== void 0 ? label : endDatePlaceholderText,
        allowClearDates: showClearDatesButton !== null && showClearDatesButton !== void 0 ? showClearDatesButton : false,
        autoOpen: autoOpen,
        errorMessage: errorMessage,
        setFieldRefByTypename: setFieldRefByTypename,
        buttonTextTemplate: buttonTextTemplate
    }, sharedDateRangeProps), {
        flexibleDateContent: flexibleDateContent,
        flexibleContentConfig: flexibleContentConfig,
        dialogId: dialogId
    });
    React22.useEffect(function() {
        if (!skipReflection) {
            setDateState(function(prevState) {
                return _object_spread({}, prevState, reflectionStartDate ? {
                    startDate: reflectionStartDate
                } : {}, reflectionEndDate ? {
                    endDate: reflectionEndDate
                } : {});
            });
        }
    }, [
        setDateState,
        reflectionStartDate,
        reflectionEndDate,
        skipReflection
    ]);
    var _dateState_startDate, _dateState_endDate;
    return /* @__PURE__ */ React22.createElement(React22.Fragment, null, useDateSelector ? /* @__PURE__ */ React22.createElement(DateRangeSelector, _object_spread({}, dateRangeSelectorProps)) : /* @__PURE__ */ React22.createElement(DateRangePicker, _object_spread({}, dateRangePickerProps)), /* @__PURE__ */ React22.createElement("input", {
        type: "hidden",
        "data-stid": START_DATE_NAME_PREFIX2,
        name: "".concat(START_DATE_NAME_PREFIX2, "-").concat(egdsElementId),
        value: (_dateState_startDate = dateState.startDate) !== null && _dateState_startDate !== void 0 ? _dateState_startDate : ""
    }), /* @__PURE__ */ React22.createElement("input", {
        type: "hidden",
        "data-stid": END_DATE_NAME_PREFIX2,
        name: "".concat(END_DATE_NAME_PREFIX2, "-").concat(egdsElementId),
        value: (_dateState_endDate = dateState.endDate) !== null && _dateState_endDate !== void 0 ? _dateState_endDate : ""
    }));
};
EGDSDateRangePicker.displayName = DISPLAY_NAME7;
EGDSDateRangePicker.fragment = __Fragment18;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-single-date-picker.tsx
import React23 from "react";
import { gql as gql20 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker9 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
import { useLocalization as useLocalization4 } from "@shared-ui/localization-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext2 } from "@shared-ui/retail-search-tools-reflection-provider";
import { UitkDatePicker as UitkDatePicker2 } from "uitk-react-date-picker";
import { UitkDateSelector as UitkDateSelector2 } from "uitk-react-date-selector";
import { useFormCallback as useFormCallback5 } from "uitk-react-form";
var DISPLAY_NAME8 = "EGDSSingleDatePicker";
var DATE_NAME_PREFIX = "".concat(DISPLAY_NAME8, "-Date");
var DATE_FORMAT3 = "yyyy-MM-dd";
var __Fragment19 = gql20(_templateObject19());
var EGDSSingleDatePicker = function(param) {
    var analytics = param.analytics, data = param.data, egdsElementId = param.egdsElementId, label = param.label, placeholder = param.placeholder, setFieldRefByTypename = param.setFieldRefByTypename, errorMessage = param.errorMessage, index = param.index, showCalendar = param.showCalendar, toggleCalendar = param.toggleCalendar, autoOpen = param.autoOpen, dialogId = param.dialogId, useDateSelector = param.useDateSelector, skipReflection = param.skipReflection;
    var clickTracker = useClickTracker9();
    var __typename = data.__typename, buttonText = data.buttonText, selectedStartDate = data.selectedStartDate, validDaysLowerBoundInclusive = data.validDaysLowerBoundInclusive, validDaysUpperBoundInclusive = data.validDaysUpperBoundInclusive, firstDayOfWeek = data.firstDayOfWeek, startDateButtonAnalytics = data.startDateButtonAnalytics, submitButtonAnalytics = data.submitButtonAnalytics;
    var _useSearchFormReflectionContext2 = useSearchFormReflectionContext2(), state = _useSearchFormReflectionContext2.state, dispatchReflectionAction = _useSearchFormReflectionContext2.dispatch;
    var _state_dates;
    var _ref = (_state_dates = state.dates) !== null && _state_dates !== void 0 ? _state_dates : {}, reflectionStartDate = _ref.start, reflectionEndDate = _ref.end;
    var formatDateString = useLocalization4().formatDateString;
    var _useDialog2 = _sliced_to_array(useDialog2("search_form_date_picker_dialog"), 3), isDialogOpen = _useDialog2[0], dialogActions = _useDialog2[1], DialogWrapper = _useDialog2[2];
    var closeDialog = dialogActions.closeDialog, openDialog = dialogActions.openDialog;
    var _React23_useState = _sliced_to_array(React23.useState(autoOpen !== null && autoOpen !== void 0 ? autoOpen : false), 1), isDateSelectorOpen = _React23_useState[0];
    var today2 = /* @__PURE__ */ new Date();
    var tomorrow = /* @__PURE__ */ new Date();
    tomorrow.setDate(today2.getDate() + 1);
    var externalStateControl = showCalendar !== void 0 && !!toggleCalendar;
    var _React23_useState1 = _sliced_to_array(React23.useState(externalStateControl ? showCalendar : false), 2), showCalendarLocal = _React23_useState1[0], toggleCalendarLocal = _React23_useState1[1];
    var didSkipDialogStatusCheckOnMount = React23.useRef(false);
    var setShowDatePicker = React23.useCallback(function(shouldOpen) {
        if (externalStateControl) {
            toggleCalendar(shouldOpen);
        } else {
            toggleCalendarLocal(shouldOpen);
        }
    }, [
        toggleCalendar,
        toggleCalendarLocal,
        externalStateControl
    ]);
    React23.useEffect(function() {
        if (externalStateControl && showCalendar !== showCalendarLocal) {
            toggleCalendarLocal(showCalendar);
        }
    }, [
        showCalendar
    ]);
    React23.useEffect(function() {
        if (didSkipDialogStatusCheckOnMount.current) {
            if (externalStateControl && !isDialogOpen && showCalendar !== isDialogOpen) {
                toggleCalendar(isDialogOpen);
            }
        } else {
            didSkipDialogStatusCheckOnMount.current = true;
        }
    }, [
        isDialogOpen
    ]);
    var _React23_useState2 = _sliced_to_array(React23.useState(formatDateString(today2, {
        raw: DATE_FORMAT3
    })), 2), startDate2 = _React23_useState2[0], setStartDate = _React23_useState2[1];
    var _React23_useState3 = _sliced_to_array(React23.useState(formatDateString(today2, {
        raw: DATE_FORMAT3
    })), 2), validStartDate = _React23_useState3[0], setValidStartDate = _React23_useState3[1];
    var defaultDaysBookableInAdvance = 500;
    var _React23_useState4 = _sliced_to_array(React23.useState(defaultDaysBookableInAdvance), 2), daysBookableInAdvance = _React23_useState4[0], setDaysBookableInAdvance = _React23_useState4[1];
    var onStartDateResultSelection = useFormCallback5("".concat(__typename, "-StartDate"), function(event) {
        return event;
    });
    React23.useEffect(function() {
        var dateFormatOptions = {
            raw: DATE_FORMAT3
        };
        if (!skipReflection && reflectionStartDate) {
            setStartDate(reflectionStartDate);
        } else if (selectedStartDate) {
            setStartDate(formatDateString(convertToDateObject(selectedStartDate), dateFormatOptions));
        }
        if (validDaysLowerBoundInclusive) {
            setValidStartDate(formatDateString(convertToDateObject(validDaysLowerBoundInclusive), dateFormatOptions));
        }
        if (validDaysUpperBoundInclusive) {
            var difference = convertToDateObject(validDaysUpperBoundInclusive).getTime() - /* @__PURE__ */ new Date().getTime();
            setDaysBookableInAdvance(convertFromMiliSecondsToDays(difference));
        }
    }, [
        formatDateString,
        selectedStartDate,
        validDaysLowerBoundInclusive,
        validDaysUpperBoundInclusive,
        reflectionStartDate
    ]);
    var onOpenCB = function(_, isSmallViewportSize) {
        var referrerId = analytics.referrerId, linkName = analytics.linkName;
        if (referrerId && linkName) {
            clickTracker(referrerId, linkName);
        }
        setShowDatePicker(true);
        if (isSmallViewportSize) {
            openDialog();
        }
    };
    var onSubmitCB = function(start, _, isSmallViewportSize) {
        var _submitButtonAnalytics, _submitButtonAnalytics1;
        var _submitButtonAnalytics_referrerId;
        var referrerId = (_submitButtonAnalytics_referrerId = (_submitButtonAnalytics = submitButtonAnalytics) === null || _submitButtonAnalytics === void 0 ? void 0 : _submitButtonAnalytics.referrerId) !== null && _submitButtonAnalytics_referrerId !== void 0 ? _submitButtonAnalytics_referrerId : "";
        var _submitButtonAnalytics_linkName;
        var linkName = (_submitButtonAnalytics_linkName = (_submitButtonAnalytics1 = submitButtonAnalytics) === null || _submitButtonAnalytics1 === void 0 ? void 0 : _submitButtonAnalytics1.linkName) !== null && _submitButtonAnalytics_linkName !== void 0 ? _submitButtonAnalytics_linkName : "";
        if (referrerId && linkName) {
            clickTracker(referrerId, linkName);
        }
        if (isSmallViewportSize) {
            closeDialog();
        }
        var newDate = formatDateString(start, {
            raw: DATE_FORMAT3
        });
        setStartDate(newDate);
        if (!skipReflection) {
            dispatchReflectionAction({
                type: "UPDATE_DATES",
                start: newDate,
                end: reflectionEndDate !== null && reflectionEndDate !== void 0 ? reflectionEndDate : ""
            });
        }
        setShowDatePicker(false);
    };
    var onDismissCB = function(isSmallViewportSize, noUpdate) {
        if (isSmallViewportSize) {
            closeDialog();
        }
        if (!noUpdate) {
            setShowDatePicker(false);
        }
    };
    var handleMountCB = function(ref) {
        return setFieldRefByTypename("EGDSSearchFormDatePickerField", ref);
    };
    var onSelectStartModeCB = function() {
        var _startDateButtonAnalytics, _startDateButtonAnalytics1;
        var _startDateButtonAnalytics_referrerId;
        var referrerId = (_startDateButtonAnalytics_referrerId = (_startDateButtonAnalytics = startDateButtonAnalytics) === null || _startDateButtonAnalytics === void 0 ? void 0 : _startDateButtonAnalytics.referrerId) !== null && _startDateButtonAnalytics_referrerId !== void 0 ? _startDateButtonAnalytics_referrerId : "";
        var _startDateButtonAnalytics_linkName;
        var linkName = (_startDateButtonAnalytics_linkName = (_startDateButtonAnalytics1 = startDateButtonAnalytics) === null || _startDateButtonAnalytics1 === void 0 ? void 0 : _startDateButtonAnalytics1.linkName) !== null && _startDateButtonAnalytics_linkName !== void 0 ? _startDateButtonAnalytics_linkName : "";
        if (referrerId && linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    var dateFieldProps = {
        startName: egdsElementId,
        startLabel: label,
        startId: egdsElementId,
        startPlaceholder: placeholder,
        routerLinkWrapper: routerLinkWrapper,
        showDatePicker: showCalendarLocal,
        startInvalid: errorMessage,
        mediumDateFormatProp: "MMMd"
    };
    var datePickerProps = {
        buttonText: buttonText,
        dateFieldProps: dateFieldProps,
        daysBookableInAdvance: daysBookableInAdvance,
        dialogWrapper: dialogWrapper(DialogWrapper),
        doubleMonths: true,
        firstDayOfWeek: EGDSDayNameMap[firstDayOfWeek],
        onDismissCB: onDismissCB,
        onOpenCB: onOpenCB,
        onSubmitCB: onSubmitCB,
        onSelectStartModeCB: onSelectStartModeCB,
        startDate: startDate2,
        validStartDate: validStartDate,
        onMountCB: handleMountCB,
        onStartDateResultSelection: onStartDateResultSelection,
        singleMode: true
    };
    var hiddenInputNameSuffix = "".concat(egdsElementId).concat(Number.isInteger(index) ? "-".concat(index) : "");
    var context = useBexApi2().context;
    var DEFAULT_LOCALE2 = "en-US";
    var TYPENAME_REFERENCE2 = "EGDSSearchFormDatePickerField";
    var formatLocale2 = function(locale2) {
        return locale2.replace("_", "-");
    };
    var locale = context.locale ? formatLocale2(context.locale) : DEFAULT_LOCALE2;
    var startDateRef = React23.useRef(null);
    var selectorDialogId = index ? index.toString() : dialogId;
    var trackAction = function(action) {
        var _action, _action1;
        var _action_referrerId;
        var referrerId = (_action_referrerId = (_action = action) === null || _action === void 0 ? void 0 : _action.referrerId) !== null && _action_referrerId !== void 0 ? _action_referrerId : "";
        var _action_linkName;
        var linkName = (_action_linkName = (_action1 = action) === null || _action1 === void 0 ? void 0 : _action1.linkName) !== null && _action_linkName !== void 0 ? _action_linkName : "";
        if (referrerId && linkName) {
            clickTracker(referrerId, linkName);
        }
    };
    React23.useEffect(function() {
        setFieldRefByTypename(TYPENAME_REFERENCE2, startDateRef);
    }, []);
    var onDateChange = function(newStartDate) {
        setStartDate(newStartDate);
        trackAction(startDateButtonAnalytics);
    };
    var onOpen = function() {
        return trackAction(analytics);
    };
    var onClose = function() {
        closeDialog();
        trackAction(submitButtonAnalytics);
    };
    var dateSelectorProps = {
        isSingleDateSelection: true,
        startDate: startDate2,
        submitButtonLabel: buttonText,
        inputLabel1: label !== null && label !== void 0 ? label : void 0,
        maxDate: addMaxDateToToday(defaultDaysBookableInAdvance),
        autoCloseOnSelection: false,
        allowClearDates: false,
        dateFormatOptions: {
            month: "short",
            day: "numeric"
        },
        dayNameLength: "narrow",
        initialOpenState: isDateSelectorOpen,
        locale: locale,
        handleShape: "circle",
        invalidInput1: errorMessage,
        dialogId: selectorDialogId,
        startDateRef: startDateRef,
        onDateRangeChange: onDateChange,
        onOpen: onOpen,
        onClose: onClose,
        endDate: null
    };
    return /* @__PURE__ */ React23.createElement(React23.Fragment, null, useDateSelector ? /* @__PURE__ */ React23.createElement(UitkDateSelector2, _object_spread({}, dateSelectorProps)) : /* @__PURE__ */ React23.createElement(UitkDatePicker2, _object_spread({}, datePickerProps)), /* @__PURE__ */ React23.createElement("input", {
        type: "hidden",
        "data-stid": DATE_NAME_PREFIX,
        name: "".concat(DATE_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: startDate2
    }));
};
EGDSSingleDatePicker.displayName = DISPLAY_NAME8;
EGDSSingleDatePicker.fragment = __Fragment19;
// ../internal/src/components/form/egds-search-form-date-picker-field/egds-search-form-date-picker-field.tsx
var __Fragment20 = gql21(_templateObject20(), EGDSDateRangePicker.fragment, EGDSSingleDatePicker.fragment);
var EGDSSearchFormDatePickerField = function(props) {
    var _action;
    var setFieldRefByTypename = props.setFieldRefByTypename, fieldError = props.fieldError, data = props.data, dialogId = props.dialogId, validDaysUpperBoundInclusive = props.validDaysUpperBoundInclusive;
    var action = data.action, errorMessage = data.errorMessage, validations = data.validations;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "EGDSOpenDatePickerAction") {
        return null;
    }
    var getErrorMessage = function(element) {
        var _datePickerValidations, _datePickerValidations1;
        var datePickerValidations = element.validations;
        if (((_datePickerValidations = datePickerValidations) === null || _datePickerValidations === void 0 ? void 0 : _datePickerValidations.sameDate) || datePickerValidations.endDateBeforeStartDate) {
            return errorMessage !== null && errorMessage !== void 0 ? errorMessage : "";
        }
        if (((_datePickerValidations1 = datePickerValidations) === null || _datePickerValidations1 === void 0 ? void 0 : _datePickerValidations1.maxDate) && validations && validations[0].__typename === "EGDSMaxLengthInputValidation") {
            var _validations__errorMessage;
            return (_validations__errorMessage = validations[0].errorMessage) !== null && _validations__errorMessage !== void 0 ? _validations__errorMessage : "";
        }
        return "";
    };
    var errorText = fieldError ? getErrorMessage(fieldError) : "";
    var datePickerProps = _object_spread_props(_object_spread({}, props), {
        analytics: action.analytics,
        setFieldRefByTypename: setFieldRefByTypename,
        errorMessage: errorText,
        dialogId: dialogId
    });
    switch(action.datePicker.__typename){
        case "EGDSDateRangePicker":
            return /* @__PURE__ */ React24.createElement(EGDSDateRangePicker, _object_spread_props(_object_spread({}, data, datePickerProps), {
                data: action.datePicker,
                validDaysUpperBoundInclusive: validDaysUpperBoundInclusive
            }));
        case "EGDSSingleDatePicker":
            {
                return /* @__PURE__ */ React24.createElement(EGDSSingleDatePicker, _object_spread_props(_object_spread({}, data, datePickerProps), {
                    data: action.datePicker
                }));
            }
        default:
            return null;
    }
};
EGDSSearchFormDatePickerField.displayName = "EGDSSearchFormDatePickerField";
EGDSSearchFormDatePickerField.fragment = __Fragment20;
// ../internal/src/components/form/egds-search-form-location-field/egds-search-form-location-field.tsx
import React27 from "react";
import { gql as gql22 } from "@apollo/client";
import { useBexApi as useBexApi3 } from "@shared-ui/bex-api-context";
import { useFormCallback as useFormCallback6 } from "uitk-react-form";
import { ESSAdapter } from "uitk-react-typeahead";
// ../internal/src/components/form/egds-search-form-location-field/location-field.tsx
import React25 from "react";
import { useClickTracker as useClickTracker10 } from "@shared-ui/clickstream-analytics-context";
import { useSearchFormReflectionContext as useSearchFormReflectionContext3 } from "@shared-ui/retail-search-tools-reflection-provider";
import { TypeaheadLocationType, UitkTypeahead } from "uitk-react-typeahead";
var DISPLAY_NAME9 = "EGDSSearchFormLocationField";
var LOCATION_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-Location");
var REGION_ID_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-RegionId");
var AIRPORT_CODE_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-AirportCode");
var LAT_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-Lat");
var LONG_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-Long");
var SELECTED_PREFIX = "".concat(DISPLAY_NAME9, "-Selected");
var AMENITIES_GROUP_PREFIX = "".concat(DISPLAY_NAME9, "-AmenitiesFacilitiesGroup");
var LOCATION_GROUP_PREFIX = "".concat(DISPLAY_NAME9, "-LocGroup");
var PROPERTIES_GOOD_FOR_GROUP_PREFIX = "".concat(DISPLAY_NAME9, "-PropertiesGoodForGroup");
var PROPERTY_TYPE_GROUP_PREFIX = "".concat(DISPLAY_NAME9, "-PropertyTypeGroup");
var DESTINATION_ID_NAME_PREFIX = "".concat(DISPLAY_NAME9, "-DestinationId");
var LocationField = function(props) {
    var _currentSelection_data_regionNames, _currentSelection_data, _propertyRefinements, _propertyRefinements1, _propertyRefinements2, _propertyRefinements3, _propertyRefinements4, _propertyRefinements5, _propertyRefinements6, _propertyRefinements7;
    var egdsElementId = props.egdsElementId, essAdapter = props.essAdapter, label = props.label, placeholder = props.placeholder, icon = props.icon, value = props.value, accessibility = props.accessibility, errorText = props.errorText, required = props.required, emptyResultsPlaceholder = props.emptyResultsPlaceholder, setFieldRefByTypename = props.setFieldRefByTypename, __typename = props.__typename, analyticsLinkName = props.analyticsLinkName, analyticsReferrerId = props.analyticsReferrerId, closeAnalyticsLinkName = props.closeAnalyticsLinkName, changeAnalyticsLinkName = props.changeAnalyticsLinkName, changeAnalyticsReferrerId = props.changeAnalyticsReferrerId, closeAnalyticsReferrerId = props.closeAnalyticsReferrerId, categorize = props.categorize, allowExactMatch = props.allowExactMatch, listTitle = props.listTitle, handleResultSelection = props.handleResultSelection, onSelection = props.onSelection, selection = props.selection, index = props.index, initialRegionId = props.regionId, skipQuery = props.skipQuery, valueFromQueryParam = props.valueFromQueryParam, initialSelected = props.pinnedPropertyId, alternativeDropOffLocationLabel = props.alternativeDropOffLocationLabel, propertyRefinements = props.propertyRefinements, isDestination = props.isDestination, skipReflection = props.skipReflection, onOpenLocationField = props.onOpenLocationField;
    var _useSearchFormReflectionContext3 = useSearchFormReflectionContext3(), state = _useSearchFormReflectionContext3.state, dispatch = _useSearchFormReflectionContext3.dispatch;
    var reflectionDestination = state.destination, reflectionOrigin = state.origin;
    var defaultSelection = React25.useMemo(function() {
        if (!skipReflection && isDestination && reflectionDestination) {
            return reflectionDestination;
        }
        if (!skipReflection && !isDestination && reflectionOrigin) {
            return reflectionOrigin;
        }
        return {
            term: value,
            data: {
                type: void 0,
                regionId: initialRegionId,
                hierarchyInfo: {
                    airport: {
                        airportCode: "",
                        airportId: ""
                    }
                },
                location: {
                    lat: "",
                    long: ""
                },
                selected: initialSelected !== null && initialSelected !== void 0 ? initialSelected : void 0,
                regionNames: {
                    fullName: value
                },
                cityId: ""
            }
        };
    }, [
        value,
        initialRegionId,
        initialSelected,
        reflectionOrigin,
        reflectionDestination,
        isDestination,
        skipReflection
    ]);
    var _React25_useState = _sliced_to_array(React25.useState(defaultSelection), 2), currentSelection = _React25_useState[0], setCurrentSelection = _React25_useState[1];
    var _React25_useState1 = _sliced_to_array(React25.useState(label), 2), displayLabel = _React25_useState1[0], setDisplayLabel = _React25_useState1[1];
    React25.useEffect(function() {
        if (defaultSelection.term && !skipQuery) {
            setCurrentSelection(defaultSelection);
        }
    }, [
        defaultSelection,
        skipQuery
    ]);
    var track = useClickTracker10();
    var handleClick = function() {
        if (onOpenLocationField) {
            onOpenLocationField();
        }
        if (analyticsReferrerId !== "" || analyticsLinkName !== "") {
            track(analyticsReferrerId, analyticsLinkName);
        }
    };
    var handleMountCB = function(ref) {
        return setFieldRefByTypename(__typename, ref);
    };
    React25.useEffect(function() {
        var _selection;
        if (((_selection = selection) === null || _selection === void 0 ? void 0 : _selection.term) && selection.term !== currentSelection.term) {
            setCurrentSelection(selection);
        }
        if (valueFromQueryParam && valueFromQueryParam !== currentSelection.term) {
            setCurrentSelection(function(prevState) {
                return _object_spread_props(_object_spread({}, prevState), {
                    term: valueFromQueryParam
                });
            });
            if (onSelection) {
                onSelection({
                    data: currentSelection.data,
                    term: valueFromQueryParam
                });
            }
        }
    }, [
        selection,
        valueFromQueryParam,
        currentSelection
    ]);
    var _ref = currentSelection.data || defaultSelection.data, regionId = _ref.regionId, location = _ref.location, hierarchyInfo = _ref.hierarchyInfo, _ref_selected = _ref.selected, selected = _ref_selected === void 0 ? "" : _ref_selected, type = _ref.type, cityId = _ref.cityId;
    var _ref1 = location !== null && location !== void 0 ? location : {}, _ref_lat = _ref1.lat, lat = _ref_lat === void 0 ? "" : _ref_lat, _ref_long = _ref1.long, long = _ref_long === void 0 ? "" : _ref_long;
    var airport = (hierarchyInfo !== null && hierarchyInfo !== void 0 ? hierarchyInfo : {}).airport;
    var _ref2 = airport || {}, _ref_airportCode = _ref2.airportCode, airportCode = _ref_airportCode === void 0 ? "" : _ref_airportCode, _ref_airportId = _ref2.airportId, airportId = _ref_airportId === void 0 ? "" : _ref_airportId;
    var handleChange = function(newSelection) {
        if (changeAnalyticsReferrerId && changeAnalyticsLinkName) {
            track("".concat(changeAnalyticsReferrerId, ".").concat(newSelection.term), changeAnalyticsLinkName);
        }
        setCurrentSelection(newSelection);
        setDisplayLabel(alternativeDropOffLocationLabel !== null && alternativeDropOffLocationLabel !== void 0 ? alternativeDropOffLocationLabel : label);
        if (onSelection) {
            onSelection(newSelection);
        }
        if (!skipReflection) {
            dispatch({
                type: isDestination ? "UPDATE_DESTINATION" : "UPDATE_ORIGIN",
                location: newSelection.data ? newSelection : _object_spread_props(_object_spread({}, newSelection), {
                    data: {}
                })
            });
        }
    };
    var handleClear = function() {
        setCurrentSelection({
            term: "",
            data: {
                regionId: "",
                hierarchyInfo: {
                    airport: {
                        airportCode: "",
                        airportId: ""
                    }
                },
                location: {
                    lat: "",
                    long: ""
                },
                selected: void 0,
                regionNames: {},
                cityId: ""
            }
        });
        setDisplayLabel(label);
    };
    var handleOnDismiss = function() {
        var referrerId = closeAnalyticsReferrerId !== null && closeAnalyticsReferrerId !== void 0 ? closeAnalyticsReferrerId : "";
        var linkName = closeAnalyticsLinkName !== null && closeAnalyticsLinkName !== void 0 ? closeAnalyticsLinkName : "";
        if (referrerId && linkName) {
            track(referrerId, linkName);
        }
    };
    var hiddenInputNameSuffix = "".concat(egdsElementId).concat(Number.isInteger(index) ? "-".concat(index) : "");
    var currentLocation = ((_currentSelection_data = currentSelection.data) === null || _currentSelection_data === void 0 ? void 0 : (_currentSelection_data_regionNames = _currentSelection_data.regionNames) === null || _currentSelection_data_regionNames === void 0 ? void 0 : _currentSelection_data_regionNames.fullName) && !valueFromQueryParam ? currentSelection.data.regionNames.fullName : currentSelection.term;
    var currentRegionId = currentSelection.data ? regionId || cityId || airportId : "";
    var locationValue = essAdapter.config.showCurrentLocation && type === TypeaheadLocationType.CURRENT_LOCATION ? "" : currentLocation;
    var destinationId = currentSelection.data ? cityId || regionId : "";
    return /* @__PURE__ */ React25.createElement(React25.Fragment, null, /* @__PURE__ */ React25.createElement(UitkTypeahead, {
        id: egdsElementId,
        name: egdsElementId,
        adapter: essAdapter,
        label: displayLabel,
        typeaheadPlaceholder: placeholder,
        icon: icon,
        value: locationValue,
        onUpdate: handleChange,
        handleClear: handleClear,
        stid: egdsElementId,
        accessibilityLabel: accessibility,
        onClick: handleClick,
        onMountCB: handleMountCB,
        invalid: errorText,
        required: required,
        typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder,
        onResultSelection: handleResultSelection,
        categorize: categorize,
        allowExactMatch: allowExactMatch,
        listTitle: listTitle,
        onDismiss: handleOnDismiss
    }), /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": LOCATION_NAME_PREFIX,
        name: "".concat(LOCATION_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: locationValue
    }), currentRegionId && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": REGION_ID_NAME_PREFIX,
        name: "".concat(REGION_ID_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: currentRegionId
    }), /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": AIRPORT_CODE_NAME_PREFIX,
        name: "".concat(AIRPORT_CODE_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: airportCode
    }), /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": LAT_NAME_PREFIX,
        name: "".concat(LAT_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: lat
    }), /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": LONG_NAME_PREFIX,
        name: "".concat(LONG_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: long
    }), /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": SELECTED_PREFIX,
        name: "".concat(SELECTED_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: selected
    }), ((_propertyRefinements = propertyRefinements) === null || _propertyRefinements === void 0 ? void 0 : _propertyRefinements.amenitiesFacilitiesGroup) && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": AMENITIES_GROUP_PREFIX,
        name: "".concat(AMENITIES_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: (_propertyRefinements1 = propertyRefinements) === null || _propertyRefinements1 === void 0 ? void 0 : _propertyRefinements1.amenitiesFacilitiesGroup
    }), ((_propertyRefinements2 = propertyRefinements) === null || _propertyRefinements2 === void 0 ? void 0 : _propertyRefinements2.locationGroup) && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": LOCATION_GROUP_PREFIX,
        name: "".concat(LOCATION_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: (_propertyRefinements3 = propertyRefinements) === null || _propertyRefinements3 === void 0 ? void 0 : _propertyRefinements3.locationGroup
    }), ((_propertyRefinements4 = propertyRefinements) === null || _propertyRefinements4 === void 0 ? void 0 : _propertyRefinements4.propertiesGoodForGroup) && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": PROPERTIES_GOOD_FOR_GROUP_PREFIX,
        name: "".concat(PROPERTIES_GOOD_FOR_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: (_propertyRefinements5 = propertyRefinements) === null || _propertyRefinements5 === void 0 ? void 0 : _propertyRefinements5.propertiesGoodForGroup
    }), ((_propertyRefinements6 = propertyRefinements) === null || _propertyRefinements6 === void 0 ? void 0 : _propertyRefinements6.propertyTypeGroup) && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": PROPERTY_TYPE_GROUP_PREFIX,
        name: "".concat(PROPERTY_TYPE_GROUP_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: (_propertyRefinements7 = propertyRefinements) === null || _propertyRefinements7 === void 0 ? void 0 : _propertyRefinements7.propertyTypeGroup
    }), destinationId && /* @__PURE__ */ React25.createElement("input", {
        type: "hidden",
        "data-stid": DESTINATION_ID_NAME_PREFIX,
        name: "".concat(DESTINATION_ID_NAME_PREFIX, "-").concat(hiddenInputNameSuffix),
        value: destinationId
    }));
};
// ../internal/src/components/form/egds-search-form-location-field/multi-location-field.tsx
import React26 from "react";
import { useClickTracker as useClickTracker11 } from "@shared-ui/clickstream-analytics-context";
import { UitkTypeahead as UitkTypeahead2 } from "uitk-react-typeahead";
var DISPLAY_NAME10 = "EGDSSearchFormLocationField";
var LOCATION_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-Location");
var REGION_ID_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-RegionId");
var AIRPORT_CODE_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-AirportCode");
var LAT_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-Lat");
var LONG_NAME_PREFIX2 = "".concat(DISPLAY_NAME10, "-Long");
var LOCATION_DEEP_LINK_PREFIX = "".concat(DISPLAY_NAME10, "-Values");
var getLocationFieldDataSelection = function(selection) {
    var defaultSelection = {
        data: {
            regionId: "",
            hierarchyInfo: {
                airport: {
                    airportCode: ""
                }
            },
            location: {
                lat: "",
                long: ""
            },
            value: ""
        }
    };
    var selectionsData = selection.map(function(item) {
        return item.data || defaultSelection.data;
    });
    return {
        term: selection.map(function(item) {
            return item.term;
        }).join(","),
        regionId: selectionsData.map(function(data) {
            return data.regionId;
        }).join(","),
        lat: selectionsData.map(function(data) {
            var _data_location;
            return (_data_location = data.location) === null || _data_location === void 0 ? void 0 : _data_location.lat;
        }).join(","),
        long: selectionsData.map(function(data) {
            var _data_location;
            return (_data_location = data.location) === null || _data_location === void 0 ? void 0 : _data_location.long;
        }).join(","),
        airportCode: selectionsData.map(function(data) {
            var _data_hierarchyInfo_airport, _data_hierarchyInfo;
            return (_data_hierarchyInfo = data.hierarchyInfo) === null || _data_hierarchyInfo === void 0 ? void 0 : (_data_hierarchyInfo_airport = _data_hierarchyInfo.airport) === null || _data_hierarchyInfo_airport === void 0 ? void 0 : _data_hierarchyInfo_airport.airportCode;
        }).join(","),
        locationValues: selectionsData.map(function(data) {
            return data.value;
        }).join(",")
    };
};
var MultiLocationField = function(props) {
    var egdsElementId = props.egdsElementId, essAdapter = props.essAdapter, label = props.label, placeholder = props.placeholder, icon = props.icon, multiLocations = props.multiLocations, errorText = props.errorText, required = props.required, emptyResultsPlaceholder = props.emptyResultsPlaceholder, setFieldRefByTypename = props.setFieldRefByTypename, __typename = props.__typename, analyticsLinkName = props.analyticsLinkName, analyticsReferrerId = props.analyticsReferrerId, categorize = props.categorize, allowExactMatch = props.allowExactMatch, listTitle = props.listTitle, selectedItemHeading = props.selectedItemHeading, clearAllText = props.clearAllText, dismissButtonText = props.dismissButtonText, handleResultSelection = props.handleResultSelection, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, onMultiSelectClose = props.onMultiSelectClose;
    var defaultMultiSelection = multiLocations.map(function(item) {
        return {
            term: item.text,
            data: {
                regionId: "",
                hierarchyInfo: {
                    airport: {
                        airportCode: ""
                    }
                },
                location: {
                    lat: "",
                    long: ""
                },
                value: item.value
            }
        };
    });
    var _React26_useState = _sliced_to_array(React26.useState(defaultMultiSelection), 2), selection = _React26_useState[0], setSelection = _React26_useState[1];
    var _React26_useState1 = _sliced_to_array(React26.useState(false), 2), shouldFireChangeEvent = _React26_useState1[0], setShouldFireChangeEvent = _React26_useState1[1];
    React26.useEffect(function() {
        if (shouldFireChangeEvent) {
            setShouldFireChangeEvent(false);
            triggerInputChangeEvent(selection.map(function(value) {
                return value.term;
            }).join(", "), handleResultSelection);
        }
    }, [
        shouldFireChangeEvent,
        selection,
        handleResultSelection
    ]);
    var trackClick = useClickTracker11();
    var handleClick = function() {
        return trackClick(analyticsReferrerId, analyticsLinkName);
    };
    var handleMountCB = function(ref) {
        return setFieldRefByTypename(__typename, ref);
    };
    var _getLocationFieldDataSelection = getLocationFieldDataSelection(selection), term = _getLocationFieldDataSelection.term, regionId = _getLocationFieldDataSelection.regionId, lat = _getLocationFieldDataSelection.lat, long = _getLocationFieldDataSelection.long, airportCode = _getLocationFieldDataSelection.airportCode, locationValues = _getLocationFieldDataSelection.locationValues;
    var handleChange = function(newSelection) {
        var isNewSelectionRepeated = selection.some(function(item) {
            return item === newSelection;
        });
        if (!isNewSelectionRepeated && newSelection.data) {
            setSelection(function(prevSelection) {
                return _to_consumable_array(prevSelection).concat([
                    newSelection
                ]);
            });
        }
    };
    var handleClear = function() {
        var _onMultiSelectClearAll;
        setSelection([]);
        (_onMultiSelectClearAll = onMultiSelectClearAll) === null || _onMultiSelectClearAll === void 0 ? void 0 : _onMultiSelectClearAll(egdsElementId);
    };
    var handleRemove = function(selectedIndex) {
        if (selection.length > 0) {
            var _onMultiSelectItemRemove;
            setSelection(function(prevSelection) {
                return prevSelection.filter(function(_, index) {
                    return index !== selectedIndex;
                });
            });
            (_onMultiSelectItemRemove = onMultiSelectItemRemove) === null || _onMultiSelectItemRemove === void 0 ? void 0 : _onMultiSelectItemRemove(selection[selectedIndex], egdsElementId);
        }
    };
    var handleDismiss = function(renderType) {
        var _onMultiSelectClose;
        (_onMultiSelectClose = onMultiSelectClose) === null || _onMultiSelectClose === void 0 ? void 0 : _onMultiSelectClose(renderType, egdsElementId);
        setShouldFireChangeEvent(true);
    };
    var accessibilityLabel = label.concat(",").concat(term);
    return /* @__PURE__ */ React26.createElement(React26.Fragment, null, /* @__PURE__ */ React26.createElement(UitkTypeahead2, {
        id: egdsElementId,
        name: egdsElementId,
        adapter: essAdapter,
        label: label,
        typeaheadPlaceholder: placeholder,
        icon: icon,
        value: selection.map(function(item) {
            return item.term;
        }),
        onUpdate: handleChange,
        stid: egdsElementId,
        accessibilityLabel: accessibilityLabel,
        onClick: handleClick,
        onMountCB: handleMountCB,
        invalid: errorText,
        required: required,
        typeaheadEmptyResultPlaceholder: emptyResultsPlaceholder,
        handleClear: handleClear,
        onItemRemove: handleRemove,
        onDismiss: handleDismiss,
        categorize: categorize,
        allowExactMatch: allowExactMatch,
        listTitle: listTitle,
        selectedItemHeading: selectedItemHeading,
        clearAllText: clearAllText,
        dismissButtonText: dismissButtonText,
        isMulti: true
    }), /* @__PURE__ */ React26.createElement("input", {
        type: "hidden",
        "data-stid": LOCATION_NAME_PREFIX2,
        name: "".concat(LOCATION_NAME_PREFIX2, "-").concat(egdsElementId),
        value: term
    }), /* @__PURE__ */ React26.createElement("input", {
        type: "hidden",
        "data-stid": REGION_ID_NAME_PREFIX2,
        name: "".concat(REGION_ID_NAME_PREFIX2, "-").concat(egdsElementId),
        value: regionId
    }), /* @__PURE__ */ React26.createElement("input", {
        type: "hidden",
        "data-stid": AIRPORT_CODE_NAME_PREFIX2,
        name: "".concat(AIRPORT_CODE_NAME_PREFIX2, "-").concat(egdsElementId),
        value: airportCode
    }), /* @__PURE__ */ React26.createElement("input", {
        type: "hidden",
        "data-stid": LAT_NAME_PREFIX2,
        name: "".concat(LAT_NAME_PREFIX2, "-").concat(egdsElementId),
        value: lat
    }), /* @__PURE__ */ React26.createElement("input", {
        type: "hidden",
        "data-stid": LONG_NAME_PREFIX2,
        name: "".concat(LONG_NAME_PREFIX2, "-").concat(egdsElementId),
        value: long
    }), /* @__PURE__ */ React26.createElement("input", {
        type: "hidden",
        "data-stid": LOCATION_DEEP_LINK_PREFIX,
        name: "".concat(LOCATION_DEEP_LINK_PREFIX, "-").concat(egdsElementId),
        value: locationValues
    }));
};
// ../internal/src/components/form/egds-search-form-location-field/egds-search-form-location-field.tsx
var __Fragment21 = gql22(_templateObject21());
var DISPLAY_NAME11 = "EGDSSearchFormLocationField";
var EGDSSearchFormLocationField = function(props) {
    var _action, _additionalAdapterFields, _additionalAdapterFields1, _identity, _leftIcon, _closeAnalytics, _closeAnalytics1, _changeAnalytics, _changeAnalytics1;
    var fieldError = props.fieldError, data = props.data, adapter = props.adapter, onMultiSelectClose = props.onMultiSelectClose, onMultiSelectItemRemove = props.onMultiSelectItemRemove, onMultiSelectClearAll = props.onMultiSelectClearAll, essLogger = props.essLogger, locationsErrorText = props.locationsErrorText, additionalAdapterFields = props.additionalAdapterFields, pinnedPropertyId = props.pinnedPropertyId, alternativeDropOffLocationLabel = props.alternativeDropOffLocationLabel, propertyRefinements = props.propertyRefinements, skipReflection = props.skipReflection;
    var context = useBexApi3().context;
    var identity = context.identity, locale = context.locale, siteId = context.siteId;
    var __typename = data.__typename, label = data.label, action = data.action, placeholder = data.placeholder, leftIcon = data.leftIcon, egdsElementId = data.egdsElementId, value = data.value, errorMessage = data.errorMessage, required = data.required, multiLocations = data.multiLocations, closeAnalytics = data.closeAnalytics, changeAnalytics = data.changeAnalytics;
    var _ref;
    var errorTextToDisplay = (_ref = locationsErrorText !== null && locationsErrorText !== void 0 ? locationsErrorText : errorMessage) !== null && _ref !== void 0 ? _ref : "";
    var handleResultSelection = useFormCallback6(egdsElementId, function(event) {
        return event;
    });
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "OpenTypeaheadAction") {
        return null;
    }
    var finalAdditionalAdapterFields = _object_spread_props(_object_spread({}, additionalAdapterFields), {
        alternate: ((_additionalAdapterFields = additionalAdapterFields) === null || _additionalAdapterFields === void 0 ? void 0 : _additionalAdapterFields.lastSearchLatLong) ? (_additionalAdapterFields1 = additionalAdapterFields) === null || _additionalAdapterFields1 === void 0 ? void 0 : _additionalAdapterFields1.alternate : false
    });
    var analytics = action.analytics, accessibility = action.accessibility, emptyResultsPlaceholder = action.emptyResultsPlaceholder, categorize = action.categorize, allowExactMatch = action.allowExactMatch, listTitle = action.listTitle, selectedItemHeading = action.selectedItemHeading, clearAllText = action.clearAllText, dismissButtonText = action.dismissButtonText;
    var _action_info = action.info, client = _action_info.client, drivable = _action_info.drivable, isDestination = _action_info.isDestination, lineOfBusiness = _action_info.lineOfBusiness, maxNumberOfResults = _action_info.maxNumberOfResults, packageType = _action_info.packageType, personalize = _action_info.personalize, regionType = _action_info.regionType, typeaheadFeatures = _action_info.typeaheadFeatures, isMultiLocation = _action_info.isMultiLocation, domain = _action_info.domain, regionId = _action_info.regionId, showCurrentLocation = _action_info.showCurrentLocation;
    var _ref1 = identity || {}, guid = _ref1.duaid;
    var expuserid = Number((_identity = identity) === null || _identity === void 0 ? void 0 : _identity.expUserId) || -1;
    var defaultMaxNumberOfResults = 10;
    var defaultRegionType = 2047;
    var defaultIcon = "place";
    var essAdapter = adapter !== null && adapter !== void 0 ? adapter : new ESSAdapter(_object_spread({
        client: client !== null && client !== void 0 ? client : "",
        drivable: drivable,
        dest: isDestination,
        domain: domain !== null && domain !== void 0 ? domain : "https://www.expedia.com/",
        expuserid: expuserid,
        features: typeaheadFeatures !== null && typeaheadFeatures !== void 0 ? typeaheadFeatures : "",
        guid: guid,
        lob: lineOfBusiness !== null && lineOfBusiness !== void 0 ? lineOfBusiness : "",
        locale: locale,
        maxResults: maxNumberOfResults !== null && maxNumberOfResults !== void 0 ? maxNumberOfResults : defaultMaxNumberOfResults,
        personalize: personalize,
        regionType: regionType !== null && regionType !== void 0 ? regionType : defaultRegionType,
        siteId: siteId,
        packageType: packageType !== null && packageType !== void 0 ? packageType : "",
        essLogger: essLogger,
        showCurrentLocation: showCurrentLocation !== null && showCurrentLocation !== void 0 ? showCurrentLocation : false,
        regionId: regionId !== null && regionId !== void 0 ? regionId : void 0
    }, finalAdditionalAdapterFields));
    var _leftIcon_title;
    var commonProps = _object_spread_props(_object_spread({}, props), {
        egdsElementId: egdsElementId,
        essAdapter: essAdapter,
        categorize: categorize,
        allowExactMatch: allowExactMatch,
        listTitle: listTitle,
        handleResultSelection: handleResultSelection,
        label: label !== null && label !== void 0 ? label : "",
        placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : "",
        icon: (_leftIcon_title = (_leftIcon = leftIcon) === null || _leftIcon === void 0 ? void 0 : _leftIcon.title) !== null && _leftIcon_title !== void 0 ? _leftIcon_title : defaultIcon,
        accessibility: accessibility !== null && accessibility !== void 0 ? accessibility : "",
        errorText: fieldError ? errorTextToDisplay : "",
        required: required !== null && required !== void 0 ? required : false,
        emptyResultsPlaceholder: emptyResultsPlaceholder !== null && emptyResultsPlaceholder !== void 0 ? emptyResultsPlaceholder : "",
        analyticsLinkName: analytics.linkName,
        analyticsReferrerId: analytics.referrerId,
        closeAnalyticsLinkName: (_closeAnalytics = closeAnalytics) === null || _closeAnalytics === void 0 ? void 0 : _closeAnalytics.linkName,
        closeAnalyticsReferrerId: (_closeAnalytics1 = closeAnalytics) === null || _closeAnalytics1 === void 0 ? void 0 : _closeAnalytics1.referrerId,
        changeAnalyticsLinkName: (_changeAnalytics = changeAnalytics) === null || _changeAnalytics === void 0 ? void 0 : _changeAnalytics.linkName,
        changeAnalyticsReferrerId: (_changeAnalytics1 = changeAnalytics) === null || _changeAnalytics1 === void 0 ? void 0 : _changeAnalytics1.referrerId,
        selectedItemHeading: selectedItemHeading !== null && selectedItemHeading !== void 0 ? selectedItemHeading : "",
        dismissButtonText: dismissButtonText !== null && dismissButtonText !== void 0 ? dismissButtonText : "",
        __typename: __typename,
        regionId: regionId,
        isDestination: isDestination
    });
    if (isMultiLocation) {
        return /* @__PURE__ */ React27.createElement(MultiLocationField, _object_spread_props(_object_spread({}, commonProps), {
            multiLocations: multiLocations !== null && multiLocations !== void 0 ? multiLocations : [],
            clearAllText: clearAllText !== null && clearAllText !== void 0 ? clearAllText : "",
            onMultiSelectClose: onMultiSelectClose,
            onMultiSelectItemRemove: onMultiSelectItemRemove,
            onMultiSelectClearAll: onMultiSelectClearAll
        }));
    }
    return /* @__PURE__ */ React27.createElement(LocationField, _object_spread_props(_object_spread({}, commonProps), {
        value: value !== null && value !== void 0 ? value : "",
        pinnedPropertyId: pinnedPropertyId !== null && pinnedPropertyId !== void 0 ? pinnedPropertyId : "",
        alternativeDropOffLocationLabel: alternativeDropOffLocationLabel,
        propertyRefinements: propertyRefinements,
        skipReflection: skipReflection
    }));
};
EGDSSearchFormLocationField.displayName = DISPLAY_NAME11;
EGDSSearchFormLocationField.fragment = __Fragment21;
EGDSSearchFormLocationField.fragment.__typename = DISPLAY_NAME11;
// ../internal/src/components/form/egds-search-form-travelers-field/egds-search-form-travelers-field.tsx
import React45 from "react";
import { gql as gql36 } from "@apollo/client";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-basic-traveler-selector.tsx
import React38 from "react";
import { gql as gql31 } from "@apollo/client";
import { ViewMedium as ViewMedium2, Viewport as Viewport2 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize3 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex4, UitkLayoutFlexItem as UitkLayoutFlexItem4 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing7 } from "uitk-react-spacing";
// ../internal/src/components/common/button/egds-primary-button.tsx
import React28 from "react";
import { gql as gql23 } from "@apollo/client";
import { useClickTracker as useClickTracker12 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize2, UitkFloatingFullWidthButton, UitkPrimaryButton as UitkPrimaryButton2 } from "uitk-react-button";
import { UitkScrim } from "uitk-react-scrim";
var __Fragment22 = gql23(_templateObject22(), EGDSButtonFragment);
var EGDSPrimaryButton = function(param) {
    var data = param.data, onClick = param.onClick, size = param.size, _param_isFullWidth = param.isFullWidth, isFullWidth = _param_isFullWidth === void 0 ? true : _param_isFullWidth, _param_floating = param.floating, floating = _param_floating === void 0 ? false : _param_floating;
    var egdsElementId = data.egdsElementId, primary = data.primary, analytics = data.analytics;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_primary_button";
    var track = useClickTracker12();
    var handleClick = React28.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    var primaryButtonProps = {
        onClick: handleClick,
        id: id,
        isFullWidth: isFullWidth,
        size: size || UitkButtonSize2.LARGE
    };
    return floating ? /* @__PURE__ */ React28.createElement(UitkScrim, {
        type: "fade-button"
    }, /* @__PURE__ */ React28.createElement(UitkFloatingFullWidthButton, _object_spread({}, primaryButtonProps), primary)) : /* @__PURE__ */ React28.createElement(UitkPrimaryButton2, _object_spread({}, primaryButtonProps), primary);
};
EGDSPrimaryButton.displayName = "EGDSPrimaryButton";
EGDSPrimaryButton.fragment = __Fragment22;
// ../internal/src/components/common/button/egds-tertiary-button.tsx
import React29 from "react";
import { gql as gql24 } from "@apollo/client";
import { useClickTracker as useClickTracker13 } from "@shared-ui/clickstream-analytics-context";
import { UitkTertiaryButton } from "uitk-react-button";
import { UitkIcon as UitkIcon3 } from "uitk-react-icons";
var __Fragment23 = gql24(_templateObject23(), EGDSButtonFragment);
var EGDSTertiaryButton = function(param) {
    var onClick = param.onClick, isFullWidth = param.isFullWidth, size = param.size, data = param.data, isDisabled = param.isDisabled;
    var egdsElementId = data.egdsElementId, primary = data.primary, disabled = data.disabled, accessibility = data.accessibility, analytics = data.analytics, icon = data.icon;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search_form_tertiary_button";
    var track = useClickTracker13();
    var disableState = isDisabled || disabled;
    var handleClick = React29.useCallback(function() {
        if (analytics) {
            var referrerId = analytics.referrerId, linkName = analytics.linkName;
            track(referrerId, linkName);
        }
        onClick();
    }, [
        analytics,
        onClick,
        track
    ]);
    return /* @__PURE__ */ React29.createElement(UitkTertiaryButton, {
        "aria-label": accessibility !== null && accessibility !== void 0 ? accessibility : "",
        id: id,
        "data-test-id": id,
        onClick: handleClick,
        disabled: disableState,
        isFullWidth: isFullWidth,
        size: size
    }, icon && /* @__PURE__ */ React29.createElement(UitkIcon3, {
        name: icon.id
    }), primary);
};
EGDSTertiaryButton.displayName = "EGDSTertiaryButton";
EGDSTertiaryButton.fragment = __Fragment23;
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers.tsx
import React37 from "react";
import { gql as gql30 } from "@apollo/client";
import { UitkSpacing as UitkSpacing6 } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-children.tsx
import React35 from "react";
import { gql as gql29 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex3, UitkLayoutFlexItem as UitkLayoutFlexItem3 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing5 } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-child-age-select.tsx
import React33 from "react";
import { gql as gql26 } from "@apollo/client";
import { useClickTracker as useClickTracker14 } from "@shared-ui/clickstream-analytics-context";
import { UitkSelect } from "uitk-react-input";
// ../internal/src/components/common/egds-basic-option.tsx
import React30 from "react";
import { gql as gql25 } from "@apollo/client";
var __Fragment24 = gql25(_templateObject24());
var EGDSBasicOption = function(param) {
    var data = param.data;
    var label = data.label, value = data.value, egdsElementId = data.egdsElementId;
    var key = "".concat(egdsElementId, "-").concat(value);
    return /* @__PURE__ */ React30.createElement("option", {
        key: key,
        value: value
    }, label);
};
EGDSBasicOption.displayName = "EGDSBasicOptionFragment";
EGDSBasicOption.fragment = __Fragment24;
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-provider.tsx
import React32 from "react";
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-provider.tsx
import React31 from "react";
var noAgeSelected = function(infantOrChild) {
    return infantOrChild.__typename === "EGDSTravelerChildAgeSelect" && infantOrChild.value === null;
};
var getChildCountWithoutAge = function(rooms) {
    return rooms.reduce(function(count, room) {
        var _room_infants;
        var childrenAges = room.children.__typename === "EGDSTravelerChildren" ? room.children.ages : [];
        var infantAges = ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" ? room.infants.ages : [];
        var _infantAges_filter_length;
        return count + childrenAges.filter(noAgeSelected).length + ((_infantAges_filter_length = infantAges.filter(noAgeSelected).length) !== null && _infantAges_filter_length !== void 0 ? _infantAges_filter_length : 0);
    }, 0);
};
var getTravelersError = function(currentError, rooms, validations, currentInfantSelection) {
    var _currentError;
    if (!validations) {
        return null;
    }
    var _room_infants_count_value;
    var travelersCount = rooms.reduce(function(count, room) {
        var _room_infants;
        return count + room.adults.value + room.children.count.value + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
    }, 0);
    var _room_infants_count_value1;
    var infantsOnLap = currentInfantSelection === "lap" ? rooms.reduce(function(count, room) {
        var _room_infants;
        return count + ((_room_infants_count_value1 = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value1 !== void 0 ? _room_infants_count_value1 : 0);
    }, 0) : 0;
    var _room_infants_count_value2;
    var infantInSeat = currentInfantSelection === "seat" ? rooms.reduce(function(count, room) {
        var _room_infants;
        return count + ((_room_infants_count_value2 = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) !== null && _room_infants_count_value2 !== void 0 ? _room_infants_count_value2 : 0);
    }, 0) : 0;
    var _room_adults_value;
    var adultCount = rooms.reduce(function(count, room) {
        return count + ((_room_adults_value = room.adults.value) !== null && _room_adults_value !== void 0 ? _room_adults_value : 0);
    }, 0);
    var olderChildren = rooms.reduce(function(count, room) {
        var ages = room.children.__typename === "EGDSTravelerChildren" ? room.children.ages : [];
        var _ages_filter_length;
        return count + ((_ages_filter_length = ages.filter(function(age) {
            return age.__typename === "EGDSTravelerChildAgeSelect" && age.value && age.value >= 12;
        }).length) !== null && _ages_filter_length !== void 0 ? _ages_filter_length : 0);
    }, 0);
    var childWithoutAgeCount = getChildCountWithoutAge(rooms);
    var checkInfantsOnLap = olderChildren + adultCount < infantsOnLap;
    var errors = validations.map(function(validation) {
        if (validation.__typename === "EGDSTravelersInputValidation") {
            var type = validation.type, message = validation.errorMessage, maxCount = validation.maxCount, errorSummary2 = validation.errorSummary, infantsInSeatPerAdult = validation.infantsInSeatPerAdult;
            var _obj;
            var validationErrors = (_obj = {}, _define_property(_obj, "MAX_TRAVELERS" /* MAX_TRAVELERS */ , maxCount && travelersCount > maxCount ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: _object_spread_props(_object_spread({}, errorSummary2), {
                    heading: message
                })
            } : null), _define_property(_obj, "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ , childWithoutAgeCount > 0 ? {
                message: message,
                type: type,
                displayConfirmation: false,
                errorCount: childWithoutAgeCount,
                errorSummary: errorSummary2
            } : null), _define_property(_obj, "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */ , checkInfantsOnLap ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary2
            } : null), _define_property(_obj, "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */ , infantsInSeatPerAdult && olderChildren + adultCount < infantInSeat / infantsInSeatPerAdult ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary2
            } : null), _obj);
            var _validationErrors_type;
            return (_validationErrors_type = validationErrors[type]) !== null && _validationErrors_type !== void 0 ? _validationErrors_type : null;
        }
        return null;
    }).filter(function(error) {
        return error !== null;
    });
    var sameErrorPresent = errors.find(function(error) {
        return currentError && currentError.type === error.type;
    });
    if (sameErrorPresent && ((_currentError = currentError) === null || _currentError === void 0 ? void 0 : _currentError.displayConfirmation)) {
        return _object_spread_props(_object_spread({}, currentError), {
            errorCount: currentError.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  ? childWithoutAgeCount : 1
        });
    }
    var _errors_;
    return (_errors_ = errors[0]) !== null && _errors_ !== void 0 ? _errors_ : null;
};
var travelersReducer = function(state, action) {
    switch(action.type){
        case "ADD_ROOM":
            {
                var _state_rooms_ = state.rooms[0], adults = _state_rooms_.adults, label = _state_rooms_.label, removeRoomButton = _state_rooms_.removeRoomButton, children = _state_rooms_.children, infants = _state_rooms_.infants;
                if (adults.__typename === "EGDSTravelerStepInput" && children.__typename === "EGDSTravelerChildren" && children.ages) {
                    var _infants, _state_infantSeatSelection;
                    var defaultChildrenCount = _object_spread_props(_object_spread({}, children.count), {
                        value: 0
                    });
                    var defaultRoom = {
                        __typename: "EGDSTravelerSelectorRoom",
                        children: _object_spread_props(_object_spread({}, children), {
                            count: defaultChildrenCount,
                            ages: []
                        }),
                        adults: _object_spread_props(_object_spread({}, adults), {
                            value: 1
                        }),
                        label: label,
                        removeRoomButton: removeRoomButton,
                        travelerNote: null,
                        infants: ((_infants = infants) === null || _infants === void 0 ? void 0 : _infants.__typename) === "EGDSTravelerInfant" ? _object_spread_props(_object_spread({}, infants), {
                            count: _object_spread_props(_object_spread({}, infants.count), {
                                value: 0
                            }),
                            ages: []
                        }) : null
                    };
                    var rooms = state.rooms.concat(defaultRoom);
                    var _state_validations;
                    var error = getTravelersError(state.error ? state.error : null, rooms, (_state_validations = state.validations) !== null && _state_validations !== void 0 ? _state_validations : [], (_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value);
                    return _object_spread_props(_object_spread({}, state), {
                        rooms: rooms,
                        error: error
                    });
                }
                return _object_spread_props(_object_spread({}, state), {
                    rooms: []
                });
            }
        case "REMOVE_ROOM":
            {
                var _state_infantSeatSelection1;
                var roomIndex = action.roomIndex;
                var rooms1 = state.rooms.filter(function(_, index) {
                    return index !== roomIndex;
                });
                var _state_validations1;
                var error1 = getTravelersError(state.error ? state.error : null, rooms1, (_state_validations1 = state.validations) !== null && _state_validations1 !== void 0 ? _state_validations1 : [], (_state_infantSeatSelection1 = state.infantSeatSelection) === null || _state_infantSeatSelection1 === void 0 ? void 0 : _state_infantSeatSelection1.value);
                return _object_spread_props(_object_spread({}, state), {
                    rooms: rooms1,
                    error: error1
                });
            }
        case "RESET_STATE":
            {
                return action.state;
            }
        case "RESET_ROOMS":
            {
                return _object_spread_props(_object_spread({}, state), {
                    rooms: action.state.rooms
                });
            }
        case "UPDATE_INFANT_SEAT_SELECTION":
            {
                var value = action.value;
                var _state_validations2;
                var error2 = getTravelersError(state.error ? state.error : null, state.rooms, (_state_validations2 = state.validations) !== null && _state_validations2 !== void 0 ? _state_validations2 : [], value);
                return _object_spread_props(_object_spread({}, state), {
                    infantSeatSelection: {
                        value: action.value
                    },
                    error: error2
                });
            }
        case "UPDATE_TRAVELERS_COUNT":
            {
                var _state_infantSeatSelection2;
                var roomIndex1 = action.roomIndex, count = action.count, travelersType = action.travelersType, useDefaultAgeForChildren = action.useDefaultAgeForChildren;
                var rooms2 = state.rooms.map(function(room, index) {
                    if (index === roomIndex1) {
                        switch(travelersType){
                            case "adults" /* ADULTS */ :
                                {
                                    return _object_spread_props(_object_spread({}, room), {
                                        adults: _object_spread_props(_object_spread({}, room.adults), {
                                            value: count
                                        })
                                    });
                                }
                            case "children" /* CHILDREN */ :
                                {
                                    if (room.children.__typename === "EGDSTravelerChildren") {
                                        var _children_ages, _children_ages1;
                                        var children = room.children;
                                        var childrenAdded = count > children.count.value;
                                        var ageTemplateWithoutDefaultAge = children.ageTemplate.__typename === "EGDSTravelerChildAgeSelect" && !useDefaultAgeForChildren ? _object_spread_props(_object_spread({}, children.ageTemplate), {
                                            value: null
                                        }) : null;
                                        var ages = childrenAdded ? (_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.concat(ageTemplateWithoutDefaultAge !== null && ageTemplateWithoutDefaultAge !== void 0 ? ageTemplateWithoutDefaultAge : children.ageTemplate) : (_children_ages1 = children.ages) === null || _children_ages1 === void 0 ? void 0 : _children_ages1.slice(0, -1);
                                        var newChildren = _object_spread_props(_object_spread({}, children), {
                                            count: _object_spread_props(_object_spread({}, children.count), {
                                                value: count
                                            }),
                                            ages: ages
                                        });
                                        return _object_spread_props(_object_spread({}, room), {
                                            children: newChildren
                                        });
                                    }
                                    return room;
                                }
                            case "infants" /* INFANTS */ :
                                {
                                    var _room_infants;
                                    if (((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant") {
                                        var infants = room.infants;
                                        var infantsAdded = count > infants.count.value;
                                        var ages1 = infantsAdded ? infants.ages.concat(infants.ageTemplate) : infants.ages.slice(0, -1);
                                        var newInfants = _object_spread_props(_object_spread({}, infants), {
                                            count: _object_spread_props(_object_spread({}, infants.count), {
                                                value: count
                                            }),
                                            ages: ages1
                                        });
                                        return _object_spread_props(_object_spread({}, room), {
                                            infants: newInfants
                                        });
                                    }
                                    return room;
                                }
                            default:
                                return room;
                        }
                    }
                    return room;
                });
                var _state_validations3;
                var error3 = getTravelersError(state.error ? state.error : null, rooms2, (_state_validations3 = state.validations) !== null && _state_validations3 !== void 0 ? _state_validations3 : [], (_state_infantSeatSelection2 = state.infantSeatSelection) === null || _state_infantSeatSelection2 === void 0 ? void 0 : _state_infantSeatSelection2.value);
                return _object_spread_props(_object_spread({}, state), {
                    rooms: rooms2,
                    error: error3
                });
            }
        case "UPDATE_CHILD_AGE":
            {
                var _state_infantSeatSelection3;
                var roomIndex2 = action.roomIndex, childIndex = action.childIndex, childAge = action.childAge, isInfant = action.isInfant;
                var rooms3 = state.rooms.map(function(room, index) {
                    var _room_infants;
                    if (index === roomIndex2 && room.children.__typename === "EGDSTravelerChildren" && !isInfant) {
                        return _object_spread_props(_object_spread({}, room), {
                            children: _object_spread_props(_object_spread({}, room.children), {
                                ages: room.children.ages.map(function(child, ageIndex) {
                                    return child.__typename === "EGDSTravelerChildAgeSelect" && childIndex === ageIndex ? _object_spread_props(_object_spread({}, child), {
                                        value: childAge
                                    }) : _object_spread({}, child);
                                })
                            })
                        });
                    }
                    if (index === roomIndex2 && ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" && isInfant) {
                        return _object_spread_props(_object_spread({}, room), {
                            infants: _object_spread_props(_object_spread({}, room.infants), {
                                ages: room.infants.ages.map(function(infant, ageIndex) {
                                    return infant.__typename === "EGDSTravelerChildAgeSelect" && childIndex === ageIndex ? _object_spread_props(_object_spread({}, infant), {
                                        value: childAge
                                    }) : _object_spread({}, infant);
                                })
                            })
                        });
                    }
                    return room;
                });
                var _state_validations4;
                var error4 = getTravelersError(state.error ? state.error : null, rooms3, (_state_validations4 = state.validations) !== null && _state_validations4 !== void 0 ? _state_validations4 : [], (_state_infantSeatSelection3 = state.infantSeatSelection) === null || _state_infantSeatSelection3 === void 0 ? void 0 : _state_infantSeatSelection3.value);
                return _object_spread_props(_object_spread({}, state), {
                    rooms: rooms3,
                    error: error4
                });
            }
        case "SHOW_ERROR":
            {
                if (state.error) {
                    var _state_error = state.error, message = _state_error.message, type = _state_error.type, errorCount = _state_error.errorCount, errorSummary2 = _state_error.errorSummary;
                    var newError = {
                        message: message,
                        type: type,
                        displayConfirmation: true,
                        errorCount: errorCount,
                        errorSummary: errorSummary2
                    };
                    return _object_spread_props(_object_spread({}, state), {
                        error: newError
                    });
                }
                return _object_spread({}, state);
            }
        case "SET_VALIDATIONS":
            {
                return _object_spread_props(_object_spread({}, state), {
                    validations: action.validations
                });
            }
        default:
            return state;
    }
};
var TravelersContext = React31.createContext({
    state: {}
});
var TravelersProvider = function(param) {
    var children = param.children, rooms = param.rooms, validations = param.validations, skipQuery = param.skipQuery, infantSeatSelection = param.infantSeatSelection;
    var _React31_useReducer = _sliced_to_array(React31.useReducer(travelersReducer, {
        rooms: rooms,
        validations: validations,
        infantSeatSelection: infantSeatSelection ? {
            value: infantSeatSelection.selected
        } : null
    }), 2), state = _React31_useReducer[0], dispatch = _React31_useReducer[1];
    var _React31_useState = _sliced_to_array(React31.useState(state), 2), currentState = _React31_useState[0], setCurrentState = _React31_useState[1];
    React31.useEffect(function() {
        if (!skipQuery) {
            dispatch({
                type: "RESET_STATE",
                state: {
                    rooms: rooms,
                    validations: validations,
                    infantSeatSelection: infantSeatSelection ? {
                        value: infantSeatSelection.selected
                    } : null
                }
            });
        }
    }, [
        skipQuery,
        infantSeatSelection,
        rooms
    ]);
    React31.useEffect(function() {
        if (state !== currentState) {
            setCurrentState(state);
        }
    }, [
        state,
        currentState
    ]);
    React31.useEffect(function() {
        dispatch({
            type: "SET_VALIDATIONS",
            validations: validations
        });
    }, [
        validations
    ]);
    var travelersContext = {
        state: currentState,
        dispatch: dispatch
    };
    return /* @__PURE__ */ React31.createElement(TravelersContext.Provider, {
        value: travelersContext
    }, children);
};
var useTravelersContext = function() {
    return React31.useContext(TravelersContext);
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-provider.tsx
var noAgeSelected2 = function(childrenAge) {
    return childrenAge.__typename === "EGDSTravelerChildAgeSelect" && childrenAge.value === null;
};
var noInfantsInSeatAgeSelected = function(infantsInSeatAge) {
    return infantsInSeatAge.__typename === "EGDSTravelerChildAgeSelect" && infantsInSeatAge.value === null;
};
var noInfantsOnLapAgeSelected = function(infantsOnLap) {
    return infantsOnLap.__typename === "EGDSTravelerChildAgeSelect" && infantsOnLap.value === null;
};
var getChildCountWithoutAge2 = function(children) {
    var _children;
    return ((_children = children) === null || _children === void 0 ? void 0 : _children.__typename) === "EGDSTravelerChildren" ? children.ages.filter(noAgeSelected2).length : 0;
};
var getInfantsInSeatCountWithoutAge = function(infantInSeat) {
    var _infantInSeat, _infantInSeat1;
    return ((_infantInSeat = infantInSeat) === null || _infantInSeat === void 0 ? void 0 : _infantInSeat.__typename) === "EGDSTravelerInfant" ? (_infantInSeat1 = infantInSeat) === null || _infantInSeat1 === void 0 ? void 0 : _infantInSeat1.ages.filter(noInfantsInSeatAgeSelected).length : 0;
};
var getInfantsOnLapCountWithoutAge = function(infantOnLap) {
    var _infantOnLap, _infantOnLap1;
    return ((_infantOnLap = infantOnLap) === null || _infantOnLap === void 0 ? void 0 : _infantOnLap.__typename) === "EGDSTravelerInfant" ? (_infantOnLap1 = infantOnLap) === null || _infantOnLap1 === void 0 ? void 0 : _infantOnLap1.ages.filter(noInfantsOnLapAgeSelected).length : 0;
};
var getTravelersError2 = function(currentError, travelers, validations) {
    var _travelers_children, _travelers_infantsInSeat, _travelers_infantsOnLap, _travelers_children1, _travelers_children2, _currentError;
    if (!validations) {
        return null;
    }
    var _travelers_children_count_value;
    var childrenCount = (_travelers_children_count_value = (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.count.value) !== null && _travelers_children_count_value !== void 0 ? _travelers_children_count_value : 0;
    var _travelers_infantsInSeat_count_value;
    var infantInSeat = (_travelers_infantsInSeat_count_value = (_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.count.value) !== null && _travelers_infantsInSeat_count_value !== void 0 ? _travelers_infantsInSeat_count_value : 0;
    var _travelers_infantsOnLap_count_value;
    var infantsOnLap = (_travelers_infantsOnLap_count_value = (_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.count.value) !== null && _travelers_infantsOnLap_count_value !== void 0 ? _travelers_infantsOnLap_count_value : 0;
    var _travelers_adults_value;
    var adultCount = (_travelers_adults_value = travelers.adults.value) !== null && _travelers_adults_value !== void 0 ? _travelers_adults_value : 0;
    var travelersCount = adultCount + childrenCount + infantInSeat + infantsOnLap;
    var childWithoutAgeCount = getChildCountWithoutAge2(travelers.children);
    var infantInSeatWithoutAgeCount = getInfantsInSeatCountWithoutAge(travelers.infantsInSeat);
    var infantsOnLapWithoutAgeCount = getInfantsOnLapCountWithoutAge(travelers.infantsOnLap);
    var kidsWithoutAgeCount = childWithoutAgeCount + infantInSeatWithoutAgeCount + infantsOnLapWithoutAgeCount;
    var olderChildren = ((_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.__typename) === "EGDSTravelerChildren" ? (_travelers_children2 = travelers.children) === null || _travelers_children2 === void 0 ? void 0 : _travelers_children2.ages.filter(function(age) {
        return age.__typename === "EGDSTravelerChildAgeSelect" && age.value && age.value >= 12;
    }).length : 0;
    var checkInfantsOnLap = olderChildren + adultCount < infantsOnLap;
    var errors = validations.map(function(validation) {
        if (validation.__typename === "EGDSTravelersInputValidation") {
            var type = validation.type, message = validation.errorMessage, maxCount = validation.maxCount, errorSummary2 = validation.errorSummary, infantsInSeatPerAdult = validation.infantsInSeatPerAdult;
            var _obj;
            var validationErrors = (_obj = {}, _define_property(_obj, "MAX_TRAVELERS" /* MAX_TRAVELERS */ , maxCount ? travelersCount > maxCount && {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary2
            } : null), _define_property(_obj, "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ , kidsWithoutAgeCount > 0 ? {
                message: message,
                type: type,
                displayConfirmation: false,
                errorCount: kidsWithoutAgeCount,
                errorSummary: errorSummary2
            } : null), _define_property(_obj, "MANY_INFANT_ON_LAP" /* MANY_INFANT_ON_LAP */ , checkInfantsOnLap ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary2
            } : null), _define_property(_obj, "MANY_INFANT_IN_SEAT" /* MANY_INFANT_IN_SEAT */ , infantsInSeatPerAdult && olderChildren + adultCount < infantInSeat / infantsInSeatPerAdult ? {
                message: message,
                type: type,
                displayConfirmation: true,
                errorCount: 1,
                errorSummary: errorSummary2
            } : null), _obj);
            return validationErrors[type];
        }
        return null;
    }).filter(function(error) {
        return !!error;
    });
    var sameErrorPresent = errors.find(function(error) {
        var _error;
        return currentError && currentError.type === ((_error = error) === null || _error === void 0 ? void 0 : _error.type);
    });
    if (sameErrorPresent && ((_currentError = currentError) === null || _currentError === void 0 ? void 0 : _currentError.displayConfirmation)) {
        return _object_spread_props(_object_spread({}, currentError), {
            errorCount: currentError.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  ? kidsWithoutAgeCount : 1
        });
    }
    return errors ? errors[0] : null;
};
var getUpdatedTravelersCount = function(travelers, action) {
    switch(action.travelersType){
        case "adults" /* ADULTS */ :
            {
                return _object_spread_props(_object_spread({}, travelers), {
                    adults: _object_spread_props(_object_spread({}, travelers.adults), {
                        value: action.count
                    })
                });
            }
        case "children" /* CHILDREN */ :
            {
                var _travelers_children, _travelers_children1;
                if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren") {
                    var _children_ages, _children_ages1;
                    var children = travelers.children;
                    var childrenAdded = action.count > children.count.value;
                    var ageTemplateWithoutDefaultAge = children.ageTemplate.__typename === "EGDSTravelerChildAgeSelect" && !action.useDefaultAgeForChildren ? _object_spread_props(_object_spread({}, children.ageTemplate), {
                        value: null
                    }) : null;
                    var ages = childrenAdded ? (_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.concat(ageTemplateWithoutDefaultAge !== null && ageTemplateWithoutDefaultAge !== void 0 ? ageTemplateWithoutDefaultAge : children.ageTemplate) : (_children_ages1 = children.ages) === null || _children_ages1 === void 0 ? void 0 : _children_ages1.slice(0, -1);
                    var newChildren = _object_spread_props(_object_spread({}, children), {
                        count: _object_spread_props(_object_spread({}, children.count), {
                            value: action.count
                        }),
                        ages: ages
                    });
                    return _object_spread_props(_object_spread({}, travelers), {
                        children: newChildren
                    });
                }
                if (((_travelers_children1 = travelers.children) === null || _travelers_children1 === void 0 ? void 0 : _travelers_children1.__typename) === "EGDSBasicTraveler") {
                    var children1 = travelers.children;
                    return _object_spread_props(_object_spread({}, travelers), {
                        children: _object_spread_props(_object_spread({}, children1), {
                            count: _object_spread_props(_object_spread({}, children1.count), {
                                value: action.count
                            })
                        })
                    });
                }
                return travelers;
            }
        case "infants_in_seat" /* INFANTS_IN_SEAT */ :
            {
                var _travelers_infantsInSeat, _travelers_infantsOnLap, _travelers_infantsInSeat1;
                if (((_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.__typename) === "EGDSTravelerInfant" && ((_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.__typename) === "EGDSTravelerInfant") {
                    var _infantsInSeat_ages, _infantsInSeat_ages1, _infantsOnLap;
                    var infantsInSeat = travelers.infantsInSeat, infantsOnLap = travelers.infantsOnLap;
                    var infantsInSeatAdded = action.count > infantsInSeat.count.value;
                    var ages1 = infantsInSeatAdded ? (_infantsInSeat_ages = infantsInSeat.ages) === null || _infantsInSeat_ages === void 0 ? void 0 : _infantsInSeat_ages.concat(infantsInSeat.ageTemplate) : (_infantsInSeat_ages1 = infantsInSeat.ages) === null || _infantsInSeat_ages1 === void 0 ? void 0 : _infantsInSeat_ages1.slice(0, -1);
                    var newInfantsInSeat = _object_spread_props(_object_spread({}, infantsInSeat), {
                        count: _object_spread_props(_object_spread({}, infantsInSeat.count), {
                            value: action.count
                        }),
                        ages: ages1
                    });
                    var maxAllowedInfantsOnLap = newInfantsInSeat.count.value > 0 ? 0 : newInfantsInSeat.count.max;
                    var newinfantsOnLap = _object_spread_props(_object_spread({}, infantsOnLap), {
                        count: _object_spread_props(_object_spread({}, (_infantsOnLap = infantsOnLap) === null || _infantsOnLap === void 0 ? void 0 : _infantsOnLap.count), {
                            max: maxAllowedInfantsOnLap
                        })
                    });
                    return _object_spread_props(_object_spread({}, travelers), {
                        infantsInSeat: newInfantsInSeat,
                        infantsOnLap: newinfantsOnLap
                    });
                }
                if (((_travelers_infantsInSeat1 = travelers.infantsInSeat) === null || _travelers_infantsInSeat1 === void 0 ? void 0 : _travelers_infantsInSeat1.__typename) === "EGDSBasicTraveler") {
                    var infantsInSeat1 = travelers.infantsInSeat;
                    return _object_spread_props(_object_spread({}, travelers), {
                        infantsInSeat: _object_spread_props(_object_spread({}, infantsInSeat1), {
                            count: _object_spread_props(_object_spread({}, infantsInSeat1.count), {
                                value: action.count
                            })
                        })
                    });
                }
                return travelers;
            }
        case "infants_on_lap" /* INFANTS_ON_LAP */ :
            {
                var _travelers_infantsOnLap1, _travelers_infantsInSeat2, _travelers_infantsOnLap2;
                if (((_travelers_infantsOnLap1 = travelers.infantsOnLap) === null || _travelers_infantsOnLap1 === void 0 ? void 0 : _travelers_infantsOnLap1.__typename) === "EGDSTravelerInfant" && ((_travelers_infantsInSeat2 = travelers.infantsInSeat) === null || _travelers_infantsInSeat2 === void 0 ? void 0 : _travelers_infantsInSeat2.__typename) === "EGDSTravelerInfant") {
                    var _infantsOnLap_ages, _infantsOnLap_ages1, _infantsInSeat;
                    var infantsOnLap1 = travelers.infantsOnLap, infantsInSeat2 = travelers.infantsInSeat;
                    var infantsOnLapAdded = action.count > infantsOnLap1.count.value;
                    var ages2 = infantsOnLapAdded ? (_infantsOnLap_ages = infantsOnLap1.ages) === null || _infantsOnLap_ages === void 0 ? void 0 : _infantsOnLap_ages.concat(infantsOnLap1.ageTemplate) : (_infantsOnLap_ages1 = infantsOnLap1.ages) === null || _infantsOnLap_ages1 === void 0 ? void 0 : _infantsOnLap_ages1.slice(0, -1);
                    var newInfantsOnLap = _object_spread_props(_object_spread({}, infantsOnLap1), {
                        count: _object_spread_props(_object_spread({}, infantsOnLap1.count), {
                            value: action.count
                        }),
                        ages: ages2
                    });
                    var maxAllowedInfantsInSeat = newInfantsOnLap.count.value > 0 ? 0 : newInfantsOnLap.count.max;
                    var newinfantsInSeat = _object_spread_props(_object_spread({}, infantsInSeat2), {
                        count: _object_spread_props(_object_spread({}, (_infantsInSeat = infantsInSeat2) === null || _infantsInSeat === void 0 ? void 0 : _infantsInSeat.count), {
                            max: maxAllowedInfantsInSeat
                        })
                    });
                    return _object_spread_props(_object_spread({}, travelers), {
                        infantsOnLap: newInfantsOnLap,
                        infantsInSeat: newinfantsInSeat
                    });
                }
                if (((_travelers_infantsOnLap2 = travelers.infantsOnLap) === null || _travelers_infantsOnLap2 === void 0 ? void 0 : _travelers_infantsOnLap2.__typename) === "EGDSBasicTraveler") {
                    var infantsOnLap2 = travelers.infantsOnLap;
                    return _object_spread_props(_object_spread({}, travelers), {
                        infantsOnLap: _object_spread_props(_object_spread({}, infantsOnLap2), {
                            count: _object_spread_props(_object_spread({}, infantsOnLap2.count), {
                                value: action.count
                            })
                        })
                    });
                }
                return travelers;
            }
        default:
            return travelers;
    }
};
var getUpdatedChildAge = function(travelers, action) {
    var _travelers_children, _travelers_infantsInSeat, _travelers_infantsOnLap;
    if (((_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : _travelers_children.__typename) === "EGDSTravelerChildren" && action.infantType === "") {
        return _object_spread_props(_object_spread({}, travelers), {
            children: _object_spread_props(_object_spread({}, travelers.children), {
                ages: travelers.children.ages.map(function(child, ageIndex) {
                    return child.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, child), {
                        value: action.childAge
                    }) : _object_spread({}, child);
                })
            })
        });
    }
    if (((_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : _travelers_infantsInSeat.__typename) === "EGDSTravelerInfant" && action.infantType === "infants_in_seat" /* INFANTS_IN_SEAT */ ) {
        return _object_spread_props(_object_spread({}, travelers), {
            infantsInSeat: _object_spread_props(_object_spread({}, travelers.infantsInSeat), {
                ages: travelers.infantsInSeat.ages.map(function(infantInSeat, ageIndex) {
                    return infantInSeat.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, infantInSeat), {
                        value: action.childAge
                    }) : _object_spread({}, infantInSeat);
                })
            })
        });
    }
    if (((_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : _travelers_infantsOnLap.__typename) === "EGDSTravelerInfant" && action.infantType === "infants_on_lap" /* INFANTS_ON_LAP */ ) {
        return _object_spread_props(_object_spread({}, travelers), {
            infantsOnLap: _object_spread_props(_object_spread({}, travelers.infantsOnLap), {
                ages: travelers.infantsOnLap.ages.map(function(infantsOnLap, ageIndex) {
                    return infantsOnLap.__typename === "EGDSTravelerChildAgeSelect" && action.childIndex === ageIndex ? _object_spread_props(_object_spread({}, infantsOnLap), {
                        value: action.childAge
                    }) : _object_spread({}, infantsOnLap);
                })
            })
        });
    }
    return travelers;
};
var getUpdatedPetsFilter = function(travelers, action) {
    var _travelers_pets;
    if (((_travelers_pets = travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox") {
        var state = action.checked ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ ;
        return _object_spread_props(_object_spread({}, travelers), {
            pets: _object_spread_props(_object_spread({}, travelers.pets), {
                state: state
            })
        });
    }
    return travelers;
};
var travelersReducer2 = function(state, action) {
    switch(action.type){
        case "RESET_STATE":
            {
                return action.state;
            }
        case "UPDATE_TRAVELERS_COUNT":
            {
                var travelers = getUpdatedTravelersCount(state.travelers, action);
                var _state_validations;
                var error = getTravelersError2(state.error ? state.error : null, travelers, (_state_validations = state.validations) !== null && _state_validations !== void 0 ? _state_validations : []);
                return _object_spread_props(_object_spread({}, state), {
                    travelers: travelers,
                    error: error
                });
            }
        case "UPDATE_CHILD_AGE":
            {
                var travelers1 = getUpdatedChildAge(state.travelers, action);
                var _state_validations1;
                var error1 = getTravelersError2(state.error ? state.error : null, travelers1, (_state_validations1 = state.validations) !== null && _state_validations1 !== void 0 ? _state_validations1 : []);
                return _object_spread_props(_object_spread({}, state), {
                    travelers: travelers1,
                    error: error1
                });
            }
        case "UPDATE_PETS_FILTER":
            {
                var travelers2 = getUpdatedPetsFilter(state.travelers, action);
                var _state_validations2;
                var error2 = getTravelersError2(state.error ? state.error : null, travelers2, (_state_validations2 = state.validations) !== null && _state_validations2 !== void 0 ? _state_validations2 : []);
                return _object_spread_props(_object_spread({}, state), {
                    travelers: travelers2,
                    error: error2
                });
            }
        case "SHOW_ERROR":
            {
                if (state.error) {
                    var _state_error = state.error, message = _state_error.message, type = _state_error.type, errorCount = _state_error.errorCount, errorSummary2 = _state_error.errorSummary;
                    var newError = {
                        message: message,
                        type: type,
                        displayConfirmation: true,
                        errorCount: errorCount,
                        errorSummary: errorSummary2
                    };
                    return _object_spread_props(_object_spread({}, state), {
                        error: newError
                    });
                }
                return _object_spread({}, state);
            }
        default:
            return state;
    }
};
var TravelersContext2 = React32.createContext({
    state: {}
});
var BasicTravelersProvider = function(param) {
    var children = param.children, travelers = param.travelers, validations = param.validations, skipQuery = param.skipQuery;
    var _React32_useReducer = _sliced_to_array(React32.useReducer(travelersReducer2, {
        travelers: travelers,
        validations: validations
    }), 2), state = _React32_useReducer[0], dispatch = _React32_useReducer[1];
    React32.useEffect(function() {
        if (!skipQuery) {
            dispatch({
                type: "RESET_STATE",
                state: {
                    travelers: travelers,
                    validations: validations
                }
            });
        }
    }, [
        skipQuery
    ]);
    var travelersContext = React32.useMemo(function() {
        return {
            state: state,
            dispatch: dispatch
        };
    }, [
        state,
        dispatch
    ]);
    return /* @__PURE__ */ React32.createElement(TravelersContext2.Provider, {
        value: travelersContext
    }, children);
};
var useBasicTravelersContext = function() {
    return React32.useContext(TravelersContext2);
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-child-age-select.tsx
var __Fragment25 = gql26(_templateObject25(), EGDSBasicOption.fragment);
var EGDSTravelerChildAgeSelect = function(param) {
    var childIndex = param.childIndex, roomIndex = param.roomIndex, isInfant = param.isInfant, infantType = param.infantType, childAgeRef = param.childAgeRef, data = param.data;
    var _error;
    var travelersContext = useTravelersContext();
    var basicTravelersContext = useBasicTravelersContext();
    var hasRooms = roomIndex !== void 0;
    var labelTemplate = data.labelTemplate, options = data.options, egdsElementId = data.egdsElementId, value = data.value;
    var track = useClickTracker14();
    var onChange = function(event) {
        var _currentOption, _currentOption1;
        var age = parseInt(event.target.value, 10);
        var currentOption = options.find(function(option) {
            return option.__typename === "EGDSBasicOption" && option.value === event.target.value;
        });
        if (currentOption && ((_currentOption = currentOption) === null || _currentOption === void 0 ? void 0 : _currentOption.__typename) === "EGDSBasicOption" && ((_currentOption1 = currentOption) === null || _currentOption1 === void 0 ? void 0 : _currentOption1.changeAnalytics)) {
            var _currentOption_changeAnalytics = currentOption.changeAnalytics, referrerId = _currentOption_changeAnalytics.referrerId, linkName = _currentOption_changeAnalytics.linkName;
            track(referrerId, linkName);
        }
        if (!Number.isNaN(age)) {
            if (hasRooms) {
                travelersContext.dispatch({
                    type: "UPDATE_CHILD_AGE",
                    roomIndex: roomIndex,
                    childIndex: childIndex,
                    childAge: age,
                    isInfant: isInfant,
                    infantType: infantType
                });
            } else {
                basicTravelersContext.dispatch({
                    type: "UPDATE_CHILD_AGE",
                    childIndex: childIndex,
                    childAge: age,
                    infantType: infantType
                });
            }
        }
    };
    var elementName = "child-".concat(egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "", "-").concat(childIndex);
    var elementId = "age-".concat(egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "", "-").concat(childIndex);
    var childNumber = childIndex + 1;
    var childAge = value !== null && value !== void 0 ? value : "";
    var hasValidChildAge = Number.isInteger(childAge);
    var error = (hasRooms ? travelersContext.state : basicTravelersContext.state).error;
    var hasError = ((_error = error) === null || _error === void 0 ? void 0 : _error.type) === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  && error.displayConfirmation;
    var errorMessage = error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */  && !hasValidChildAge && hasError ? error.message : "";
    var label = labelTemplate.__typename === "EGDSBasicLocalizedText" && labelTemplate.models.length === 1 ? formatLocalizedTokenString(labelTemplate.template, labelTemplate.models[0].key, childNumber.toString()) : "";
    return /* @__PURE__ */ React33.createElement(UitkSelect, {
        domRef: childAgeRef,
        invalid: errorMessage,
        label: label,
        id: elementId,
        name: elementName,
        onChange: onChange,
        value: childAge,
        emptyState: typeof childAge === "string",
        required: true
    }, options.map(function(option) {
        return option.__typename === "EGDSBasicOption" && /* @__PURE__ */ React33.createElement(EGDSBasicOption, {
            key: "".concat(elementName, "-").concat(option.value),
            data: option
        });
    }));
};
EGDSTravelerChildAgeSelect.displayName = "EGDSTravelerChildAgeSelectFragment";
EGDSTravelerChildAgeSelect.fragment = __Fragment25;
EGDSTravelerChildAgeSelect.fragment.__typename = "EGDSTravelerChildAgeSelect";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-step-input.tsx
import React34 from "react";
import { gql as gql28 } from "@apollo/client";
import { useClickTracker as useClickTracker15 } from "@shared-ui/clickstream-analytics-context";
import { UitkStepInput } from "uitk-react-step-input";
// ../internal/src/components/common/egds-text/egds-localized-text-fragments.ts
import { gql as gql27 } from "@apollo/client";
var TemplateModelFragment = gql27(_templateObject26());
var EGDSBasicLocalizedTextFragment = gql27(_templateObject27(), TemplateModelFragment);
var EGDSCardinalLocalizedTextFragment = gql27(_templateObject28(), TemplateModelFragment);
var EGDSCompositeLocalizedTextFragment = gql27(_templateObject29(), TemplateModelFragment);
var EGDSLocalizedTextFragment = gql27(_templateObject30(), EGDSBasicLocalizedTextFragment, EGDSCardinalLocalizedTextFragment, EGDSCompositeLocalizedTextFragment);
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-step-input.tsx
var __Fragment26 = gql28(_templateObject31(), EGDSBasicLocalizedTextFragment);
var getStepInputText = function(textTemplate, roomIndex) {
    var _textTemplate;
    if (((_textTemplate = textTemplate) === null || _textTemplate === void 0 ? void 0 : _textTemplate.__typename) === "EGDSBasicLocalizedText") {
        var roomNumber = (roomIndex + 1).toString();
        return formatLocalizedTokenString(textTemplate.template, textTemplate.models[0].key, roomNumber);
    }
    return "";
};
var EGDSTravelersStepInput = function(param) {
    var roomIndex = param.roomIndex, travelersType = param.travelersType, data = param.data, useDefaultAgeForChildren = param.useDefaultAgeForChildren;
    var label = data.label, max = data.max, min = data.min, subLabel = data.subLabel, value = data.value;
    var travelersContext = useTravelersContext();
    var basicTravelersContext = useBasicTravelersContext();
    var clickTracker = useClickTracker15();
    var hasRooms = roomIndex !== void 0;
    var stepAddInputRef = React34.createRef();
    var stepInputTexts = data.__typename === "EGDSTravelerStepInput" && (hasRooms ? {
        incrementText: getStepInputText(data.increaseTextTemplate, roomIndex),
        decrementText: getStepInputText(data.decreaseTextTemplate, roomIndex)
    } : {
        incrementText: data.increaseText || "",
        decrementText: data.decreaseText || ""
    });
    var onChange = function(event) {
        var count = parseInt(event.target.value, 10);
        if (data.__typename === "EGDSTravelerStepInput") {
            var increaseAnalytics = data.increaseAnalytics, decreaseAnalytics = data.decreaseAnalytics;
            if (count > value && increaseAnalytics.referrerId && increaseAnalytics.linkName) {
                clickTracker(increaseAnalytics.referrerId, data.increaseAnalytics.linkName);
            } else if (decreaseAnalytics.referrerId && decreaseAnalytics.linkName) {
                clickTracker(decreaseAnalytics.referrerId, data.decreaseAnalytics.linkName);
            }
        }
        if (!Number.isNaN(count)) {
            if (hasRooms) {
                travelersContext.dispatch({
                    type: "UPDATE_TRAVELERS_COUNT",
                    travelersType: travelersType,
                    roomIndex: roomIndex,
                    count: count,
                    useDefaultAgeForChildren: useDefaultAgeForChildren
                });
            } else {
                basicTravelersContext.dispatch({
                    type: "UPDATE_TRAVELERS_COUNT",
                    travelersType: travelersType,
                    count: count,
                    useDefaultAgeForChildren: useDefaultAgeForChildren
                });
            }
        }
    };
    React34.useEffect(function() {
        if (travelersType === "adults" /* ADULTS */  && !travelersContext.state.error) {
            var _stepAddInputRef_current;
            (_stepAddInputRef_current = stepAddInputRef.current) === null || _stepAddInputRef_current === void 0 ? void 0 : _stepAddInputRef_current.focus();
        }
    }, [
        stepAddInputRef
    ]);
    var travelerId = data.__typename === "EGDSTravelerStepInput" ? "".concat(data.egdsElementId).concat(hasRooms ? "-".concat(roomIndex) : "") : "";
    return /* @__PURE__ */ React34.createElement(UitkStepInput, _object_spread_props(_object_spread({}, stepInputTexts), {
        label: label,
        incrementId: "".concat(travelerId, "-increase"),
        decrementId: "".concat(travelerId, "-decrease"),
        min: min !== null && min !== void 0 ? min : 0,
        max: max !== null && max !== void 0 ? max : 0,
        onChange: onChange,
        value: value,
        description: subLabel !== null && subLabel !== void 0 ? subLabel : "",
        id: travelerId,
        incrementRef: stepAddInputRef
    }));
};
EGDSTravelersStepInput.displayName = "EGDSTravelerStepInputFragment";
EGDSTravelersStepInput.fragment = __Fragment26;
EGDSTravelersStepInput.fragment.__typename = "EGDSTravelerStepInput";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-children.tsx
var __Fragment27 = gql29(_templateObject32(), EGDSTravelersStepInput.fragment, EGDSTravelerChildAgeSelect.fragment);
var EGDSTravelersChildren = function(param) {
    var data = param.data, childAgeRef = param.childAgeRef, roomIndex = param.roomIndex, travelersType = param.travelersType, childrenAgeMessage = param.childrenAgeMessage, includeDefaultChildAgeMessage = param.includeDefaultChildAgeMessage;
    var _data_ages;
    var count = data.count, __typename = data.__typename;
    var isInfant = travelersType === "infants" /* INFANTS */  || travelersType === "infants_on_lap" /* INFANTS_ON_LAP */  || travelersType === "infants_in_seat" /* INFANTS_IN_SEAT */ ;
    var firstChildIndexWithNoAgeValue = ((data.__typename === "EGDSTravelerInfant" || data.__typename === "EGDSTravelerChildren") && data.ages ? data.ages : []).findIndex(function(age) {
        return age.__typename === "EGDSTravelerChildAgeSelect" && age.value === null;
    });
    return /* @__PURE__ */ React35.createElement(React35.Fragment, null, count && count.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */ React35.createElement(EGDSTravelersStepInput, {
        travelersType: travelersType,
        roomIndex: roomIndex,
        data: count,
        useDefaultAgeForChildren: includeDefaultChildAgeMessage
    }), childrenAgeMessage && includeDefaultChildAgeMessage && /* @__PURE__ */ React35.createElement(UitkSpacing5, {
        padding: {
            blockstart: "four",
            blockend: "one"
        }
    }, /* @__PURE__ */ React35.createElement(UitkText, null, childrenAgeMessage)), (__typename === "EGDSTravelerChildren" || __typename === "EGDSTravelerInfant") && /* @__PURE__ */ React35.createElement(UitkLayoutFlex3, {
        wrap: "wrap"
    }, (_data_ages = data.ages) === null || _data_ages === void 0 ? void 0 : _data_ages.map(function(age, childIndex) {
        return age.__typename === "EGDSTravelerChildAgeSelect" && /* @__PURE__ */ React35.createElement(React35.Fragment, {
            key: childIndex
        }, /* @__PURE__ */ React35.createElement(UitkSpacing5, {
            padding: {
                blockstart: "two",
                inlineend: "two"
            }
        }, /* @__PURE__ */ React35.createElement(UitkLayoutFlexItem3, {
            minWidth: "half_width"
        }, /* @__PURE__ */ React35.createElement("div", null, /* @__PURE__ */ React35.createElement(EGDSTravelerChildAgeSelect, {
            key: childIndex,
            childIndex: childIndex,
            roomIndex: roomIndex,
            isInfant: isInfant,
            infantType: isInfant ? travelersType : "",
            data: age,
            childAgeRef: firstChildIndexWithNoAgeValue === childIndex ? childAgeRef : void 0
        })))));
    })));
};
EGDSTravelersChildren.displayName = "EGDSTravelersChildren";
EGDSTravelersChildren.fragment = __Fragment27;
EGDSTravelersChildren.fragment.__typename = "EGDSTravelerChildren";
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-pets.tsx
import React36 from "react";
var TravelersPets = function(param) {
    var data = param.data;
    var _pets;
    var _useBasicTravelersContext = useBasicTravelersContext(), state = _useBasicTravelersContext.state, dispatch = _useBasicTravelersContext.dispatch;
    var pets = state.travelers.pets;
    if (((_pets = pets) === null || _pets === void 0 ? void 0 : _pets.__typename) !== "EGDSBasicCheckBox") {
        return null;
    }
    var checked = pets.state === "CHECKED" /* CHECKED */ ;
    var handleOnChange = function(event) {
        dispatch({
            type: "UPDATE_PETS_FILTER",
            checked: event.currentTarget.checked
        });
    };
    return /* @__PURE__ */ React36.createElement(EGDSBasicCheckBox, {
        data: data,
        checked: checked,
        onChange: handleOnChange
    });
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers.tsx
var __Fragment28 = gql30(_templateObject33(), EGDSBasicCheckBox.fragment, EGDSTravelersChildren.fragment, EGDSTravelersStepInput.fragment);
var EGDSTravelers = function(param) {
    var childAgeRef = param.childAgeRef, infantsOnLapRef = param.infantsOnLapRef, infantsInSeatRef = param.infantsInSeatRef, data = param.data, includeDefaultChildAgeMessage = param.includeDefaultChildAgeMessage;
    var _children, _infantsInSeat, _infantsOnLap, _travelerNote, _travelerNote1, _children1, _children2, _infantsOnLap1, _infantsOnLap2, _infantsInSeat1, _infantsInSeat2, _pets;
    var adults = data.adults, children = data.children, pets = data.pets, infantsInSeat = data.infantsInSeat, infantsOnLap = data.infantsOnLap, travelerNote = data.travelerNote;
    var _children_count_value;
    var childrenCount = (_children_count_value = (_children = children) === null || _children === void 0 ? void 0 : _children.count.value) !== null && _children_count_value !== void 0 ? _children_count_value : 0;
    var _infantsInSeat_count_value;
    var infantsInSeatCount = (_infantsInSeat_count_value = (_infantsInSeat = infantsInSeat) === null || _infantsInSeat === void 0 ? void 0 : _infantsInSeat.count.value) !== null && _infantsInSeat_count_value !== void 0 ? _infantsInSeat_count_value : 0;
    var _infantsOnLap_count_value;
    var infantsOnLapCount = (_infantsOnLap_count_value = (_infantsOnLap = infantsOnLap) === null || _infantsOnLap === void 0 ? void 0 : _infantsOnLap.count.value) !== null && _infantsOnLap_count_value !== void 0 ? _infantsOnLap_count_value : 0;
    var _React37_useState = _sliced_to_array(React37.useState(""), 2), childrenAgeMessage = _React37_useState[0], setChildrenAgeMessage = _React37_useState[1];
    var _React37_useState1 = _sliced_to_array(React37.useState(""), 2), infantsOnLapAgeMessage = _React37_useState1[0], setInfantsOnLapAgeMessage = _React37_useState1[1];
    var _React37_useState2 = _sliced_to_array(React37.useState(""), 2), infantsInSeatAgeMessage = _React37_useState2[0], setInfantsInSeatAgeMessage = _React37_useState2[1];
    var singularChildAgeMessage = ((_travelerNote = travelerNote) === null || _travelerNote === void 0 ? void 0 : _travelerNote.__typename) === "EGDSCardinalLocalizedText" && travelerNote.templates[0].category === "ONE";
    var multipleChildrenAgeMessage = ((_travelerNote1 = travelerNote) === null || _travelerNote1 === void 0 ? void 0 : _travelerNote1.__typename) === "EGDSCardinalLocalizedText" && travelerNote.templates[1].category === "OTHER";
    React37.useEffect(function() {
        if (childrenCount && !infantsInSeatCount && !infantsOnLapCount) {
            setChildrenAgeMessage(getLocalizedChildAgeMessage(childrenCount));
            return;
        }
        if (childrenCount && (infantsInSeatCount || infantsOnLapCount)) {
            setChildrenAgeMessage(getLocalizedChildAgeMessage(childrenCount + (infantsInSeatCount !== null && infantsInSeatCount !== void 0 ? infantsInSeatCount : 0) + (infantsOnLapCount !== null && infantsOnLapCount !== void 0 ? infantsOnLapCount : 0)));
            return;
        }
        setChildrenAgeMessage("");
    }, [
        childrenCount,
        infantsInSeatCount,
        infantsOnLapCount
    ]);
    React37.useEffect(function() {
        if (!childrenCount && infantsInSeatCount && !infantsOnLapCount) {
            setInfantsInSeatAgeMessage(getLocalizedChildAgeMessage(infantsInSeatCount));
            return;
        }
        setInfantsInSeatAgeMessage("");
    }, [
        childrenCount,
        infantsInSeatCount,
        infantsOnLap
    ]);
    React37.useEffect(function() {
        if (!childrenCount && !infantsInSeatCount && infantsOnLapCount) {
            setInfantsOnLapAgeMessage(getLocalizedChildAgeMessage(infantsOnLapCount));
            return;
        }
        setInfantsOnLapAgeMessage("");
    }, [
        childrenCount,
        infantsInSeatCount,
        infantsOnLap
    ]);
    var getLocalizedChildAgeMessage = function(childCount) {
        if (childCount === 1 && singularChildAgeMessage) {
            return travelerNote.templates[0].template;
        }
        if (childCount > 1 && multipleChildrenAgeMessage) {
            return travelerNote.templates[1].template;
        }
        return "";
    };
    return /* @__PURE__ */ React37.createElement(React37.Fragment, null, adults.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */ React37.createElement(UitkSpacing6, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(EGDSTravelersStepInput, {
        travelersType: "adults" /* ADULTS */ ,
        data: adults
    }))), (((_children1 = children) === null || _children1 === void 0 ? void 0 : _children1.__typename) === "EGDSTravelerChildren" || ((_children2 = children) === null || _children2 === void 0 ? void 0 : _children2.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */ React37.createElement(UitkSpacing6, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(EGDSTravelersChildren, {
        travelersType: "children" /* CHILDREN */ ,
        childAgeRef: childAgeRef,
        data: children,
        childrenAgeMessage: childrenAgeMessage,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    }))), (((_infantsOnLap1 = infantsOnLap) === null || _infantsOnLap1 === void 0 ? void 0 : _infantsOnLap1.__typename) === "EGDSTravelerInfant" || ((_infantsOnLap2 = infantsOnLap) === null || _infantsOnLap2 === void 0 ? void 0 : _infantsOnLap2.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */ React37.createElement(UitkSpacing6, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(EGDSTravelersChildren, {
        travelersType: "infants_on_lap" /* INFANTS_ON_LAP */ ,
        childAgeRef: infantsOnLapRef,
        data: infantsOnLap,
        childrenAgeMessage: infantsOnLapAgeMessage,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    }))), (((_infantsInSeat1 = infantsInSeat) === null || _infantsInSeat1 === void 0 ? void 0 : _infantsInSeat1.__typename) === "EGDSTravelerInfant" || ((_infantsInSeat2 = infantsInSeat) === null || _infantsInSeat2 === void 0 ? void 0 : _infantsInSeat2.__typename) === "EGDSBasicTraveler") && /* @__PURE__ */ React37.createElement(UitkSpacing6, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(EGDSTravelersChildren, {
        travelersType: "infants_in_seat" /* INFANTS_IN_SEAT */ ,
        childAgeRef: infantsInSeatRef,
        data: infantsInSeat,
        childrenAgeMessage: infantsInSeatAgeMessage,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    }))), ((_pets = pets) === null || _pets === void 0 ? void 0 : _pets.__typename) === "EGDSBasicCheckBox" && /* @__PURE__ */ React37.createElement(UitkSpacing6, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React37.createElement("div", null, /* @__PURE__ */ React37.createElement(TravelersPets, {
        data: pets
    }))));
};
EGDSTravelers.displayName = "EGDSTravelersFragment";
EGDSTravelers.fragment = __Fragment28;
EGDSTravelers.fragment.__typename = "EGDSTravelers";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-basic-traveler-selector.tsx
var __Fragment29 = gql31(_templateObject34(), EGDSErrorSummary.fragment, EGDSPrimaryButton.fragment, EGDSTertiaryButton.fragment, EGDSTravelers.fragment);
var EGDSBasicTravelerSelector = function(param) {
    var data = param.data, onSubmit = param.onSubmit, includeDefaultChildAgeMessage = param.includeDefaultChildAgeMessage;
    var _error;
    var doneButton = data.doneButton;
    var state = useBasicTravelersContext().state;
    var childAgeRef = React38.useRef(null);
    var infantsOnLap = React38.useRef(null);
    var infantsInSeat = React38.useRef(null);
    var travelers = state.travelers, error = state.error;
    var getChildrenRef = function() {
        if (childAgeRef.current) {
            return childAgeRef;
        }
        if (infantsOnLap.current) {
            return infantsOnLap;
        }
        return infantsInSeat;
    };
    var inputErrorRef = getChildrenRef();
    var handleSubmit = function() {
        if (onSubmit) {
            onSubmit("menu");
        }
    };
    return /* @__PURE__ */ React38.createElement(UitkLayoutFlex4, {
        direction: "column"
    }, ((_error = error) === null || _error === void 0 ? void 0 : _error.displayConfirmation) && /* @__PURE__ */ React38.createElement(UitkSpacing7, {
        padding: {
            blockstart: "four"
        }
    }, /* @__PURE__ */ React38.createElement("div", null, /* @__PURE__ */ React38.createElement(EGDSErrorSummary, {
        data: error.errorSummary,
        inputErrorRef: inputErrorRef,
        errorCount: error.errorCount
    }))), /* @__PURE__ */ React38.createElement("section", null, /* @__PURE__ */ React38.createElement(EGDSTravelers, {
        data: travelers,
        childAgeRef: childAgeRef,
        infantsOnLapRef: infantsOnLap,
        infantsInSeatRef: infantsInSeat,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    })), doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React38.createElement(Viewport2, null, /* @__PURE__ */ React38.createElement(ViewMedium2, null, /* @__PURE__ */ React38.createElement(UitkSpacing7, {
        padding: {
            blockstart: "four",
            blockend: "three"
        }
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlex4, {
        justifyContent: "end"
    }, /* @__PURE__ */ React38.createElement(UitkLayoutFlexItem4, null, /* @__PURE__ */ React38.createElement(EGDSPrimaryButton, {
        isFullWidth: false,
        onClick: handleSubmit,
        data: doneButton,
        size: UitkButtonSize3.MEDIUM
    })))))));
};
EGDSBasicTravelerSelector.displayName = "EGDSBasicTravelerSelectorFragment";
EGDSBasicTravelerSelector.fragment = __Fragment29;
EGDSBasicTravelerSelector.fragment.__typename = "EGDSBasicTravelerSelector";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-rooms-traveler-selector.tsx
import React42 from "react";
import { gql as gql35 } from "@apollo/client";
import { ViewMedium as ViewMedium3, Viewport as Viewport3 } from "@shared-ui/viewport-context";
import { UitkButtonSize as UitkButtonSize4 } from "uitk-react-button";
import { UitkLayoutFlex as UitkLayoutFlex7, UitkLayoutFlexItem as UitkLayoutFlexItem7 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing10 } from "uitk-react-spacing";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-traveler-infant-seat-select.tsx
import React40 from "react";
import { gql as gql33 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex5, UitkLayoutFlexItem as UitkLayoutFlexItem5 } from "uitk-react-layout-flex";
import { UitkRadioButton, UitkRadioButtonGroup } from "uitk-react-radio-button";
import { UitkSpacing as UitkSpacing8 } from "uitk-react-spacing";
import { UitkText as UitkText3 } from "uitk-react-text";
// ../internal/src/components/common/link/egds-standard-link.tsx
import React39 from "react";
import { gql as gql32 } from "@apollo/client";
import { useClickTracker as useClickTracker16 } from "@shared-ui/clickstream-analytics-context";
import { UitkIcon as UitkIcon4 } from "uitk-react-icons";
import { UitkLink } from "uitk-react-link";
import { UitkText as UitkText2 } from "uitk-react-text";
var fragment = gql32(_templateObject35());
var _obj2;
var UILinkTargetMap = (_obj2 = {}, _define_property(_obj2, "EXTERNAL" /* EXTERNAL */ , "_blank" /* EXTERNAL */ ), _define_property(_obj2, "INTERNAL" /* INTERNAL */ , "_self" /* INTERNAL */ ), _obj2);
var EGDSStandardLink = function(param) {
    var _param_data = param.data, _param_data_action = _param_data.action, analytics = _param_data_action.analytics, resource = _param_data_action.resource, target = _param_data_action.target, accessibility = _param_data_action.accessibility, text = _param_data.text, icon = _param_data.icon, iconPosition = _param_data.iconPosition;
    var clickTracker = useClickTracker16();
    var onClick = React39.useCallback(function() {
        clickTracker(analytics.referrerId, analytics.linkName);
    }, [
        clickTracker,
        analytics
    ]);
    return /* @__PURE__ */ React39.createElement(UitkLink, {
        onClickCapture: onClick,
        inline: true
    }, /* @__PURE__ */ React39.createElement("a", {
        target: UILinkTargetMap[target],
        href: resource.value
    }, /* @__PURE__ */ React39.createElement(React39.Fragment, null, icon && iconPosition !== "TRAILING" /* TRAILING */  && /* @__PURE__ */ React39.createElement(UitkIcon4, {
        name: icon.id
    }), text, icon && iconPosition === "TRAILING" /* TRAILING */  && /* @__PURE__ */ React39.createElement(UitkIcon4, {
        name: icon.id
    }), accessibility && /* @__PURE__ */ React39.createElement(UitkText2, {
        className: "is-visually-hidden"
    }, accessibility))));
};
EGDSStandardLink.fragment = fragment;
EGDSStandardLink.displayName = "EGDSStandardLink";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-traveler-infant-seat-select.tsx
var __Fragment30 = gql33(_templateObject36(), EGDSStandardLink.fragment);
var EGDSTravelerInfantSeatSelect = function(param) {
    var data = param.data;
    var _state_infantSeatSelection;
    var _useTravelersContext = useTravelersContext(), state = _useTravelersContext.state, dispatch = _useTravelersContext.dispatch;
    var _room_infants_count_value;
    var numberOfInfants = state.rooms.reduce(function(infants, room) {
        var _room_infants_count, _room_infants;
        return infants + ((_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : (_room_infants_count = _room_infants.count) === null || _room_infants_count === void 0 ? void 0 : _room_infants_count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0);
    }, 0);
    var infantSeatSelection = (_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value;
    if (data.labelTemplate.__typename !== "EGDSCardinalLocalizedText" || numberOfInfants === 0 || !infantSeatSelection) {
        return null;
    }
    var labelTemplate = data.labelTemplate, options = data.options, airlineAgeRule = data.airlineAgeRule, groupName = data.groupName;
    var infantsSeatingText = numberOfInfants === 1 ? labelTemplate.text : labelTemplate.templates[1].template;
    var handleOnChange = function(event) {
        dispatch({
            type: "UPDATE_INFANT_SEAT_SELECTION",
            value: event.currentTarget.value
        });
    };
    return /* @__PURE__ */ React40.createElement(UitkLayoutFlex5, {
        direction: "column"
    }, /* @__PURE__ */ React40.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React40.createElement(UitkText3, null, infantsSeatingText)), /* @__PURE__ */ React40.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React40.createElement(UitkRadioButtonGroup, {
        group: groupName,
        selected: infantSeatSelection,
        onChange: handleOnChange,
        defaultChecked: true
    }, options.map(function(option, index) {
        return /* @__PURE__ */ React40.createElement(UitkSpacing8, {
            key: "radioInfant".concat(index + 1),
            margin: index === 0 ? {
                blockstart: "three"
            } : void 0
        }, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement(UitkRadioButton, {
            id: option.value,
            value: option.value
        }, option.label)));
    }))), /* @__PURE__ */ React40.createElement(UitkLayoutFlexItem5, null, /* @__PURE__ */ React40.createElement(UitkSpacing8, {
        padding: {
            blockstart: "two",
            blockend: "six"
        }
    }, /* @__PURE__ */ React40.createElement("div", null, /* @__PURE__ */ React40.createElement(EGDSStandardLink, {
        data: airlineAgeRule
    })))));
};
EGDSTravelerInfantSeatSelect.displayName = "EGDSTravelerInfantSeatSelect";
EGDSTravelerInfantSeatSelect.fragment = __Fragment30;
EGDSTravelerInfantSeatSelect.fragment.__typename = "EGDSTravelerInfantSeatSelection";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-travelers-selector-room.tsx
import React41 from "react";
import { gql as gql34 } from "@apollo/client";
import { UitkLayoutFlex as UitkLayoutFlex6, UitkLayoutFlexItem as UitkLayoutFlexItem6 } from "uitk-react-layout-flex";
import { UitkSpacing as UitkSpacing9 } from "uitk-react-spacing";
import { UitkHeading as UitkHeading3 } from "uitk-react-text";
var __Fragment31 = gql34(_templateObject37(), EGDSTravelersStepInput.fragment, EGDSTravelersChildren.fragment, EGDSTertiaryButton.fragment);
var EGDSTravelerSelectorRoom = function(param) {
    var roomIndex = param.roomIndex, childAgeRef = param.childAgeRef, data = param.data, includeDefaultChildAgeMessage = param.includeDefaultChildAgeMessage;
    var _children_ages, _travelerNote, _travelerNote1, _infants;
    var adults = data.adults, children = data.children, infants = data.infants, label = data.label, removeRoomButton = data.removeRoomButton, travelerNote = data.travelerNote;
    var _useTravelersContext = useTravelersContext(), state = _useTravelersContext.state, dispatch = _useTravelersContext.dispatch;
    var onRemoveRoom = function() {
        dispatch({
            type: "REMOVE_ROOM",
            roomIndex: roomIndex
        });
    };
    var hasChildWithNoAge = children.__typename === "EGDSTravelerChildren" && ((_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.some(function(child) {
        return child.__typename === "EGDSTravelerChildAgeSelect" && child.value === null;
    }));
    var roomNumber = roomIndex + 1;
    var isNoteAvailable = travelerNote && !!state.rooms[roomIndex].children.count;
    var childrenCount = isNoteAvailable ? state.rooms.reduce(function(count, room) {
        return count + (room.children.count.value ? room.children.count.value : 0);
    }, 0) : 0;
    var infantCount = isNoteAvailable ? state.rooms.reduce(function(count, room) {
        var _room_infants;
        return count + (((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.count.value) ? room.infants.count.value : 0);
    }, 0) : 0;
    var _React41_useState = _sliced_to_array(React41.useState(""), 2), childrenAgeMessage = _React41_useState[0], setChildrenAgeMessage = _React41_useState[1];
    var _React41_useState1 = _sliced_to_array(React41.useState(""), 2), infantsAgeMessage = _React41_useState1[0], setInfantsAgeMessage = _React41_useState1[1];
    var singularChildAgeMessage = ((_travelerNote = travelerNote) === null || _travelerNote === void 0 ? void 0 : _travelerNote.__typename) === "EGDSCardinalLocalizedText" && travelerNote.templates[0].category === "ONE";
    var multipleChildrenAgeMessage = ((_travelerNote1 = travelerNote) === null || _travelerNote1 === void 0 ? void 0 : _travelerNote1.__typename) === "EGDSCardinalLocalizedText" && travelerNote.templates[1].category === "OTHER";
    React41.useEffect(function() {
        if (childrenCount && !infantCount) {
            setChildrenAgeMessage(getLocalizedChildAgeMessage(childrenCount));
            return;
        }
        if (childrenCount && infantCount) {
            setChildrenAgeMessage(getLocalizedChildAgeMessage(childrenCount + infantCount));
            return;
        }
        setChildrenAgeMessage("");
    }, [
        childrenCount,
        infantCount
    ]);
    React41.useEffect(function() {
        if (!childrenCount && infantCount) {
            setInfantsAgeMessage(getLocalizedChildAgeMessage(infantCount));
            return;
        }
        setInfantsAgeMessage("");
    }, [
        childrenCount,
        infantCount
    ]);
    var getLocalizedChildAgeMessage = function(childCount) {
        if (childCount === 1 && singularChildAgeMessage) {
            return travelerNote.templates[0].template;
        }
        if (childCount > 1 && multipleChildrenAgeMessage) {
            return travelerNote.templates[1].template;
        }
        return "";
    };
    return /* @__PURE__ */ React41.createElement(React41.Fragment, null, label.__typename === "EGDSBasicLocalizedText" && label.models.length === 1 && /* @__PURE__ */ React41.createElement(UitkHeading3, {
        size: 7
    }, formatLocalizedTokenString(label.template, label.models[0].key, roomNumber.toString())), adults.__typename === "EGDSTravelerStepInput" && /* @__PURE__ */ React41.createElement(UitkSpacing9, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(EGDSTravelersStepInput, {
        travelersType: "adults" /* ADULTS */ ,
        roomIndex: roomIndex,
        data: adults
    }))), children.__typename === "EGDSTravelerChildren" && /* @__PURE__ */ React41.createElement(UitkSpacing9, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(EGDSTravelersChildren, {
        travelersType: "children" /* CHILDREN */ ,
        roomIndex: roomIndex,
        childAgeRef: childAgeRef,
        data: children,
        childrenAgeMessage: childrenAgeMessage,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    }))), ((_infants = infants) === null || _infants === void 0 ? void 0 : _infants.__typename) === "EGDSTravelerInfant" && /* @__PURE__ */ React41.createElement(UitkSpacing9, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React41.createElement("div", null, /* @__PURE__ */ React41.createElement(EGDSTravelersChildren, {
        travelersType: "infants" /* INFANTS */ ,
        roomIndex: roomIndex,
        childAgeRef: hasChildWithNoAge ? void 0 : childAgeRef,
        data: infants,
        childrenAgeMessage: infantsAgeMessage,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    }))), state.rooms.length > 1 && removeRoomButton && removeRoomButton.__typename === "UITertiaryButton" && /* @__PURE__ */ React41.createElement(UitkSpacing9, {
        padding: {
            blockstart: "two"
        }
    }, /* @__PURE__ */ React41.createElement(UitkLayoutFlex6, {
        justifyContent: "end"
    }, /* @__PURE__ */ React41.createElement(UitkLayoutFlexItem6, null, /* @__PURE__ */ React41.createElement(EGDSTertiaryButton, {
        onClick: onRemoveRoom,
        data: removeRoomButton
    })))));
};
EGDSTravelerSelectorRoom.displayName = "EGDSTravelerSelectorRoomFragment";
EGDSTravelerSelectorRoom.fragment = __Fragment31;
EGDSTravelerSelectorRoom.fragment.__typename = "EGDSTravelerSelectorRoom";
// ../internal/src/components/form/egds-search-form-travelers-field/egds-rooms-traveler-selector.tsx
var __Fragment32 = gql35(_templateObject38(), EGDSErrorSummary.fragment, EGDSPrimaryButton.fragment, EGDSTertiaryButton.fragment, EGDSTravelerSelectorRoom.fragment, EGDSTravelerInfantSeatSelect.fragment);
var EGDSRoomsTravelerSelector = function(param) {
    var data = param.data, onSubmit = param.onSubmit, includeDefaultChildAgeMessage = param.includeDefaultChildAgeMessage;
    var _error;
    var addAnotherRoomButton = data.addAnotherRoomButton, doneButton = data.doneButton, maxRoomCount = data.maxRoomCount, infantSeatSelection = data.infantSeatSelection;
    var _useTravelersContext = useTravelersContext(), state = _useTravelersContext.state, dispatch = _useTravelersContext.dispatch;
    var childAgeRef = React42.useRef(null);
    var rooms = state.rooms, error = state.error;
    var _React42_useState = _sliced_to_array(React42.useState(rooms), 2), setRoom = _React42_useState[1];
    React42.useEffect(function() {
        setRoom(rooms);
    }, [
        rooms
    ]);
    if (rooms.length < 1) {
        return null;
    }
    var onAddRoom = function() {
        dispatch({
            type: "ADD_ROOM"
        });
    };
    var handleSubmit = function() {
        if (onSubmit) {
            onSubmit("menu");
        }
    };
    var addNewRoomButton = _object_spread_props(_object_spread({}, addAnotherRoomButton), {
        disabled: maxRoomCount ? rooms.length >= maxRoomCount : false
    });
    var firstRoomIndexWithNoChildAgeValue = rooms.findIndex(function(room) {
        var _room_children, _room_children1, _room_infants, _room_infants1;
        var _ref;
        return room.children.__typename === "EGDSTravelerChildren" && ((_room_children = room.children) === null || _room_children === void 0 ? void 0 : _room_children.ages) && ((_room_children1 = room.children) === null || _room_children1 === void 0 ? void 0 : _room_children1.ages.some(function(child) {
            return child.__typename === "EGDSTravelerChildAgeSelect" && child.value === null;
        })) || ((_ref = ((_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : _room_infants.__typename) === "EGDSTravelerInfant" && ((_room_infants1 = room.infants) === null || _room_infants1 === void 0 ? void 0 : _room_infants1.ages.some(function(infant) {
            return infant.__typename === "EGDSTravelerChildAgeSelect" && infant.value === null;
        }))) !== null && _ref !== void 0 ? _ref : false);
    });
    var actionButton = doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React42.createElement(UitkSpacing10, {
        padding: {
            blockstart: "four",
            blockend: "three"
        }
    }, /* @__PURE__ */ React42.createElement(UitkLayoutFlex7, {
        justifyContent: "end"
    }, /* @__PURE__ */ React42.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React42.createElement(EGDSPrimaryButton, {
        isFullWidth: false,
        onClick: handleSubmit,
        data: doneButton,
        size: UitkButtonSize4.MEDIUM
    }))));
    return /* @__PURE__ */ React42.createElement(UitkLayoutFlex7, {
        direction: "column"
    }, ((_error = error) === null || _error === void 0 ? void 0 : _error.displayConfirmation) && /* @__PURE__ */ React42.createElement(EGDSErrorSummary, {
        data: error.errorSummary,
        inputErrorRef: childAgeRef,
        errorCount: error.errorCount
    }), /* @__PURE__ */ React42.createElement("section", null, rooms.map(function(room, roomIndex) {
        var _error;
        return /* @__PURE__ */ React42.createElement(UitkSpacing10, {
            padding: {
                blockstart: ((_error = error) === null || _error === void 0 ? void 0 : _error.displayConfirmation) ? "two" : "unset"
            },
            key: roomIndex
        }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(EGDSTravelerSelectorRoom, {
            roomIndex: roomIndex,
            data: room,
            childAgeRef: firstRoomIndexWithNoChildAgeValue === roomIndex ? childAgeRef : void 0,
            includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
        })));
    }), addNewRoomButton.__typename === "UITertiaryButton" && /* @__PURE__ */ React42.createElement(UitkSpacing10, {
        padding: {
            small: {
                blockstart: "two",
                blockend: "sixteen"
            },
            medium: {
                blockend: "unset"
            }
        }
    }, /* @__PURE__ */ React42.createElement(UitkLayoutFlex7, {
        justifyContent: "end"
    }, /* @__PURE__ */ React42.createElement(UitkLayoutFlexItem7, null, /* @__PURE__ */ React42.createElement(EGDSTertiaryButton, {
        onClick: onAddRoom,
        data: addNewRoomButton
    })))), infantSeatSelection && /* @__PURE__ */ React42.createElement(UitkSpacing10, {
        padding: {
            blockstart: "twelve"
        }
    }, /* @__PURE__ */ React42.createElement("div", null, /* @__PURE__ */ React42.createElement(EGDSTravelerInfantSeatSelect, {
        data: infantSeatSelection
    })))), /* @__PURE__ */ React42.createElement(Viewport3, null, /* @__PURE__ */ React42.createElement(ViewMedium3, null, /* @__PURE__ */ React42.createElement("div", null, actionButton))));
};
EGDSRoomsTravelerSelector.displayName = "EGDSTravelerSelectorFragment";
EGDSRoomsTravelerSelector.fragment = __Fragment32;
EGDSRoomsTravelerSelector.fragment.__typename = "EGDSRoomsTravelerSelector";
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-field-triggers.tsx
import React43 from "react";
import { useClickTracker as useClickTracker17 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog3 } from "@shared-ui/dialog-context";
import { ViewLarge, ViewMedium as ViewMedium4, Viewport as Viewport4, ViewSmall as ViewSmall2 } from "@shared-ui/viewport-context";
import { UitkForm, useFormCallback as useFormCallback7 } from "uitk-react-form";
import { UitkFakeInput } from "uitk-react-input";
import { PositionType, UitkMenu, UitkMenuContainer, UitkMenuTrigger } from "uitk-react-menu";
import { UitkSheet, UitkSheetContent } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing11 } from "uitk-react-spacing";
import { UitkToolbar } from "uitk-react-toolbar";
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-summary.ts
var formatCardinalText2 = function(cardinalText, value) {
    var useSecondaryTemplates = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var templateKey = useSecondaryTemplates ? "secondaryTemplates" : "templates";
    var cardinalTemplate = cardinalText[templateKey].find(function(template) {
        return template.category === getPluralCategory(value);
    });
    if (!cardinalTemplate) {
        return "";
    }
    return formatLocalizedTokenString(cardinalTemplate.template, cardinalText.models[0].key, value.toString());
};
var formatCompositeText = function(compositeText) {
    for(var _len = arguments.length, keysToReplace = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        keysToReplace[_key - 1] = arguments[_key];
    }
    var models = compositeText.models, template = compositeText.template;
    var formattedTexts = models.map(function(model, index) {
        return model.models.__typename === "EGDSCardinalLocalizedText" ? formatCardinalText2(model.models, keysToReplace[index]) : "";
    });
    return models.reduce(function(prev, model, index) {
        return formatLocalizedTokenString(prev, model.key, formattedTexts[index]);
    }, template);
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-basic-field-triggers.tsx
var BASE_TRAVELERS_FIELD_PREFIX = "EGDSSearchFormTravelersField-";
var ADULT_COUNT_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "Adult");
var CHILDREN_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "ChildrenAge");
var INFANT_IN_SEAT_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "InfantInSeatAge");
var INFANT_ON_LAP_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "InfantOnLapAge");
var PETS_STATE_NAME_PREFIX = "".concat(BASE_TRAVELERS_FIELD_PREFIX, "Pets");
var ChildrenHiddenInputs = function(param) {
    var ages = param.ages, prefix = param.prefix;
    return /* @__PURE__ */ React43.createElement(React43.Fragment, null, ages.map(function(age, index) {
        if (age.__typename === "EGDSTravelerChildAgeSelect") {
            var childNumber = index + 1;
            var name = "".concat(prefix, "-").concat(childNumber);
            var _age_value;
            return /* @__PURE__ */ React43.createElement("input", {
                key: index,
                type: "hidden",
                "data-stid": name,
                name: name,
                value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
            });
        }
        return null;
    }));
};
var BasicTravelersFieldTriggers = function(param) {
    var label = param.label, leftIcon = param.leftIcon, action = param.action, labelTemplate = param.labelTemplate, readOnly = param.readOnly, isAnyPetAllowed = param.isAnyPetAllowed, includeDefaultChildAgeMessage = param.includeDefaultChildAgeMessage, onOpenTravelerField = param.onOpenTravelerField;
    var _labelTemplate, _children, _children1, _infantsInSeat, _infantsInSeat1, _infantsOnLap, _infantsOnLap1, _pets;
    var analytics = action.analytics, travelerSelector2 = action.travelerSelector;
    var doneButton = travelerSelector2.doneButton;
    var track = useClickTracker17();
    var _useBasicTravelersContext = useBasicTravelersContext(), dispatch = _useBasicTravelersContext.dispatch, state = _useBasicTravelersContext.state;
    var _useDialog3 = _sliced_to_array(useDialog3("travelerSelectorDialog"), 3), dialogActions = _useDialog3[1], TravelerSelectorDialogWrapper = _useDialog3[2];
    var triggerRef = React43.useRef(null);
    var _React43_useState = _sliced_to_array(React43.useState(false), 2), showMenu = _React43_useState[0], setShowMenu = _React43_useState[1];
    var _React43_useState1 = _sliced_to_array(React43.useState(state), 2), initialState = _React43_useState1[0], setInitialState = _React43_useState1[1];
    var _labelTemplate_text;
    var _React43_useState2 = _sliced_to_array(React43.useState((_labelTemplate_text = (_labelTemplate = labelTemplate) === null || _labelTemplate === void 0 ? void 0 : _labelTemplate.text) !== null && _labelTemplate_text !== void 0 ? _labelTemplate_text : ""), 2), travelersSummary = _React43_useState2[0], setTravelersSummary = _React43_useState2[1];
    var error = state.error;
    var handleChange = useFormCallback7(travelerSelector2.__typename, function(event) {
        return event;
    });
    var formatTravelerSummary = function(travelers) {
        var _travelers_adults, _travelers_children_count, _travelers_children, _travelers_infantsInSeat_count, _travelers_infantsInSeat, _travelers_infantsOnLap_count, _travelers_infantsOnLap, _travelers_pets, _travelers;
        var _travelers_adults_value;
        var adultCount = (_travelers_adults_value = (_travelers_adults = travelers.adults) === null || _travelers_adults === void 0 ? void 0 : _travelers_adults.value) !== null && _travelers_adults_value !== void 0 ? _travelers_adults_value : 0;
        var _travelers_children_count_value;
        var childrenCount = (_travelers_children_count_value = (_travelers_children = travelers.children) === null || _travelers_children === void 0 ? void 0 : (_travelers_children_count = _travelers_children.count) === null || _travelers_children_count === void 0 ? void 0 : _travelers_children_count.value) !== null && _travelers_children_count_value !== void 0 ? _travelers_children_count_value : 0;
        var _travelers_infantsInSeat_count_value;
        var infantsInSeatCount = (_travelers_infantsInSeat_count_value = (_travelers_infantsInSeat = travelers.infantsInSeat) === null || _travelers_infantsInSeat === void 0 ? void 0 : (_travelers_infantsInSeat_count = _travelers_infantsInSeat.count) === null || _travelers_infantsInSeat_count === void 0 ? void 0 : _travelers_infantsInSeat_count.value) !== null && _travelers_infantsInSeat_count_value !== void 0 ? _travelers_infantsInSeat_count_value : 0;
        var _travelers_infantsOnLap_count_value;
        var infantsOnLapCount = (_travelers_infantsOnLap_count_value = (_travelers_infantsOnLap = travelers.infantsOnLap) === null || _travelers_infantsOnLap === void 0 ? void 0 : (_travelers_infantsOnLap_count = _travelers_infantsOnLap.count) === null || _travelers_infantsOnLap_count === void 0 ? void 0 : _travelers_infantsOnLap_count.value) !== null && _travelers_infantsOnLap_count_value !== void 0 ? _travelers_infantsOnLap_count_value : 0;
        var travelersCount = adultCount + childrenCount + infantsInSeatCount + infantsOnLapCount;
        var isPetsChecked = ((_travelers = travelers) === null || _travelers === void 0 ? void 0 : (_travelers_pets = _travelers.pets) === null || _travelers_pets === void 0 ? void 0 : _travelers_pets.__typename) === "EGDSBasicCheckBox" && travelers.pets.state === "CHECKED" /* CHECKED */ ;
        return formatCardinalText2(labelTemplate, travelersCount, isPetsChecked);
    };
    React43.useEffect(function() {
        var _initialState_travelers_pets;
        if (isAnyPetAllowed !== void 0) {
            dispatch({
                type: "UPDATE_PETS_FILTER",
                checked: isAnyPetAllowed
            });
        }
        if (((_initialState_travelers_pets = initialState.travelers.pets) === null || _initialState_travelers_pets === void 0 ? void 0 : _initialState_travelers_pets.__typename) === "EGDSBasicCheckBox") {
            var dataTravelersPetsState = isAnyPetAllowed ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ ;
            var newState = _object_spread_props(_object_spread({}, initialState), {
                travelers: _object_spread_props(_object_spread({}, initialState.travelers), {
                    pets: _object_spread_props(_object_spread({}, initialState.travelers.pets), {
                        state: dataTravelersPetsState
                    })
                })
            });
            setInitialState(newState);
        }
    }, [
        isAnyPetAllowed
    ]);
    React43.useEffect(function() {
        setTravelersSummary(formatTravelerSummary(state.travelers));
    }, [
        state.travelers
    ]);
    if (travelerSelector2.__typename !== "EGDSBasicTravelerSelector") {
        return null;
    }
    var onTriggerClick = function() {
        if (onOpenTravelerField) {
            onOpenTravelerField();
        }
        setShowMenu(function(prevState) {
            return !prevState;
        });
        if (analytics.referrerId && analytics.linkName) {
            track(analytics.referrerId, analytics.linkName);
        }
    };
    var onDismissMenu = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.error) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch({
                                type: "SHOW_ERROR"
                            })
                        ];
                    case 1:
                        _state.sent();
                        setShowMenu(true);
                        _state.label = 2;
                    case 2:
                        if (!state.error) {
                            triggerInputChangeEvent("submit", handleChange);
                        }
                        return [
                            2
                        ];
                }
            });
        });
        return function onDismissMenu() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClick = function() {
        if (onOpenTravelerField) {
            onOpenTravelerField();
        }
        dialogActions.openDialog();
        if (analytics.referrerId && analytics.linkName) {
            track(analytics.referrerId, analytics.linkName);
        }
    };
    var onDismissDialog = function() {
        if ((travelerSelector2.closeButton.__typename === "UIPrimaryButton" || travelerSelector2.closeButton.__typename === "UITertiaryButton") && travelerSelector2.closeButton.analytics) {
            var _travelerSelector2_closeButton_analytics = travelerSelector2.closeButton.analytics, referrerId = _travelerSelector2_closeButton_analytics.referrerId, linkName = _travelerSelector2_closeButton_analytics.linkName;
            track(referrerId, linkName);
        }
        dispatch({
            type: "RESET_STATE",
            state: initialState
        });
        dialogActions.closeDialog();
    };
    var updateTravelerSummary = function(travelers) {
        var travelersValue = formatTravelerSummary(travelers);
        triggerInputChangeEvent(travelersValue, handleChange);
        setTravelersSummary(travelersValue);
    };
    var onSaveMenu = function(newState) {
        var _triggerRef_current;
        updateTravelerSummary(newState.travelers);
        setInitialState(newState);
        setShowMenu(function(prevState) {
            return !prevState;
        });
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    };
    var onSaveDialog = function(newState) {
        var _triggerRef_current;
        updateTravelerSummary(newState.travelers);
        setInitialState(newState);
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        dialogActions.closeDialog();
    };
    var handleSubmit = function(triggerType) {
        var _doneButton;
        if (doneButton.__typename === "UIPrimaryButton" && ((_doneButton = doneButton) === null || _doneButton === void 0 ? void 0 : _doneButton.analytics)) {
            track(doneButton.analytics.referrerId, doneButton.analytics.linkName);
        }
        if (error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ) {
            var _error_errorSummary;
            dispatch({
                type: "SHOW_ERROR"
            });
            if ((_error_errorSummary = error.errorSummary) === null || _error_errorSummary === void 0 ? void 0 : _error_errorSummary.impressionAnalytics) {
                var referrerId = "".concat(error.errorSummary.impressionAnalytics.referrerId, ".For.NoChildAgeSubmit");
                var linkName = error.errorSummary.impressionAnalytics.linkName || "";
                track(referrerId, linkName);
            }
        }
        if (!error) {
            if (triggerType === "menu") {
                onSaveMenu(state);
            } else {
                onSaveDialog(state);
            }
        }
    };
    var _state_travelers = state.travelers, adults = _state_travelers.adults, children = _state_travelers.children, pets = _state_travelers.pets, infantsInSeat = _state_travelers.infantsInSeat, infantsOnLap = _state_travelers.infantsOnLap;
    var _travelerSelector2_closeButton_accessibility;
    return /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement(Viewport4, null, /* @__PURE__ */ React43.createElement(ViewLarge, null, /* @__PURE__ */ React43.createElement(UitkMenu, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React43.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React43.createElement(UitkFakeInput, {
        label: label,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef
    })), /* @__PURE__ */ React43.createElement(UitkMenuContainer, {
        autoPosition: true,
        position: PositionType.RIGHT,
        width: 375
    }, /* @__PURE__ */ React43.createElement(UitkSpacing11, {
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(EGDSBasicTravelerSelector, {
        onSubmit: handleSubmit,
        data: travelerSelector2,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    })))))), /* @__PURE__ */ React43.createElement(ViewMedium4, null, /* @__PURE__ */ React43.createElement(UitkMenu, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React43.createElement(UitkMenuTrigger, null, /* @__PURE__ */ React43.createElement(UitkFakeInput, {
        label: label,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef
    })), /* @__PURE__ */ React43.createElement(UitkMenuContainer, {
        autoPosition: true,
        position: PositionType.LEFT,
        width: 375
    }, /* @__PURE__ */ React43.createElement(UitkSpacing11, {
        padding: {
            inline: "six"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(EGDSBasicTravelerSelector, {
        onSubmit: handleSubmit,
        data: travelerSelector2,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    })))))), /* @__PURE__ */ React43.createElement(ViewSmall2, null, /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement(UitkFakeInput, {
        label: label,
        value: travelersSummary,
        onClick: onClick,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef
    }), /* @__PURE__ */ React43.createElement(TravelerSelectorDialogWrapper, null, /* @__PURE__ */ React43.createElement(UitkSheet, {
        type: "full",
        triggerRef: triggerRef,
        isVisible: true,
        returnFocusOnClose: true
    }, /* @__PURE__ */ React43.createElement(UitkToolbar, {
        toolbarTitle: travelerSelector2.title,
        navigationContent: {
            navType: "close",
            navIconLabel: travelerSelector2.closeButton.__typename === "UIPrimaryButton" ? (_travelerSelector2_closeButton_accessibility = travelerSelector2.closeButton.accessibility) !== null && _travelerSelector2_closeButton_accessibility !== void 0 ? _travelerSelector2_closeButton_accessibility : "" : "",
            onClick: onDismissDialog
        }
    }), /* @__PURE__ */ React43.createElement(UitkSheetContent, {
        padded: false
    }, /* @__PURE__ */ React43.createElement(UitkSpacing11, {
        padding: {
            blockstart: "four",
            blockend: "sixteen",
            inline: "six"
        }
    }, /* @__PURE__ */ React43.createElement("div", null, /* @__PURE__ */ React43.createElement(UitkForm, {
        hasRequiredFieldIndicator: true
    }, /* @__PURE__ */ React43.createElement(EGDSBasicTravelerSelector, {
        data: travelerSelector2,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    }))))), doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React43.createElement(EGDSPrimaryButton, {
        floating: true,
        onClick: handleSubmit,
        data: doneButton
    })))))), /* @__PURE__ */ React43.createElement(React43.Fragment, null, /* @__PURE__ */ React43.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(ADULT_COUNT_NAME_PREFIX),
        name: "".concat(ADULT_COUNT_NAME_PREFIX),
        value: adults.value
    }), ((_children = children) === null || _children === void 0 ? void 0 : _children.__typename) === "EGDSTravelerChildren" && children.ages && /* @__PURE__ */ React43.createElement(ChildrenHiddenInputs, {
        ages: children.ages,
        prefix: CHILDREN_NAME_PREFIX
    }), ((_children1 = children) === null || _children1 === void 0 ? void 0 : _children1.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */ React43.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(CHILDREN_NAME_PREFIX),
        name: "".concat(CHILDREN_NAME_PREFIX),
        value: children.count.value
    }), ((_infantsInSeat = infantsInSeat) === null || _infantsInSeat === void 0 ? void 0 : _infantsInSeat.__typename) === "EGDSTravelerInfant" && infantsInSeat.ages && /* @__PURE__ */ React43.createElement(ChildrenHiddenInputs, {
        ages: infantsInSeat.ages,
        prefix: INFANT_IN_SEAT_NAME_PREFIX
    }), ((_infantsInSeat1 = infantsInSeat) === null || _infantsInSeat1 === void 0 ? void 0 : _infantsInSeat1.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */ React43.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(INFANT_IN_SEAT_NAME_PREFIX),
        name: "".concat(INFANT_IN_SEAT_NAME_PREFIX),
        value: infantsInSeat.count.value
    }), ((_infantsOnLap = infantsOnLap) === null || _infantsOnLap === void 0 ? void 0 : _infantsOnLap.__typename) === "EGDSTravelerInfant" && infantsOnLap.ages && /* @__PURE__ */ React43.createElement(ChildrenHiddenInputs, {
        ages: infantsOnLap.ages,
        prefix: INFANT_ON_LAP_NAME_PREFIX
    }), ((_infantsOnLap1 = infantsOnLap) === null || _infantsOnLap1 === void 0 ? void 0 : _infantsOnLap1.__typename) === "EGDSBasicTraveler" && /* @__PURE__ */ React43.createElement("input", {
        type: "hidden",
        "data-stid": "".concat(INFANT_ON_LAP_NAME_PREFIX),
        name: "".concat(INFANT_ON_LAP_NAME_PREFIX),
        value: infantsOnLap.count.value
    }), ((_pets = pets) === null || _pets === void 0 ? void 0 : _pets.__typename) === "EGDSBasicCheckBox" && /* @__PURE__ */ React43.createElement("input", {
        type: "hidden",
        name: "".concat(PETS_STATE_NAME_PREFIX),
        value: pets.state
    })));
};
// ../internal/src/components/form/egds-search-form-travelers-field/travelers-field-triggers.tsx
import React44 from "react";
import { useClickTracker as useClickTracker18 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog4 } from "@shared-ui/dialog-context";
import { ViewLarge as ViewLarge2, ViewMedium as ViewMedium5, Viewport as Viewport5, ViewSizes as ViewSizes2, ViewSmall as ViewSmall3 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm2, useFormCallback as useFormCallback8 } from "uitk-react-form";
import { UitkFakeInput as UitkFakeInput2 } from "uitk-react-input";
import { PositionType as PositionType2, UitkMenu as UitkMenu2, UitkMenuContainer as UitkMenuContainer2, UitkMenuTrigger as UitkMenuTrigger2 } from "uitk-react-menu";
import { UitkSheet as UitkSheet2, UitkSheetContent as UitkSheetContent2 } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing12 } from "uitk-react-spacing";
import { UitkToolbar as UitkToolbar2 } from "uitk-react-toolbar";
var BASE_TRAVELERS_FIELD_PREFIX2 = "EGDSSearchFormTravelersField";
var ADULT_COUNT_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-Adult");
var CHILDREN_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-ChildrenAge");
var INFANT_IN_SEAT_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-InfantInSeatAge");
var INFANT_ON_LAP_NAME_PREFIX2 = "".concat(BASE_TRAVELERS_FIELD_PREFIX2, "-InfantOnLapAge");
var TravelersFieldTriggers = function(param) {
    var label = param.label, leftIcon = param.leftIcon, action = param.action, labelTemplate = param.labelTemplate, readOnly = param.readOnly, retainTravelerOnDialogDismiss = param.retainTravelerOnDialogDismiss, includeDefaultChildAgeMessage = param.includeDefaultChildAgeMessage, onOpenTravelerField = param.onOpenTravelerField;
    var _labelTemplate;
    var analytics = action.analytics, travelerSelector2 = action.travelerSelector;
    var doneButton = travelerSelector2.doneButton;
    var track = useClickTracker18();
    var _useTravelersContext = useTravelersContext(), dispatch = _useTravelersContext.dispatch, state = _useTravelersContext.state;
    var error = state.error;
    var _useDialog4 = _sliced_to_array(useDialog4("travelerSelectorDialog"), 3), dialogActions = _useDialog4[1], TravelerSelectorDialogWrapper = _useDialog4[2];
    var triggerRef = React44.useRef(null);
    var _React44_useState = _sliced_to_array(React44.useState(false), 2), showMenu = _React44_useState[0], setShowMenu = _React44_useState[1];
    var _React44_useState1 = _sliced_to_array(React44.useState(state), 2), initialState = _React44_useState1[0], setInitialState = _React44_useState1[1];
    var _labelTemplate_text;
    var _React44_useState2 = _sliced_to_array(React44.useState((_labelTemplate_text = (_labelTemplate = labelTemplate) === null || _labelTemplate === void 0 ? void 0 : _labelTemplate.text) !== null && _labelTemplate_text !== void 0 ? _labelTemplate_text : ""), 2), travelersSummary = _React44_useState2[0], setTravelersSummary = _React44_useState2[1];
    var handleChange = useFormCallback8(travelerSelector2.__typename, function(event) {
        return event;
    });
    var formatTravelerSummary = function(rooms) {
        var travelersCount = rooms.reduce(function(count, room) {
            var _room_adults, _room_children_count, _room_children, _room_infants_count, _room_infants;
            var _room_adults_value;
            var adultsCount = (_room_adults_value = (_room_adults = room.adults) === null || _room_adults === void 0 ? void 0 : _room_adults.value) !== null && _room_adults_value !== void 0 ? _room_adults_value : 0;
            var _room_children_count_value;
            var childrenCount = (_room_children_count_value = (_room_children = room.children) === null || _room_children === void 0 ? void 0 : (_room_children_count = _room_children.count) === null || _room_children_count === void 0 ? void 0 : _room_children_count.value) !== null && _room_children_count_value !== void 0 ? _room_children_count_value : 0;
            var _room_infants_count_value;
            var infantsCount = (_room_infants_count_value = (_room_infants = room.infants) === null || _room_infants === void 0 ? void 0 : (_room_infants_count = _room_infants.count) === null || _room_infants_count === void 0 ? void 0 : _room_infants_count.value) !== null && _room_infants_count_value !== void 0 ? _room_infants_count_value : 0;
            return count + adultsCount + childrenCount + infantsCount;
        }, 0);
        return formatCompositeText(labelTemplate, rooms.length, travelersCount);
    };
    React44.useEffect(function() {
        setTravelersSummary(formatTravelerSummary(state.rooms));
        if (action.travelerSelector.__typename === "EGDSRoomsTravelerSelector") {
            if (action.travelerSelector.rooms[0].infants !== initialState.rooms[0].infants) {
                dispatch({
                    type: "RESET_ROOMS",
                    state: _object_spread_props(_object_spread({}, state), {
                        rooms: action.travelerSelector.rooms
                    })
                });
                setInitialState(_object_spread_props(_object_spread({}, state), {
                    rooms: action.travelerSelector.rooms
                }));
                setTravelersSummary(formatTravelerSummary(action.travelerSelector.rooms));
            }
        }
    }, [
        action.travelerSelector
    ]);
    if (travelerSelector2.__typename !== "EGDSRoomsTravelerSelector") {
        return null;
    }
    var onTriggerClick = function() {
        setShowMenu(function(prevState) {
            return !prevState;
        });
        if (onOpenTravelerField) {
            onOpenTravelerField();
        }
        track(analytics.referrerId, analytics.linkName);
    };
    var onDismissMenu = function() {
        var _ref = _async_to_generator(function() {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!state.error) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            dispatch({
                                type: "SHOW_ERROR"
                            })
                        ];
                    case 1:
                        _state.sent();
                        setShowMenu(true);
                        _state.label = 2;
                    case 2:
                        if (!state.error) {
                            triggerInputChangeEvent("submit", handleChange);
                        }
                        setTravelersSummary(formatTravelerSummary(state.rooms));
                        return [
                            2
                        ];
                }
            });
        });
        return function onDismissMenu() {
            return _ref.apply(this, arguments);
        };
    }();
    var onClick = function() {
        dialogActions.openDialog();
        track(analytics.referrerId, analytics.linkName);
        if (onOpenTravelerField) {
            onOpenTravelerField(ViewSizes2.SMALL);
        }
    };
    var updateTravelerSummary = function(rooms) {
        var travelersValue = formatTravelerSummary(rooms);
        triggerInputChangeEvent(travelersValue, handleChange);
        setTravelersSummary(travelersValue);
    };
    var onSaveMenu = function(newState) {
        var _triggerRef_current;
        updateTravelerSummary(newState.rooms);
        setInitialState(newState);
        setShowMenu(function(prevState) {
            return !prevState;
        });
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
    };
    var onSaveDialog = function(newState) {
        var _triggerRef_current;
        updateTravelerSummary(newState.rooms);
        setInitialState(newState);
        (_triggerRef_current = triggerRef.current) === null || _triggerRef_current === void 0 ? void 0 : _triggerRef_current.focus();
        dialogActions.closeDialog();
    };
    var validateSelector = function(event) {
        if (error && error.type === "CHILD_AGE_REQUIRED" /* CHILD_AGE_REQUIRED */ ) {
            if (event) {
                event.preventDefault();
            }
            dispatch({
                type: "SHOW_ERROR"
            });
        }
    };
    var onDismissDialog = function() {
        if ((travelerSelector2.closeButton.__typename === "UIPrimaryButton" || travelerSelector2.closeButton.__typename === "UITertiaryButton") && travelerSelector2.closeButton.analytics) {
            var _travelerSelector2_closeButton_analytics = travelerSelector2.closeButton.analytics, referrerId = _travelerSelector2_closeButton_analytics.referrerId, linkName = _travelerSelector2_closeButton_analytics.linkName;
            if (retainTravelerOnDialogDismiss && !error) {
                track(referrerId, "Travelers results updated");
            } else {
                track(referrerId, linkName);
            }
        }
        validateSelector();
        if (retainTravelerOnDialogDismiss && !error) {
            onSaveDialog(state);
        } else if (!error) {
            dispatch({
                type: "RESET_STATE",
                state: initialState
            });
            dialogActions.closeDialog();
        }
    };
    var handleSubmit = function(triggerType) {
        if (doneButton.__typename === "UIPrimaryButton" && doneButton.analytics) {
            var _doneButton_analytics = doneButton.analytics, linkName = _doneButton_analytics.linkName, referrerId = _doneButton_analytics.referrerId;
            track(referrerId, linkName);
        }
        validateSelector();
        if (!error) {
            if (triggerType === "menu") {
                onSaveMenu(state);
            } else {
                onSaveDialog(state);
            }
        }
    };
    var getActionButton = function(isFloating) {
        return doneButton.__typename === "UIPrimaryButton" && /* @__PURE__ */ React44.createElement(EGDSPrimaryButton, {
            onClick: handleSubmit,
            data: doneButton,
            floating: isFloating
        });
    };
    return /* @__PURE__ */ React44.createElement(React44.Fragment, null, /* @__PURE__ */ React44.createElement(Viewport5, null, /* @__PURE__ */ React44.createElement(ViewLarge2, null, /* @__PURE__ */ React44.createElement(UitkMenu2, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React44.createElement(UitkMenuTrigger2, null, /* @__PURE__ */ React44.createElement(UitkFakeInput2, {
        label: label,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef,
        className: "open-room-picker-observer-root"
    })), /* @__PURE__ */ React44.createElement(UitkMenuContainer2, {
        autoPosition: true,
        position: PositionType2.RIGHT,
        width: 375
    }, /* @__PURE__ */ React44.createElement(UitkSpacing12, {
        padding: {
            inline: "six",
            blockstart: "two"
        }
    }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(EGDSRoomsTravelerSelector, {
        onSubmit: handleSubmit,
        data: travelerSelector2,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    })))))), /* @__PURE__ */ React44.createElement(ViewMedium5, null, /* @__PURE__ */ React44.createElement(UitkMenu2, {
        isOpen: showMenu,
        onTriggerClick: onTriggerClick,
        onDismiss: onDismissMenu
    }, /* @__PURE__ */ React44.createElement(UitkMenuTrigger2, null, /* @__PURE__ */ React44.createElement(UitkFakeInput2, {
        label: label,
        value: travelersSummary,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef,
        className: "open-room-picker-observer-root"
    })), /* @__PURE__ */ React44.createElement(UitkMenuContainer2, {
        autoPosition: true,
        position: PositionType2.RIGHT,
        width: 375,
        intersectionObserverRoot: ".open-room-picker-observer-root"
    }, /* @__PURE__ */ React44.createElement(UitkSpacing12, {
        padding: {
            inline: "six",
            blockstart: "two"
        }
    }, /* @__PURE__ */ React44.createElement("div", null, /* @__PURE__ */ React44.createElement(EGDSRoomsTravelerSelector, {
        onSubmit: handleSubmit,
        data: travelerSelector2,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    })))))), /* @__PURE__ */ React44.createElement(ViewSmall3, null, /* @__PURE__ */ React44.createElement(React44.Fragment, null, /* @__PURE__ */ React44.createElement(UitkFakeInput2, {
        label: label,
        value: travelersSummary,
        onClick: onClick,
        icon: leftIcon,
        "data-stid": "open-room-picker",
        disabled: readOnly,
        domRef: triggerRef
    }), /* @__PURE__ */ React44.createElement(TravelerSelectorDialogWrapper, null, /* @__PURE__ */ React44.createElement(UitkSheet2, {
        isVisible: true,
        returnFocusOnClose: true,
        type: "full",
        triggerRef: triggerRef
    }, /* @__PURE__ */ React44.createElement(UitkToolbar2, {
        toolbarTitle: travelerSelector2.title,
        navigationContent: {
            navType: "close",
            onClick: onDismissDialog
        }
    }), /* @__PURE__ */ React44.createElement(UitkSheetContent2, null, /* @__PURE__ */ React44.createElement(UitkForm2, {
        hasRequiredFieldIndicator: true
    }, /* @__PURE__ */ React44.createElement(EGDSRoomsTravelerSelector, {
        data: travelerSelector2,
        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage
    }))), getActionButton(true)))))), state.rooms.map(function(room, roomIndex) {
        var _children_ages, _infants, _infants_ages;
        var adults = room.adults, children = room.children, infants = room.infants;
        var roomNumber = roomIndex + 1;
        return /* @__PURE__ */ React44.createElement(React44.Fragment, {
            key: roomIndex
        }, /* @__PURE__ */ React44.createElement("input", {
            type: "hidden",
            "data-stid": "".concat(ADULT_COUNT_NAME_PREFIX2, "-").concat(roomNumber),
            name: "".concat(ADULT_COUNT_NAME_PREFIX2, "-Room").concat(roomNumber),
            value: adults.value
        }), children.__typename === "EGDSTravelerChildren" && ((_children_ages = children.ages) === null || _children_ages === void 0 ? void 0 : _children_ages.map(function(age, childIndex) {
            if (age.__typename === "EGDSTravelerChildAgeSelect") {
                var childNumber = childIndex + 1;
                var childName = "".concat(CHILDREN_NAME_PREFIX2, "-Room").concat(roomNumber, "-Child").concat(childNumber);
                var _age_value;
                return /* @__PURE__ */ React44.createElement("input", {
                    key: childIndex,
                    type: "hidden",
                    "data-stid": childName,
                    name: childName,
                    value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
                });
            }
            return null;
        })), ((_infants = infants) === null || _infants === void 0 ? void 0 : _infants.__typename) === "EGDSTravelerInfant" && ((_infants_ages = infants.ages) === null || _infants_ages === void 0 ? void 0 : _infants_ages.map(function(age, infantIndex) {
            if (age.__typename === "EGDSTravelerChildAgeSelect") {
                var _state_infantSeatSelection;
                var infantNumber = infantIndex + 1;
                var infantType = ((_state_infantSeatSelection = state.infantSeatSelection) === null || _state_infantSeatSelection === void 0 ? void 0 : _state_infantSeatSelection.value) === "seat" ? INFANT_IN_SEAT_NAME_PREFIX2 : INFANT_ON_LAP_NAME_PREFIX2;
                var infantName = "".concat(infantType, "-Room").concat(roomNumber, "-Infant").concat(infantNumber);
                var _age_value;
                return /* @__PURE__ */ React44.createElement("input", {
                    key: infantIndex,
                    type: "hidden",
                    "data-stid": infantName,
                    name: infantName,
                    value: (_age_value = age.value) !== null && _age_value !== void 0 ? _age_value : ""
                });
            }
            return null;
        })));
    }));
};
// ../internal/src/components/form/egds-search-form-travelers-field/egds-search-form-travelers-field.tsx
var __Fragment33 = gql36(_templateObject39(), EGDSBasicTravelerSelector.fragment, EGDSRoomsTravelerSelector.fragment);
var getTravelersData = function(travelers, isAnyPetAllowed) {
    var _travelers;
    if (((_travelers = travelers) === null || _travelers === void 0 ? void 0 : _travelers.pets) && travelers.pets.__typename === "EGDSBasicCheckBox") {
        return _object_spread_props(_object_spread({}, travelers), {
            pets: _object_spread_props(_object_spread({}, travelers.pets), {
                state: isAnyPetAllowed ? "CHECKED" /* CHECKED */  : "UNCHECKED" /* UNCHECKED */ 
            })
        });
    }
    return travelers;
};
var EGDSSearchFormTravelersField = function(param) {
    var data = param.data, skipQuery = param.skipQuery, isAnyPetAllowed = param.isAnyPetAllowed, retainTravelerOnDialogDismiss = param.retainTravelerOnDialogDismiss, includeDefaultChildAgeMessage = param.includeDefaultChildAgeMessage, onOpenTravelerField = param.onOpenTravelerField, maxBookableTravelers = param.maxBookableTravelers, maxTravelersErrorMessage = param.maxTravelersErrorMessage;
    var _action;
    var _React45_useState = _sliced_to_array(React45.useState(data), 2), state = _React45_useState[0], setState = _React45_useState[1];
    React45.useEffect(function() {
        var _data_action;
        if (((_data_action = data.action) === null || _data_action === void 0 ? void 0 : _data_action.__typename) === "EGDSOpenTravelerSelectorAction") {
            var _data_action_travelerSelector_validations;
            var _data_action_travelerSelector_validations_map;
            var validations = (_data_action_travelerSelector_validations_map = (_data_action_travelerSelector_validations = data.action.travelerSelector.validations) === null || _data_action_travelerSelector_validations === void 0 ? void 0 : _data_action_travelerSelector_validations.map(function(validation) {
                var isTravelerValidation = validation.__typename === "EGDSTravelersInputValidation" && validation.type === "MAX_TRAVELERS";
                var overrideTravelerMaxCount = isTravelerValidation && maxBookableTravelers;
                if (overrideTravelerMaxCount) {
                    return _object_spread_props(_object_spread({}, validation), {
                        maxCount: maxBookableTravelers,
                        errorMessage: maxTravelersErrorMessage !== null && maxTravelersErrorMessage !== void 0 ? maxTravelersErrorMessage : ""
                    });
                }
                return validation;
            })) !== null && _data_action_travelerSelector_validations_map !== void 0 ? _data_action_travelerSelector_validations_map : null;
            setState(_object_spread_props(_object_spread({}, data), {
                action: _object_spread_props(_object_spread({}, data.action), {
                    travelerSelector: _object_spread_props(_object_spread({}, data.action.travelerSelector), {
                        validations: validations
                    })
                })
            }));
            return;
        }
        setState(data);
    }, [
        data,
        maxBookableTravelers,
        maxTravelersErrorMessage
    ]);
    var action = state.action, label = state.label, labelTemplate = state.labelTemplate, leftIcon = state.leftIcon, readOnly = state.readOnly;
    if (((_action = action) === null || _action === void 0 ? void 0 : _action.__typename) !== "EGDSOpenTravelerSelectorAction") {
        return null;
    }
    switch(action.travelerSelector.__typename){
        case "EGDSBasicTravelerSelector":
            {
                var _labelTemplate;
                var _action_travelerSelector = action.travelerSelector, travelers = _action_travelerSelector.travelers, validations = _action_travelerSelector.validations;
                var initialTravelers = getTravelersData(travelers, isAnyPetAllowed !== null && isAnyPetAllowed !== void 0 ? isAnyPetAllowed : false);
                if (!!initialTravelers && ((_labelTemplate = labelTemplate) === null || _labelTemplate === void 0 ? void 0 : _labelTemplate.__typename) === "EGDSCardinalLocalizedText") {
                    var _leftIcon;
                    return /* @__PURE__ */ React45.createElement(BasicTravelersProvider, _object_spread_props(_object_spread({}, {
                        travelers: initialTravelers,
                        validations: validations
                    }), {
                        skipQuery: skipQuery
                    }), /* @__PURE__ */ React45.createElement(BasicTravelersFieldTriggers, {
                        label: label !== null && label !== void 0 ? label : "",
                        leftIcon: (_leftIcon = leftIcon) === null || _leftIcon === void 0 ? void 0 : _leftIcon.id,
                        action: action,
                        labelTemplate: labelTemplate,
                        readOnly: readOnly,
                        isAnyPetAllowed: isAnyPetAllowed,
                        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage,
                        onOpenTravelerField: onOpenTravelerField
                    }));
                }
                return null;
            }
        case "EGDSRoomsTravelerSelector":
            {
                var _labelTemplate1;
                if (((_labelTemplate1 = labelTemplate) === null || _labelTemplate1 === void 0 ? void 0 : _labelTemplate1.__typename) === "EGDSCompositeLocalizedText") {
                    var _leftIcon1;
                    return /* @__PURE__ */ React45.createElement(TravelersProvider, _object_spread_props(_object_spread({}, action.travelerSelector), {
                        infantSeatSelection: action.travelerSelector.infantSeatSelection,
                        rooms: action.travelerSelector.rooms,
                        validations: action.travelerSelector.validations,
                        skipQuery: skipQuery
                    }), /* @__PURE__ */ React45.createElement(TravelersFieldTriggers, {
                        label: label !== null && label !== void 0 ? label : "",
                        leftIcon: (_leftIcon1 = leftIcon) === null || _leftIcon1 === void 0 ? void 0 : _leftIcon1.id,
                        action: action,
                        labelTemplate: labelTemplate,
                        readOnly: readOnly,
                        retainTravelerOnDialogDismiss: retainTravelerOnDialogDismiss,
                        includeDefaultChildAgeMessage: includeDefaultChildAgeMessage,
                        onOpenTravelerField: onOpenTravelerField
                    }));
                }
                return null;
            }
        default:
            return null;
    }
};
EGDSSearchFormTravelersField.displayName = "EGDSSearchFormTravelersField";
EGDSSearchFormTravelersField.fragment = __Fragment33;
// ../internal/src/components/form/egds-search-playback.tsx
import React47 from "react";
import { gql as gql37 } from "@apollo/client";
import { useClickTracker as useClickTracker19 } from "@shared-ui/clickstream-analytics-context";
import { UitkButtonSize as UitkButtonSize5 } from "uitk-react-button";
import { UitkCard, UitkCardLink } from "uitk-react-cards";
import { UitkIcon as UitkIcon5, UitkIconSize as UitkIconSize3 } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex8 } from "uitk-react-layout-flex";
import { MinMax, Repeat, UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { UitkHeading as UitkHeading4, UitkText as UitkText4 } from "uitk-react-text";
// ../internal/src/components/form/sticky-search-form.tsx
import React46 from "react";
import { ViewRow } from "@egds/react-search-experience";
import { UitkSpacing as UitkSpacing13 } from "uitk-react-spacing";
import { UitkSticky } from "uitk-react-sticky";
var StickySearchForm = function(props) {
    var _React46_useState = _sliced_to_array(React46.useState(false), 2), sticky = _React46_useState[0], setSticky = _React46_useState[1];
    var children = props.children, _props_paddedViewRow = props.paddedViewRow, paddedViewRow = _props_paddedViewRow === void 0 ? true : _props_paddedViewRow;
    return /* @__PURE__ */ React46.createElement(UitkSticky, {
        zIndex: 500,
        onFixed: function(isFixed) {
            setSticky(isFixed);
        }
    }, /* @__PURE__ */ React46.createElement(ViewRow, {
        layout: "fullwidth",
        canvasTheme: sticky ? "primary" : "none",
        paddedViewRow: !!sticky || paddedViewRow
    }, /* @__PURE__ */ React46.createElement(UitkSpacing13, {
        padding: {
            block: "four"
        }
    }, /* @__PURE__ */ React46.createElement("div", {
        "data-stid": "sticky-search-form"
    }, children))));
};
// ../internal/src/components/form/egds-search-playback.tsx
var __Fragment34 = gql37(_templateObject40(), EGDSTertiaryButton.fragment);
var StickyWrapper = function(param) {
    var isSticky = param.isSticky, children = param.children;
    return isSticky ? /* @__PURE__ */ React47.createElement(StickySearchForm, null, children) : /* @__PURE__ */ React47.createElement("div", null, children);
};
var EGDSSearchPlayback = function(param) {
    var data = param.data, children = param.children, stickyPlayback = param.stickyPlayback, display = param.display, onDisplayToggle = param.onDisplayToggle;
    var primary = data.primary, secondaries = data.secondaries, showAction = data.showAction, hideButton = data.hideButton;
    var track = useClickTracker19();
    if (showAction.__typename !== "EGDSShowSearchFormAction" || hideButton.__typename !== "UITertiaryButton") {
        return null;
    }
    var accessibility = showAction.accessibility, analytics = showAction.analytics, icon = showAction.icon;
    var _icon_size;
    var iconSize = UitkIconSize3[(_icon_size = icon.size) !== null && _icon_size !== void 0 ? _icon_size : "SMALL"];
    var onPlaybackClick = function() {
        onDisplayToggle(false);
        track(analytics.referrerId, analytics.linkName);
    };
    var onCloseButtonClick = function() {
        onDisplayToggle(true);
        if (hideButton.analytics) {
            var _hideButton_analytics = hideButton.analytics, referrerId = _hideButton_analytics.referrerId, linkName = _hideButton_analytics.linkName;
            track(referrerId, linkName);
        }
    };
    return /* @__PURE__ */ React47.createElement(StickyWrapper, {
        isSticky: stickyPlayback
    }, display && /* @__PURE__ */ React47.createElement(UitkCard, {
        border: true,
        padded: true
    }, /* @__PURE__ */ React47.createElement(UitkLayoutGrid, {
        space: "three",
        columns: [
            MinMax("0x", "1fr"),
            "min-content"
        ],
        alignItems: "center"
    }, /* @__PURE__ */ React47.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React47.createElement("div", null, /* @__PURE__ */ React47.createElement(UitkHeading4, {
        size: 6,
        tag: "h2",
        overflow: "truncate"
    }, primary.text), /* @__PURE__ */ React47.createElement(UitkLayoutGrid, {
        columns: [
            Repeat(secondaries.length, "max-content")
        ],
        space: "six"
    }, secondaries.map(function(secondary, index) {
        return secondary && secondary.__typename === "EGDSBasicLocalizedText" || secondary && secondary.__typename === "EGDSCardinalLocalizedText" ? /* @__PURE__ */ React47.createElement(UitkLayoutGridItem, {
            key: "secondary-".concat(index)
        }, /* @__PURE__ */ React47.createElement(UitkText4, {
            size: 200,
            overflow: "truncate",
            "aria-label": secondary.__typename === "EGDSBasicLocalizedText" ? secondary.accessibilityTemplate : secondary.accessibilityText
        }, /* @__PURE__ */ React47.createElement("span", {
            "aria-hidden": "true"
        }, secondary.text))) : /* @__PURE__ */ React47.createElement(UitkLayoutGridItem, {
            key: "secondary-".concat(index)
        }, /* @__PURE__ */ React47.createElement(UitkText4, {
            size: 200,
            overflow: "truncate"
        }, secondary && secondary.__typename === "EGDSPlainText" ? secondary.text : ""));
    })))), /* @__PURE__ */ React47.createElement(UitkLayoutGridItem, null, /* @__PURE__ */ React47.createElement(UitkIcon5, {
        id: icon.id,
        name: icon.id,
        size: iconSize
    }))), /* @__PURE__ */ React47.createElement(UitkCardLink, null, /* @__PURE__ */ React47.createElement("button", {
        type: "button",
        onClick: onPlaybackClick,
        "aria-label": accessibility
    }))), /* @__PURE__ */ React47.createElement(UitkLayoutFlex8, {
        space: "three",
        direction: "column",
        "aria-hidden": display,
        className: display ? "is-visually-hidden is-hidden" : ""
    }, children, /* @__PURE__ */ React47.createElement(EGDSTertiaryButton, {
        onClick: onCloseButtonClick,
        isFullWidth: true,
        size: UitkButtonSize5.MEDIUM,
        data: hideButton
    })));
};
EGDSSearchPlayback.fragment = __Fragment34;
EGDSSearchPlayback.displayName = "EGDSSearchPlayback";
// ../internal/src/utils/error-validation.ts
var getDate = function(date) {
    var days = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var newDate = new Date(date);
    newDate.setDate(newDate.getDate() + days);
    return newDate;
};
var getRefTypename = function(typename) {
    var id = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var typenames = {
        "origin_select-input": "".concat(typename, "Origin"),
        "destination_select-input": "".concat(typename, "Destination"),
        "pick_up_location-input": "".concat(typename, "PickUp"),
        "drop_off_location-input": "".concat(typename, "DropOff"),
        "airport_location-input": "".concat(typename, "Airport"),
        "hotel_location-input": "".concat(typename, "Hotel")
    };
    var _typenames_id;
    return (_typenames_id = typenames[id]) !== null && _typenames_id !== void 0 ? _typenames_id : typename;
};
var validateAgeInputField = function(ageInput) {
    var _ageInput;
    var _ageInput_value;
    var ageinputValue = (_ageInput_value = ageInput.value) !== null && _ageInput_value !== void 0 ? _ageInput_value : "";
    var isAgeinputValueEmpty = ageinputValue === "";
    var ageNumber = parseInt(ageinputValue, 10);
    var minInvalidAgeRange = 30;
    var maxInvalidAgeRange = 70;
    var isAgeInRange = ageNumber > minInvalidAgeRange && ageNumber < maxInvalidAgeRange;
    var isAgeInputnValid = !isAgeinputValueEmpty && !isAgeInRange;
    return {
        __typename: getRefTypename("EGDSNumberInputField", (_ageInput = ageInput) === null || _ageInput === void 0 ? void 0 : _ageInput.id),
        isValid: isAgeInputnValid,
        validations: {
            ageRange: isAgeinputValueEmpty ? true : !isAgeInRange
        }
    };
};
var validateDestinationLocationField = function(originLocation, destinationLocation) {
    var _destinationLocation;
    var _destinationLocation_value;
    var destinationValue = (_destinationLocation_value = destinationLocation.value) !== null && _destinationLocation_value !== void 0 ? _destinationLocation_value : "";
    var isDestinationEmpty = destinationValue === "";
    var hasSameValueAsOrigin = originLocation ? !isDestinationEmpty && originLocation.value === destinationValue : false;
    var isLocationValid = !isDestinationEmpty && !hasSameValueAsOrigin;
    return {
        __typename: getRefTypename("EGDSSearchFormLocationField", (_destinationLocation = destinationLocation) === null || _destinationLocation === void 0 ? void 0 : _destinationLocation.id),
        isValid: isLocationValid,
        validations: {
            sameLocationSelected: hasSameValueAsOrigin
        }
    };
};
var validateOriginLocationField = function(location) {
    var _location, _location1;
    return {
        __typename: getRefTypename("EGDSSearchFormLocationField", (_location = location) === null || _location === void 0 ? void 0 : _location.id),
        isValid: ((_location1 = location) === null || _location1 === void 0 ? void 0 : _location1.value) !== ""
    };
};
var validateDatePickerField = function(dates) {
    var _startDateInput, _endDateInput;
    var startDateInput = dates.startDateInput, endDateInput = dates.endDateInput, config = dates.config;
    var _startDateInput_value;
    var startDate2 = getDate((_startDateInput_value = (_startDateInput = startDateInput) === null || _startDateInput === void 0 ? void 0 : _startDateInput.value) !== null && _startDateInput_value !== void 0 ? _startDateInput_value : "");
    var _endDateInput_value;
    var endDate2 = getDate((_endDateInput_value = (_endDateInput = endDateInput) === null || _endDateInput === void 0 ? void 0 : _endDateInput.value) !== null && _endDateInput_value !== void 0 ? _endDateInput_value : "");
    var overpassesMaxRange = config.maxNumberOfDaysSelected !== 0 ? endDate2 >= getDate(startDate2, config.maxNumberOfDaysSelected) : false;
    var isSameDate = startDate2 === endDate2;
    var endDateBeforeStartDate = endDate2 < startDate2;
    var isDateValid = !overpassesMaxRange && !isSameDate && !endDateBeforeStartDate;
    return {
        __typename: "EGDSSearchFormDatePickerField",
        isValid: isDateValid,
        validations: {
            maxDate: overpassesMaxRange,
            sameDate: isSameDate,
            endDateBeforeStartDate: endDateBeforeStartDate
        }
    };
};
var getParsedTimeValues = function(time) {
    var hours = parseInt(time.substr(0, 2), 10);
    var minutes = parseInt(time.substr(2, 2), 10);
    if (time.includes("PM") && hours !== 12) {
        hours += 12;
    }
    return {
        hours: hours,
        minutes: minutes
    };
};
var parseDateTime = function(time) {
    var _getParsedTimeValues = getParsedTimeValues(time), hours = _getParsedTimeValues.hours, minutes = _getParsedTimeValues.minutes;
    return 1e3 * 60 * (hours * 60 + minutes);
};
var validatePickupTimeField = function(startTimeValue, startDate2) {
    var today2 = /* @__PURE__ */ new Date();
    if (today2.getDate() === startDate2.getDate() && today2.getMonth() === startDate2.getMonth() && today2.getFullYear() === startDate2.getFullYear()) {
        var parsedTime = getParsedTimeValues(startTimeValue);
        var startTimeFormat = /* @__PURE__ */ new Date();
        startTimeFormat.setHours(parsedTime.hours, parsedTime.minutes);
        var isValid = today2 < startTimeFormat;
        return {
            __typename: "EGDSBasicSelectPickUp",
            isValid: isValid
        };
    }
    return {
        __typename: "EGDSBasicSelectPickUp",
        isValid: true
    };
};
var validateDropoffTimeField = function(startTime, endTime, dates) {
    var _startDateInput, _endDateInput;
    var startDateInput = dates.startDateInput, endDateInput = dates.endDateInput;
    var _startDateInput_value;
    var startDate2 = getDate((_startDateInput_value = (_startDateInput = startDateInput) === null || _startDateInput === void 0 ? void 0 : _startDateInput.value) !== null && _startDateInput_value !== void 0 ? _startDateInput_value : "");
    var _endDateInput_value;
    var endDate2 = getDate((_endDateInput_value = (_endDateInput = endDateInput) === null || _endDateInput === void 0 ? void 0 : _endDateInput.value) !== null && _endDateInput_value !== void 0 ? _endDateInput_value : "");
    var isSameDate = startDate2.getDate() === endDate2.getDate();
    if (isSameDate) {
        var _startTime, _endTime;
        var startTimeValue = (_startTime = startTime) === null || _startTime === void 0 ? void 0 : _startTime.value;
        var endTimeValue = (_endTime = endTime) === null || _endTime === void 0 ? void 0 : _endTime.value;
        var startTimeFormat = /* @__PURE__ */ new Date();
        startTimeFormat.setTime(parseDateTime(startTimeValue));
        var endTimeFormat = /* @__PURE__ */ new Date();
        endTimeFormat.setTime(parseDateTime(endTimeValue));
        var isEndTimeAfterStartTime = endTimeFormat > startTimeFormat;
        startTimeFormat.setHours(startTimeFormat.getHours() + 2);
        var isTwoHoursDifference = endTimeFormat > startTimeFormat;
        var isValid = isEndTimeAfterStartTime && isTwoHoursDifference;
        return {
            __typename: "EGDSBasicSelectDropOff",
            isValid: isValid
        };
    }
    return {
        __typename: "EGDSBasicSelectDropOff",
        isValid: true
    };
};
var getFormElementsWithErrors = function(formElements) {
    var location = formElements.location, dates = formElements.dates, age = formElements.age, time = formElements.time;
    var validations = [
        validateOriginLocationField(location.origin),
        validateDatePickerField(dates)
    ];
    if (location.destination) {
        validations.push(validateDestinationLocationField(location.origin, location.destination));
    }
    if (age) {
        validations.push(validateAgeInputField(age));
    }
    if (time) {
        var _time_pickup, _time;
        var _dates_startDateInput_value;
        var startDate2 = getDate((_dates_startDateInput_value = dates.startDateInput.value) !== null && _dates_startDateInput_value !== void 0 ? _dates_startDateInput_value : "");
        var startTimeValue = (_time = time) === null || _time === void 0 ? void 0 : (_time_pickup = _time.pickup) === null || _time_pickup === void 0 ? void 0 : _time_pickup.value;
        validations.push(validatePickupTimeField(startTimeValue, startDate2), validateDropoffTimeField(time.pickup, time.dropOff, dates));
    }
    return validations.filter(function(element) {
        return element.isValid === false;
    });
};
var findFieldByNameAttribute = function(name) {
    return function(element) {
        return element.getAttribute("name") === name;
    };
};
// ../internal/src/utils/query-params-mapper/fields/egds-search-form-location-field.ts
var fieldName = "EGDSSearchFormLocationField";
var locationPrefix = "".concat(fieldName, "-Location");
var regionIdPrefix = "".concat(fieldName, "-RegionId");
var latPrefix = "".concat(fieldName, "-Lat");
var longPrefix = "".concat(fieldName, "-Long");
var deeplinkPrefix = "".concat(fieldName, "-Values");
var selectedPrefix = "".concat(fieldName, "-Selected");
var amenitiesFacilitiesGroupPrefix = "".concat(fieldName, "-AmenitiesFacilitiesGroup");
var locationGroupPrefix = "".concat(fieldName, "-LocGroup");
var propertiesGoodForGroupPrefix = "".concat(fieldName, "-PropertiesGoodForGroup");
var propertyTypeGroupPrefix = "".concat(fieldName, "-PropertyTypeGroup");
// ../internal/src/utils/query-params-mapper/fields/egds-date-range-picker.ts
var fieldName2 = "EGDSDateRangePicker";
var startDatePrefix = "".concat(fieldName2, "-StartDate");
var endDatePrefix = "".concat(fieldName2, "-EndDate");
var flexibilityPrefix = "EGDSDatePickerFlexibilityCalendarContent-SelectedOption";
// ../internal/src/utils/query-params-mapper/fields/egds-search-form-travelers-field.ts
var fieldName3 = "EGDSSearchFormTravelersField";
var adultPrefix = "".concat(fieldName3, "-Adult-Room");
var childrenAgePrefix = "".concat(fieldName3, "-ChildrenAge-Room");
// ../internal/src/utils/query-params-mapper/fields/egds-basic-traveler-selector.ts
var fieldName4 = "EGDSSearchFormTravelersField";
var adultBasicPrefix = "".concat(fieldName4, "-Adult");
var childrenAgeBasicPrefix = "".concat(fieldName4, "-ChildrenAge");
var petsBasicPrefix = "".concat(fieldName4, "-Pets");
// ../internal/src/utils/query-params-mapper/fields/search-form-duration-span-field.ts
var fieldName5 = "SearchFormDurationSpanField";
var minDurationPrefix = "".concat(fieldName5, "-Min");
var maxDurationPrefix = "".concat(fieldName5, "-Max");
// ../internal/src/utils/query-params-mapper/fields/egds-basic-pill.ts
var egdsBasicPillPrefix = "EGDSBasicPill";
// ../internal/src/utils/query-params-mapper/strategies/activities-strategy.ts
var activitiesStrategy = function(inputs) {
    var queryParamsMap = inputs.reduce(function(prev, param) {
        var name = param.name, value = param.value;
        if (name.startsWith(locationPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                location: value
            });
        }
        if (name.startsWith(regionIdPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                rid: value
            });
        }
        if (name.startsWith(startDatePrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                d1: value,
                startDate: value
            });
        }
        if (name.startsWith(endDatePrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                d2: value,
                endDate: value
            });
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap).map(function(key) {
        return "".concat(key, "=").concat(queryParamsMap[key]);
    }).join("&");
    return "?".concat(queryParamsString);
};
// ../internal/src/utils/query-params-mapper/strategies/cruise-strategy.ts
var cruiseStrategy = function(inputs) {
    var queryParamsMap = inputs.reduce(function(prev, param) {
        var name = param.name, value = param.value;
        if (name.startsWith(deeplinkPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                destination: value.replace(/,/g, "|")
            });
        }
        if (name.startsWith(startDatePrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                "earliest-departure-date": value
            });
        }
        if (name.startsWith(endDatePrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                "latest-departure-date": value
            });
        }
        if (name.startsWith(minDurationPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                "min-length": value
            });
        }
        if (name.startsWith(maxDurationPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                "max-length": value
            });
        }
        if (name.startsWith(adultBasicPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                adultCount: value
            });
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            var prevChildren = prev.childAges;
            var childAges = prevChildren ? "".concat(prevChildren, ",").concat(value) : value;
            var childCount = childAges.split(",").length;
            return _object_spread_props(_object_spread({}, prev), {
                childCount: childCount,
                childAges: childAges
            });
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap).map(function(key) {
        return "".concat(key, "=").concat(queryParamsMap[key]);
    }).join("&");
    return "?".concat(queryParamsString);
};
// ../internal/src/utils/query-params-mapper/fields/flights/index.ts
var flightTypeEgdsElementId = "flight_type_selector";
var cabinClassEgdsElementId = "cabin_class";
var destinationEgdsElementId = "destination_select";
var originEgdsElementId = "origin_select";
// ../internal/src/utils/query-params-mapper/strategies/flight-strategy.ts
var flightTypeMap = {
    ONE_WAY: "oneway",
    ROUND_TRIP: "roundtrip",
    MULTI_DESTINATION: "multi"
};
var flightStrategy = function(inputs) {
    var leg = {
        from: "",
        to: "",
        departureDate: ""
    };
    var passengers = {
        adults: 0,
        seniors: 0,
        childAges: []
    };
    var queryParamsMap = inputs.reduce(function(prev, param) {
        var name = param.name, value = param.value;
        if (name.includes(flightTypeEgdsElementId)) {
            return _object_spread_props(_object_spread({}, prev), {
                trip: flightTypeMap[value]
            });
        }
        if (name.includes(cabinClassEgdsElementId)) {
            return _object_spread_props(_object_spread({}, prev), {
                options: "cabinclass:".concat(value)
            });
        }
        if (name.startsWith(locationPrefix) && name.includes(originEgdsElementId)) {
            leg.from = value;
            return prev;
        }
        if (name.startsWith(locationPrefix) && name.includes(destinationEgdsElementId)) {
            leg.to = value;
            return prev;
        }
        if (name.startsWith(startDatePrefix)) {
            leg.departureDate = value;
            return _object_spread_props(_object_spread({}, prev), {
                fromDate: value
            });
        }
        if (name.startsWith(adultBasicPrefix)) {
            passengers.adults = +value;
            return prev;
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            passengers.childAges.push(value);
            return prev;
        }
        return prev;
    }, {
        "flight-type": "on",
        mode: "search"
    });
    var childCount = passengers.childAges.length || 0;
    var childAges = childCount ? "".concat(childCount, "[").concat(passengers.childAges.join(";"), "]") : childCount.toString();
    queryParamsMap.legs = [
        leg
    ];
    queryParamsMap.passengers = "children:".concat(childAges, ",adults:").concat(passengers.adults, ",seniors:0,infantinlap:Y");
    var queryParamsString = Object.keys(queryParamsMap).map(function(key) {
        if (key === "legs" && queryParamsMap.legs) {
            return queryParamsMap.legs.map(function(value, index) {
                return "leg".concat(index + 1, "=from:").concat(value.from, ",to:").concat(value.to, ",departure:").concat(value.departureDate, "TANYT");
            }).join("&");
        }
        return "".concat(key, "=").concat(queryParamsMap[key]);
    }).join("&");
    return "?".concat(queryParamsString);
};
// ../internal/src/utils/query-params-mapper/strategies/lodging-strategy.ts
var lodgingStrategy = function(inputs) {
    var queryParamsMap = inputs.reduce(function(prev, input) {
        var name = input.name, value = input.value, checked = input.checked;
        if (name.startsWith("".concat(locationPrefix, "-destination"))) {
            return _object_spread_props(_object_spread({}, prev), {
                destination: value
            });
        }
        if (name.startsWith("".concat(regionIdPrefix, "-destination")) && value !== "null") {
            return _object_spread_props(_object_spread({}, prev), {
                regionId: value
            });
        }
        if (name.startsWith("".concat(latPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                latLong: value
            });
        }
        if (name.startsWith("".concat(longPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                latLong: "".concat(prev.latLong, ",").concat(value)
            });
        }
        if (name.startsWith("".concat(amenitiesFacilitiesGroupPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                amenities_facilities_group: value
            });
        }
        if (name.startsWith("".concat(locationGroupPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                location_group: value
            });
        }
        if (name.startsWith("".concat(propertiesGoodForGroupPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                properties_good_for_group: value
            });
        }
        if (name.startsWith("".concat(propertyTypeGroupPrefix, "-destination")) && value) {
            return _object_spread_props(_object_spread({}, prev), {
                property_type_group: value
            });
        }
        if (name.startsWith(startDatePrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                d1: value,
                startDate: value
            });
        }
        if (name.startsWith(endDatePrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                d2: value,
                endDate: value
            });
        }
        if (name.startsWith(flexibilityPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                flexibility: value
            });
        }
        if (name.startsWith(adultPrefix)) {
            var prevAdults = prev.adults;
            var adults = prevAdults ? "".concat(prevAdults, ",").concat(value) : value;
            var rooms = adults.split(",").length;
            return _object_spread_props(_object_spread({}, prev), {
                adults: adults,
                rooms: rooms
            });
        }
        if (name.startsWith(childrenAgePrefix)) {
            var prevChildren = prev.children;
            var roomNumber = name.substr(childrenAgePrefix.length, 1);
            var formattedValue = "".concat(roomNumber, "_").concat(value);
            var children = prevChildren ? "".concat(prevChildren, ",").concat(formattedValue) : formattedValue;
            return _object_spread_props(_object_spread({}, prev), {
                children: children
            });
        }
        if (name.startsWith(adultBasicPrefix)) {
            return _object_spread_props(_object_spread({}, prev), {
                adults: value
            });
        }
        if (name.startsWith(childrenAgeBasicPrefix)) {
            var prevChildren1 = prev.children;
            var roomNumber1 = 1;
            var formattedValue1 = "".concat(roomNumber1, "_").concat(value);
            var children1 = prevChildren1 ? "".concat(prevChildren1, ",").concat(formattedValue1) : formattedValue1;
            return _object_spread_props(_object_spread({}, prev), {
                children: children1
            });
        }
        if (name.startsWith(petsBasicPrefix)) {
            var isPets = value === "CHECKED" /* CHECKED */ ;
            return _object_spread(_object_spread_props(_object_spread({}, prev), {
                isPets: isPets
            }), isPets && {
                house_rules_group: "pets_allowed"
            });
        }
        if (name.startsWith(selectedPrefix)) {
            return value ? _object_spread_props(_object_spread({}, prev), {
                selected: value
            }) : _object_spread({}, prev);
        }
        if (name.startsWith("".concat(locationPrefix, "-origin"))) {
            return _object_spread_props(_object_spread({}, prev), {
                origin: value
            });
        }
        if (name.startsWith("EGDSSoftPackagesPackageType") && value.length > 0) {
            return _object_spread_props(_object_spread({}, prev), {
                packageType: value
            });
        }
        if (name.startsWith("".concat(egdsBasicPillPrefix, "-add-flight")) || name.startsWith("add-flight-switch")) {
            return _object_spread({}, prev, checked ? {
                "add-flight-switch": checked
            } : {});
        }
        if (name.startsWith("".concat(egdsBasicPillPrefix, "-add-car")) || name.startsWith("add-car-switch")) {
            return _object_spread({}, prev, checked ? {
                "add-car-switch": checked
            } : {});
        }
        return prev;
    }, {});
    var queryParamsString = Object.keys(queryParamsMap).map(function(key) {
        return "".concat(key, "=").concat(queryParamsMap[key]);
    }).join("&");
    return "?".concat(queryParamsString);
};
var _obj3;
// ../internal/src/utils/query-params-mapper/strategies/map.ts
var queryParamsStrategiesMap = (_obj3 = {}, _define_property(_obj3, "LODGING" /* LODGING */ , lodgingStrategy), _define_property(_obj3, "CRUISES" /* CRUISES */ , cruiseStrategy), _define_property(_obj3, "FLIGHTS" /* FLIGHTS */ , flightStrategy), _define_property(_obj3, "ACTIVITIES" /* ACTIVITIES */ , activitiesStrategy), _obj3);
// ../internal/src/utils/query-params-mapper/query-params-mapper.ts
var getSearchToolsQueryParams = function(strategy, elements) {
    var searchToolsInputPrefix = "EGDS";
    var searchForm = "SearchForm";
    var softPackages = "add";
    var prefixes = [
        searchToolsInputPrefix,
        searchForm,
        softPackages
    ];
    var filteredInputs = elements.filter(function(param) {
        var name = param.name;
        return prefixes.find(function(prefix) {
            return name.startsWith(prefix);
        });
    });
    return queryParamsStrategiesMap[strategy](filteredInputs);
};
// ../internal/src/utils/search-form-playback-dates.ts
var getFormattedDates = function(value, localizationContext) {
    var formatDateString = localizationContext.formatDateString;
    var _value_split = _sliced_to_array(value.split(" - "), 2), startDate2 = _value_split[0], endDate2 = _value_split[1];
    var updatedStartDate = formatDateString(startDate2, {
        skeleton: "MMMd"
    });
    var updatedEndDate = formatDateString(endDate2, {
        skeleton: "MMMd"
    });
    return "".concat(updatedStartDate, " - ").concat(updatedEndDate);
};
// ../internal/src/utils/uis-prime-utils.ts
var mapUisMicroMessage = function(uisPrimeMessages) {
    return uisPrimeMessages.map(function(uisPrimeMessage) {
        return {
            messageContent: JSON.parse(uisPrimeMessage.messageContent),
            schemaName: uisPrimeMessage.schemaName
        };
    });
};
// src/components/__private/lodging-search-form.tsx
import { useSignalPublisher, useSignalSubscriber } from "@shared-ui/signal-events-context";
import { ViewLarge as ViewLarge3, ViewMedium as ViewMedium6, Viewport as Viewport6, ViewSizes as ViewSizes3, ViewSmall as ViewSmall4 } from "@shared-ui/viewport-context";
import { UitkForm as UitkForm3 } from "uitk-react-form";
import { FitContent, Repeat as Repeat2, UitkLayoutGrid as UitkLayoutGrid3, UitkLayoutGridItem as UitkLayoutGridItem3 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing15 } from "uitk-react-spacing";
// src/utils/fields-map.ts
var FieldNameMap = /* @__PURE__ */ function(FieldNameMap2) {
    FieldNameMap2["DESTINATION"] = "destination_form_field";
    FieldNameMap2["TRAVEL_DATES"] = "EGDSDateRangePicker";
    FieldNameMap2["TRAVELER_ROOM_SELECTOR"] = "EGDSRoomsTravelerSelector";
    FieldNameMap2["TRAVELER_BASIC_SELECTOR"] = "EGDSBasicTravelerSelector";
    return FieldNameMap2;
}(FieldNameMap || {});
// src/utils/query-params.ts
var ParamsKeys = /* @__PURE__ */ function(ParamsKeys2) {
    ParamsKeys2["DESTINATION"] = "destination";
    ParamsKeys2["REGION_ID"] = "regionId";
    ParamsKeys2["LAT_LONG"] = "latLong";
    ParamsKeys2["DATE_ONE"] = "d1";
    ParamsKeys2["DATE_TWO"] = "d2";
    ParamsKeys2["START_DATE"] = "startDate";
    ParamsKeys2["END_DATE"] = "endDate";
    ParamsKeys2["ADULTS"] = "adults";
    ParamsKeys2["CHILDREN"] = "children";
    ParamsKeys2["SELECTED"] = "selected";
    ParamsKeys2["FLEXIBILITY"] = "flexibility";
    ParamsKeys2["MAP_BOUNDS"] = "mapBounds";
    return ParamsKeys2;
}(ParamsKeys || {});
var SortAndFiltersParamsKeys = /* @__PURE__ */ function(SortAndFiltersParamsKeys2) {
    SortAndFiltersParamsKeys2["SORT"] = "sort";
    SortAndFiltersParamsKeys2["HOTEL_NAME"] = "hotelName";
    SortAndFiltersParamsKeys2["REWARDS"] = "rewards";
    SortAndFiltersParamsKeys2["STAR"] = "star";
    SortAndFiltersParamsKeys2["GUEST_RATING"] = "guestRating";
    SortAndFiltersParamsKeys2["CLEANING_AND_SAFETY"] = "cleaningAndSafetyPractices";
    SortAndFiltersParamsKeys2["LODGING"] = "lodging";
    SortAndFiltersParamsKeys2["MEAL_PLAN"] = "mealPlan";
    SortAndFiltersParamsKeys2["AMENITIES"] = "amenities";
    SortAndFiltersParamsKeys2["TRAVELER_TYPE"] = "travelerType";
    SortAndFiltersParamsKeys2["PAYMENT_TYPE"] = "paymentType";
    SortAndFiltersParamsKeys2["DEALS"] = "deals";
    SortAndFiltersParamsKeys2["PROPERTY_STYLE"] = "propertyStyle";
    SortAndFiltersParamsKeys2["BEDROOM_FILTER"] = "bedroomFilter";
    SortAndFiltersParamsKeys2["NEIGHBORHOOD"] = "neighborhood";
    SortAndFiltersParamsKeys2["STAY_TYPE"] = "stayType";
    SortAndFiltersParamsKeys2["ACCESSIBILITY"] = "accessibility";
    SortAndFiltersParamsKeys2["POI"] = "poi";
    SortAndFiltersParamsKeys2["MIN_BEDROOMS"] = "bedroom_count_gt";
    SortAndFiltersParamsKeys2["MIN_BATHROOMS"] = "us_bathroom_count_gt";
    SortAndFiltersParamsKeys2["PROPERTY_TYPE"] = "property_type_group";
    SortAndFiltersParamsKeys2["LOCATION"] = "location_group";
    SortAndFiltersParamsKeys2["ACCESSIBILITY_FEATURES"] = "accessibility_features_group";
    SortAndFiltersParamsKeys2["BOOKING_OPTIONS"] = "booking_options_group";
    SortAndFiltersParamsKeys2["DISCOUNTS_GROUP"] = "discounts_group";
    SortAndFiltersParamsKeys2["AMENITIES_FACILITIES"] = "amenities_facilities_group";
    SortAndFiltersParamsKeys2["FREE_CANCELLATION_GROUP"] = "free_cancellation_group";
    SortAndFiltersParamsKeys2["HOUSE_RULES"] = "house_rules_group";
    SortAndFiltersParamsKeys2["NEARBY_ACTIVITIES"] = "nearby_activities_group";
    SortAndFiltersParamsKeys2["NEIGHBORHOOD_GROUP"] = "neighborhood_group";
    SortAndFiltersParamsKeys2["PREMIER_HOST"] = "premier_host_group";
    SortAndFiltersParamsKeys2["PROPERTIES_GOOD"] = "properties_good_for_group";
    SortAndFiltersParamsKeys2["PROPERTY_REVIEWS"] = "property_reviews_group";
    SortAndFiltersParamsKeys2["ROOMS_SPACES"] = "rooms_spaces_group";
    SortAndFiltersParamsKeys2["SAFETY"] = "safety_group";
    SortAndFiltersParamsKeys2["VIRTUAL_TOUR_GROUP"] = "virtual_tour_group";
    SortAndFiltersParamsKeys2["PRICING_GROUP"] = "pricing_group";
    SortAndFiltersParamsKeys2["PROPERTY_NAME"] = "propertyName";
    SortAndFiltersParamsKeys2["AVAILABLE_FILTER"] = "availableFilter";
    SortAndFiltersParamsKeys2["AGENCY_BUSINESS_MODELS"] = "agencyBusinessModels";
    SortAndFiltersParamsKeys2["COMMISSION_TIERS"] = "commissionTiers";
    SortAndFiltersParamsKeys2["USE_REWARDS"] = "useRewards";
    return SortAndFiltersParamsKeys2;
}(SortAndFiltersParamsKeys || {});
var SortAndFiltersRangeParamKey = /* @__PURE__ */ function(SortAndFiltersRangeParamKey2) {
    SortAndFiltersRangeParamKey2["PRICE"] = "price";
    SortAndFiltersRangeParamKey2["NIGHTLY_PRICE"] = "nightly_price";
    SortAndFiltersRangeParamKey2["TOTAL_PRICE"] = "total_price";
    return SortAndFiltersRangeParamKey2;
}(SortAndFiltersRangeParamKey || {});
var getDestination = function(param) {
    var destination2 = param.destination, regionId = param.regionId, latLong = param.latLong, selected = param.selected, mapBounds = param.mapBounds;
    var _latLong;
    var _ref = _sliced_to_array(((_latLong = latLong) === null || _latLong === void 0 ? void 0 : _latLong.split(",").map(function(value) {
        return parseFloat(value);
    })) || [
        null,
        null
    ], 2), latitude = _ref[0], longitude = _ref[1];
    return _object_spread({
        regionName: destination2,
        regionId: regionId,
        coordinates: latitude && longitude ? {
            latitude: latitude,
            longitude: longitude
        } : null,
        mapBounds: mapBounds
    }, selected && {
        pinnedPropertyId: selected
    });
};
var getDate2 = function(date) {
    var _date_split = _sliced_to_array(date.split("-"), 3), year = _date_split[0], month = _date_split[1], day = _date_split[2];
    return {
        year: parseInt(year, 10),
        month: parseInt(month, 10),
        day: parseInt(day, 10)
    };
};
var formatDateInVariant = function(date) {
    var _date_split = _sliced_to_array(date.split("/"), 3), month = _date_split[0], day = _date_split[1], year = _date_split[2];
    return "".concat(year, "-").concat(month, "-").concat(day);
};
var getDateRange = function(param) {
    var startDate2 = param.startDate, endDate2 = param.endDate;
    if (!startDate2 || !endDate2) {
        return null;
    }
    var defaultFormat = /^\d{4}-\d{2}-\d{2}$/;
    var formatVariant = /^(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\/\d{4}$/;
    var isStartDateValid = defaultFormat.test(startDate2) || formatVariant.test(startDate2);
    var isEndDateValid = defaultFormat.test(endDate2) || formatVariant.test(endDate2);
    if (!isStartDateValid || !isEndDateValid) {
        return null;
    }
    var formattedStartDate = defaultFormat.test(startDate2) ? startDate2 : formatDateInVariant(startDate2);
    var formattedEndDate = defaultFormat.test(endDate2) ? endDate2 : formatDateInVariant(endDate2);
    return {
        checkInDate: getDate2(formattedStartDate),
        checkOutDate: getDate2(formattedEndDate)
    };
};
var getPriceRange = function(param) {
    var queryParams = param.queryParams;
    var range = [];
    Object.values(SortAndFiltersRangeParamKey).forEach(function(i) {
        var price = queryParams.getAll(i);
        var updatedPrice = price.length === 1 ? price[0].split(",") : price;
        var pricesArr = updatedPrice.filter(function(value) {
            return value.length !== 0;
        }).map(Number).filter(function(value) {
            return !Number.isNaN(value);
        });
        if (pricesArr.length > 1) {
            var _Math, _Math1;
            range.push({
                id: i,
                min: (_Math = Math).min.apply(_Math, _to_consumable_array(pricesArr)),
                max: (_Math1 = Math).max.apply(_Math1, _to_consumable_array(pricesArr))
            });
        }
    });
    return range;
};
var getRooms = function(param) {
    var adultsValue = param.adults, children = param.children;
    var _adultsValue, _children;
    var adults = ((_adultsValue = adultsValue) === null || _adultsValue === void 0 ? void 0 : _adultsValue.split(",").map(function(count) {
        return parseInt(count, 10);
    })) || [];
    var childrenRoomsAndAges = ((_children = children) === null || _children === void 0 ? void 0 : _children.split(",")) || [];
    return adults.map(function(count, index) {
        var roomNumber = index + 1;
        var childrenAgePosition = 1;
        return {
            adults: count,
            children: childrenRoomsAndAges.filter(function(roomAndAge) {
                return roomAndAge.startsWith(roomNumber.toString());
            }).map(function(value) {
                return {
                    age: parseInt(value.split("_")[childrenAgePosition], 10)
                };
            })
        };
    }).filter(function(room) {
        return !Number.isNaN(room.adults);
    });
};
var addSelectionIfIDNotPresent = function(selections, newSelection) {
    return selections.some(function(selection) {
        return selection.id === newSelection.id;
    }) ? selections : _to_consumable_array(selections).concat([
        newSelection
    ]);
};
var getSelections = function(param) {
    var queryParams = param.queryParams, paramsToExclude = param.paramsToExclude;
    var selections = Object.values(SortAndFiltersParamsKeys).reduce(function(prev, element) {
        var values = queryParams.getAll(element);
        if (values.length && values[0] !== "") {
            var selection = values.map(function(value) {
                var newValue = paramsToExclude.includes(element) ? [
                    value
                ] : value.split(",");
                return newValue.map(function(splitValue) {
                    if (element === "useRewards" /* USE_REWARDS */ ) {
                        return {
                            id: element,
                            value: splitValue === "true" ? "SHOP_WITH_POINTS" /* SHOP_WITH_POINTS */  : "SHOP_WITHOUT_POINTS" /* SHOP_WITHOUT_POINTS */ 
                        };
                    }
                    return {
                        id: element,
                        value: splitValue
                    };
                });
            });
            return _to_consumable_array(prev).concat(_to_consumable_array(selection));
        }
        return _to_consumable_array(prev);
    }, []).flat();
    return addSelectionIfIDNotPresent(selections, {
        id: "sort" /* SORT */ ,
        value: "RECOMMENDED"
    });
};
var getFlexibleCriteria = function(queryParams) {
    var flexibilityParams = queryParams.getAll("flexibility" /* FLEXIBILITY */ );
    if (flexibilityParams.length === 0) {
        return null;
    }
    var flexibility = flexibilityParams.map(function(param) {
        return param.split("_");
    }).filter(function(params) {
        return params.length > 1;
    }).map(function(params) {
        var bound = params.length === 3 ? {
            bound: ClosedPeriodBounding[params[2].toUpperCase()]
        } : {};
        var length = parseInt(params[0], 10);
        var unit = DatePeriodUnit[params[1].toUpperCase()];
        return _object_spread({
            unit: unit,
            length: length
        }, bound);
    }).filter(function(criteria) {
        return !(criteria.unit === void 0 || Number.isNaN(criteria.length));
    });
    if (flexibility.length === 0) {
        return null;
    }
    return {
        flexibility: flexibility
    };
};
var getMapBounds = function(mapBounds) {
    var resolvedBounds = mapBounds.map(function(bounds) {
        return bounds.split(",");
    }).filter(function(param) {
        var _param = _sliced_to_array(param, 2), latitude = _param[0], longitude = _param[1];
        return latitude !== "" && longitude !== "";
    }).map(function(param) {
        var _param = _sliced_to_array(param, 2), latitude = _param[0], longitude = _param[1];
        return {
            latitude: Number(latitude),
            longitude: Number(longitude)
        };
    });
    return resolvedBounds.length === 2 ? resolvedBounds : [];
};
var getPropertySearchCriteriaFromQueryParams = function(queryParams) {
    var destination2 = getDestination({
        destination: queryParams.get("destination" /* DESTINATION */ ),
        regionId: queryParams.get("regionId" /* REGION_ID */ ) === "null" ? null : queryParams.get("regionId" /* REGION_ID */ ),
        latLong: queryParams.get("latLong" /* LAT_LONG */ ),
        selected: queryParams.get("selected" /* SELECTED */ ),
        mapBounds: getMapBounds(queryParams.getAll("mapBounds" /* MAP_BOUNDS */ ))
    });
    var dateRange = getDateRange({
        startDate: queryParams.get("startDate" /* START_DATE */ ),
        endDate: queryParams.get("endDate" /* END_DATE */ )
    });
    var rooms = getRooms({
        adults: queryParams.get("adults" /* ADULTS */ ),
        children: queryParams.get("children" /* CHILDREN */ )
    });
    var rangesFilters = getPriceRange({
        queryParams: queryParams
    });
    var paramsToExclude = [
        "hotelName" /* HOTEL_NAME */ ,
        "poi" /* POI */ 
    ];
    var selectionsFilters = getSelections({
        queryParams: queryParams,
        paramsToExclude: paramsToExclude
    });
    var flexibleSearchCriteria = getFlexibleCriteria(queryParams);
    var flexSearchCriteria = flexibleSearchCriteria ? {
        flexSearchCriteria: flexibleSearchCriteria
    } : {};
    return {
        propertySearchCriteriaInput: {
            primary: _object_spread({
                destination: destination2,
                rooms: rooms,
                dateRange: dateRange
            }, flexSearchCriteria),
            secondary: {
                ranges: rangesFilters,
                selections: selectionsFilters
            }
        }
    };
};
// src/components/__private/adaptex-tracking-success-fragment.tsx
import { gql as gql39 } from "@apollo/client";
// ../internal/src/components/common/uis-micro-message.ts
import { gql as gql38 } from "@apollo/client";
var egUisMicroMessageFragment = gql38(_templateObject41());
// src/components/__private/adaptex-tracking-success-fragment.tsx
var adaptexTrackingSuccessFragment = gql39(_templateObject42(), egUisMicroMessageFragment);
// src/components/__private/soft-packages.tsx
import React48 from "react";
import { gql as gql40 } from "@apollo/client";
import { UitkLayoutGrid as UitkLayoutGrid2, UitkLayoutGridItem as UitkLayoutGridItem2 } from "uitk-react-layout-grid";
import { UitkSpacing as UitkSpacing14 } from "uitk-react-spacing";
var getSelectedSoftPackage = function(param) {
    var flightAdded = param.flightAdded, carAdded = param.carAdded;
    if (flightAdded && carAdded) {
        return "fhc";
    }
    if (flightAdded) {
        return "fh";
    }
    if (carAdded) {
        return "hc";
    }
    return "";
};
var _fragment = gql40(_templateObject43(), EGDSPill.fragment, EGDSCheckBox.fragment, EGDSSearchFormLocationField.fragment);
var packageTypeParamName = "EGDSSoftPackagesPackageType";
var SoftPackages = function(props) {
    var _flight, _flight1, _car;
    var data = props.data, onProductSelect = props.onProductSelect, setFieldRefByTypename = props.setFieldRefByTypename, fieldError = props.fieldError;
    var addCar = data.addCar, addFlight = data.addFlight, car = data.car, flight = data.flight, origin = data.origin;
    var handleCheckboxChange = function(event) {
        onProductSelect(event);
    };
    var displayOriginField = origin && ((_flight = flight) === null || _flight === void 0 ? void 0 : _flight.__typename) === "EGDSBasicPill" && flight.selected;
    var originField = origin && /* @__PURE__ */ React48.createElement("div", null, /* @__PURE__ */ React48.createElement(EGDSSearchFormLocationField, {
        data: origin,
        setFieldRefByTypename: setFieldRefByTypename,
        fieldError: fieldError
    }));
    var selectedSoftPackage = getSelectedSoftPackage({
        flightAdded: ((_flight1 = flight) === null || _flight1 === void 0 ? void 0 : _flight1.__typename) === "EGDSBasicPill" && flight.selected,
        carAdded: ((_car = car) === null || _car === void 0 ? void 0 : _car.__typename) === "EGDSBasicPill" && car.selected
    });
    var pills = flight && car ? [
        flight,
        car
    ] : [];
    var checkboxes = addCar && addFlight ? [
        addFlight,
        addCar
    ] : [];
    var gridColumns = {
        small: 2,
        medium: 12
    };
    var productGridItemColumns = {
        small: 1,
        medium: 2
    };
    return /* @__PURE__ */ React48.createElement(React48.Fragment, null, /* @__PURE__ */ React48.createElement(UitkLayoutGrid2, {
        space: "three",
        columns: gridColumns
    }, checkboxes.map(function(checkbox) {
        return /* @__PURE__ */ React48.createElement(UitkLayoutGridItem2, {
            key: checkbox.egdsElementId,
            colSpan: productGridItemColumns
        }, /* @__PURE__ */ React48.createElement("div", null, /* @__PURE__ */ React48.createElement(EGDSCheckBox, {
            data: checkbox,
            onChange: handleCheckboxChange
        })));
    })), displayOriginField && /* @__PURE__ */ React48.createElement(UitkLayoutGrid2, {
        columns: gridColumns
    }, /* @__PURE__ */ React48.createElement(UitkLayoutGridItem2, {
        colSpan: {
            small: 2,
            medium: 4
        }
    }, /* @__PURE__ */ React48.createElement("div", null, /* @__PURE__ */ React48.createElement(UitkSpacing14, {
        padding: {
            blockstart: "three"
        }
    }, /* @__PURE__ */ React48.createElement("div", null, originField))))), /* @__PURE__ */ React48.createElement("input", {
        type: "hidden",
        name: packageTypeParamName,
        value: selectedSoftPackage
    }));
};
SoftPackages.fragment = _fragment;
SoftPackages.displayName = "SoftPackages";
// src/components/__private/lodging-search-form.tsx
var fieldComponents = [
    EGDSSearchFormLocationField,
    EGDSSearchFormDatePickerField,
    EGDSSearchFormTravelersField,
    EGDSSearchFormButton,
    SoftPackages
];
var _fragment2 = gql41(_templateObject44(), EGDSErrorSummary.fragment, EGDSSearchFormLocationField.fragment, EGDSSearchFormDatePickerField.fragment, EGDSSearchFormTravelersField.fragment, EGDSSearchFormButton.fragment, EGDSSearchPlayback.fragment, SoftPackages.fragment, adaptexTrackingSuccessFragment);
var getLocationParameter = function() {
    if (typeof window !== "undefined") {
        return new URLSearchParams(window.location.search).get("destination" /* DESTINATION */ );
    }
    return "";
};
var LodgingSearchForm = function(props) {
    var _datePickerField, _datePickerField_action, _softPackages_flight, _softPackages, _softPackages_car, _softPackages1, _errorLinkReference_current, _errorLinkReference;
    var data = props.data, onFieldChange = props.onFieldChange, onSubmit = props.onSubmit, autoOpenCalendar = props.autoOpenCalendar, autoOpenPlayback = props.autoOpenPlayback, sticky = props.sticky, stickyPlayback = props.stickyPlayback, skipQuery = props.skipQuery, autoSubmitOnFieldChange = props.autoSubmitOnFieldChange, redirectToSearchResultOnSubmit = props.redirectToSearchResultOnSubmit, additionalQueryParams = props.additionalQueryParams, dateFieldInitialFocus = props.dateFieldInitialFocus, paddedViewRow = props.paddedViewRow, verticalLayout = props.verticalLayout;
    var localizationContext = useLocalization5();
    var _React49_useState = _sliced_to_array(React49.useState({
        EGDSSearchFormLocationField: null,
        EGDSSearchFormLocationFieldOrigin: null,
        EGDSSearchFormDatePickerField: null
    }), 2), fieldsRefs = _React49_useState[0], setFieldsRefs = _React49_useState[1];
    var initialErrorState = {
        displayErrorSummary: false,
        errorCount: 0,
        errorLinkReference: null,
        fieldsWithErrors: []
    };
    var formRef = React49.useRef(null);
    var _React49_useState1 = _sliced_to_array(React49.useState(_object_spread({}, initialErrorState)), 2), errorState = _React49_useState1[0], setErrorState = _React49_useState1[1];
    var egdsElementId = data.egdsElementId, elements = data.elements, search2 = data.search, actionURL = data.actionURL, errorSummary2 = data.errorSummary, playback = data.playback, initialSoftPackages = data.softPackages, adaptExSuccessEvent = data.adaptExSuccessEvent;
    var _React49_useState2 = _sliced_to_array(React49.useState(playback), 2), playbackData = _React49_useState2[0], setPlaybackData = _React49_useState2[1];
    var _React49_useState3 = _sliced_to_array(React49.useState(initialSoftPackages), 2), softPackages = _React49_useState3[0], setSoftPackages = _React49_useState3[1];
    var _React49_useState4 = _sliced_to_array(React49.useState(!autoOpenPlayback), 2), displayToggle = _React49_useState4[0], setDisplayToggle = _React49_useState4[1];
    var _useExperiment = useExperiment("Web_close_search_playback_on_field_update" /* Web_close_search_playback_on_field_update */ ), closePlaybackOnFieldUpdateExposure = _useExperiment.exposure, closePlaybackOnFieldUpdateLogger = _useExperiment.logExperiment;
    var id = egdsElementId !== null && egdsElementId !== void 0 ? egdsElementId : "search-lodging-form";
    var fieldsAndSoftPackages = softPackages ? _to_consumable_array(elements).concat([
        softPackages
    ]) : elements;
    var fields = search2 ? _to_consumable_array(fieldsAndSoftPackages).concat([
        search2
    ]) : fieldsAndSoftPackages;
    var searchFormButtonData = search2 && search2.__typename === "EGDSSearchFormButton" ? search2 : null;
    var clickTracker = useClickTracker20();
    var track = useClickstreamAnalytics().track;
    var publishSignal = useSignalPublisher().publishSignal;
    React49.useEffect(function() {
        if (playback && !skipQuery) {
            setPlaybackData(playback);
        }
    }, [
        playback,
        skipQuery
    ]);
    var handlePlaybackToggle = function(open) {
        setDisplayToggle(open);
    };
    useSignalSubscriber([
        {
            query: {
                type: "SEARCH_FORM_NEXT_PAGE" /* NEXT_PAGE */ 
            },
            callback: function() {
                var _adaptExSuccessEvent;
                if ((_adaptExSuccessEvent = adaptExSuccessEvent) === null || _adaptExSuccessEvent === void 0 ? void 0 : _adaptExSuccessEvent.datePrefill) {
                    track(ITrackType.EVENT, {
                        data: mapUisMicroMessage([
                            adaptExSuccessEvent.datePrefill
                        ])
                    });
                }
            }
        }
    ]);
    React49.useEffect(function() {
        if (dateFieldInitialFocus) {
            var _fieldsRefs_EGDSSearchFormDatePickerField_current, _fieldsRefs_EGDSSearchFormDatePickerField;
            (_fieldsRefs_EGDSSearchFormDatePickerField = fieldsRefs.EGDSSearchFormDatePickerField) === null || _fieldsRefs_EGDSSearchFormDatePickerField === void 0 ? void 0 : (_fieldsRefs_EGDSSearchFormDatePickerField_current = _fieldsRefs_EGDSSearchFormDatePickerField.current) === null || _fieldsRefs_EGDSSearchFormDatePickerField_current === void 0 ? void 0 : _fieldsRefs_EGDSSearchFormDatePickerField_current.focus();
        }
    }, [
        fieldsRefs.EGDSSearchFormDatePickerField
    ]);
    var setFieldRefByTypename = function(typename, ref) {
        var _ref_current;
        var typenameRef = getRefTypename(typename, (_ref_current = ref.current) === null || _ref_current === void 0 ? void 0 : _ref_current.id);
        setFieldsRefs(function(prevState) {
            return _object_spread_props(_object_spread({}, prevState), _define_property({}, typenameRef, ref));
        });
    };
    var datePickerField = elements.find(function(element) {
        return element.__typename === "EGDSSearchFormDatePickerField";
    });
    var _datePickerField_action_datePicker_maxNumberOfDaysSelected;
    var maxNumberOfDaysSelected = ((_datePickerField = datePickerField) === null || _datePickerField === void 0 ? void 0 : _datePickerField.__typename) === "EGDSSearchFormDatePickerField" && ((_datePickerField_action = datePickerField.action) === null || _datePickerField_action === void 0 ? void 0 : _datePickerField_action.__typename) === "EGDSOpenDatePickerAction" && datePickerField.action.datePicker.__typename === "EGDSDateRangePicker" ? (_datePickerField_action_datePicker_maxNumberOfDaysSelected = datePickerField.action.datePicker.maxNumberOfDaysSelected) !== null && _datePickerField_action_datePicker_maxNumberOfDaysSelected !== void 0 ? _datePickerField_action_datePicker_maxNumberOfDaysSelected : 0 : 0;
    var getUpdatedSecondaries = function(isDateRangePicker, isTravelerSelector, prevSecondaries, text) {
        var hasPrevDates = prevSecondaries.length > 1;
        var base = {
            __typename: "EGDSPlainText",
            accessibility: null,
            text: ""
        };
        if (hasPrevDates) {
            if (isDateRangePicker) {
                var dates = getFormattedDates(text, localizationContext);
                return [
                    _object_spread_props(_object_spread({}, base), {
                        text: dates
                    }),
                    prevSecondaries[1]
                ];
            }
            if (isTravelerSelector) {
                return [
                    prevSecondaries[0],
                    _object_spread_props(_object_spread({}, base), {
                        text: text
                    })
                ];
            }
        }
        if (isDateRangePicker) {
            var dates1 = getFormattedDates(text, localizationContext);
            return [
                _object_spread_props(_object_spread({}, base), {
                    text: dates1
                }),
                prevSecondaries[0]
            ];
        }
        if (isTravelerSelector) {
            return [
                _object_spread_props(_object_spread({}, base), {
                    text: text
                })
            ];
        }
        return _to_consumable_array(prevSecondaries);
    };
    var handleFieldChange = function(field, event) {
        if (onFieldChange) {
            onFieldChange(field, event);
        }
        if (autoSubmitOnFieldChange) {
            var _formRef_current;
            (_formRef_current = formRef.current) === null || _formRef_current === void 0 ? void 0 : _formRef_current.dispatchEvent(new Event("submit", {
                cancelable: true,
                bubbles: true
            }));
        }
        setPlaybackData(function(prevPlaybackState) {
            var DESTINATION = FieldNameMap.DESTINATION, TRAVELER_ROOM_SELECTOR = FieldNameMap.TRAVELER_ROOM_SELECTOR, TRAVELER_BASIC_SELECTOR = FieldNameMap.TRAVELER_BASIC_SELECTOR, TRAVEL_DATES = FieldNameMap.TRAVEL_DATES;
            var name = field.name, text = field.value;
            var isDestination = name === DESTINATION;
            var isDateRangePicker = name === TRAVEL_DATES;
            var isTravelerSelector = name === TRAVELER_ROOM_SELECTOR || name === TRAVELER_BASIC_SELECTOR;
            if (!prevPlaybackState) {
                return null;
            }
            if (!isDateRangePicker && !isTravelerSelector && !isDestination) {
                return _object_spread({}, prevPlaybackState);
            }
            var prevSecondaries = prevPlaybackState.secondaries;
            var secondaries = getUpdatedSecondaries(isDateRangePicker, isTravelerSelector, prevSecondaries, text);
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                secondaries: secondaries
            });
        });
        if (closePlaybackOnFieldUpdateExposure.bucket === 1) {
            setDisplayToggle(true);
        }
        try {
            closePlaybackOnFieldUpdateLogger(closePlaybackOnFieldUpdateExposure);
        } catch (error) {}
    };
    var clearErrorState = function() {
        setErrorState(_object_spread({}, initialErrorState));
    };
    var isSoftPackagesFlightSelected = ((_softPackages = softPackages) === null || _softPackages === void 0 ? void 0 : (_softPackages_flight = _softPackages.flight) === null || _softPackages_flight === void 0 ? void 0 : _softPackages_flight.__typename) === "EGDSBasicPill" && softPackages.flight.selected;
    var isSoftPackagesCarSelected = ((_softPackages1 = softPackages) === null || _softPackages1 === void 0 ? void 0 : (_softPackages_car = _softPackages1.car) === null || _softPackages_car === void 0 ? void 0 : _softPackages_car.__typename) === "EGDSBasicPill" && softPackages.car.selected;
    var validateFormAndReturnResults = React49.useCallback(function(formElements) {
        var formElementsToValidate = {
            location: _object_spread_props(_object_spread({}, isSoftPackagesFlightSelected ? {
                origin: formElements.find(findFieldByNameAttribute("origin_select"))
            } : null), {
                destination: formElements.find(findFieldByNameAttribute("destination_form_field"))
            }),
            dates: {
                startDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-StartDate-date_form_field")),
                endDateInput: formElements.find(findFieldByNameAttribute("EGDSDateRangePicker-EndDate-date_form_field")),
                config: {
                    maxNumberOfDaysSelected: maxNumberOfDaysSelected
                }
            }
        };
        var fieldsWithErrors = getFormElementsWithErrors(formElementsToValidate);
        var errorCount2 = fieldsWithErrors.length;
        var isFormValid = errorCount2 === 0;
        return {
            fieldsWithErrors: fieldsWithErrors,
            errorCount: errorCount2,
            isFormValid: isFormValid
        };
    }, [
        maxNumberOfDaysSelected,
        isSoftPackagesFlightSelected
    ]);
    var handleSubmit = function(event) {
        var _fieldsWithErrors_, _data_errorSummary, _data;
        clearErrorState();
        var formElements = Array.from(event.currentTarget.elements);
        var _validateFormAndReturnResults = validateFormAndReturnResults(formElements), fieldsWithErrors = _validateFormAndReturnResults.fieldsWithErrors, errorCount2 = _validateFormAndReturnResults.errorCount, isFormValid = _validateFormAndReturnResults.isFormValid;
        if (fieldsRefs[(_fieldsWithErrors_ = fieldsWithErrors[0]) === null || _fieldsWithErrors_ === void 0 ? void 0 : _fieldsWithErrors_.__typename] && ((_data = data) === null || _data === void 0 ? void 0 : (_data_errorSummary = _data.errorSummary) === null || _data_errorSummary === void 0 ? void 0 : _data_errorSummary.analytics)) {
            var referrerId = "".concat(data.errorSummary.analytics.referrerId, ".For.NoDestinationSubmit");
            clickTracker(referrerId, data.errorSummary.analytics.linkName);
        }
        if (!isFormValid) {
            var _fieldsWithErrors_1;
            setErrorState({
                fieldsWithErrors: fieldsWithErrors,
                errorCount: errorCount2,
                displayErrorSummary: true,
                errorLinkReference: fieldsRefs[(_fieldsWithErrors_1 = fieldsWithErrors[0]) === null || _fieldsWithErrors_1 === void 0 ? void 0 : _fieldsWithErrors_1.__typename]
            });
            event.preventDefault();
            return;
        }
        if (onSubmit || redirectToSearchResultOnSubmit) {
            var queryParams = getSearchToolsQueryParams("LODGING" /* LODGING */ , formElements);
            var newCriteria = getPropertySearchCriteriaFromQueryParams(new URLSearchParams(queryParams)) || void 0;
            if (onSubmit) {
                onSubmit(event, newCriteria);
            }
            if (redirectToSearchResultOnSubmit) {
                event.preventDefault();
                publishSignal({
                    payload: {},
                    type: "SEARCH_FORM_NEXT_PAGE" /* NEXT_PAGE */ 
                });
                window.location.href = "".concat(event.currentTarget.action).concat(queryParams).concat(additionalQueryParams ? "&".concat(additionalQueryParams) : "");
            }
        }
    };
    var displayErrorSummary = errorState.displayErrorSummary, errorCount = errorState.errorCount, errorLinkReference = errorState.errorLinkReference;
    var showErrorSummary = errorSummary2 && displayErrorSummary;
    var handleProductSelect = function(event) {
        var _event_currentTarget = event.currentTarget, name = _event_currentTarget.name, checked = _event_currentTarget.checked;
        setSoftPackages(function(previous) {
            var _previous_car, _previous, _previous_flight, _previous1;
            if (((_previous = previous) === null || _previous === void 0 ? void 0 : (_previous_car = _previous.car) === null || _previous_car === void 0 ? void 0 : _previous_car.__typename) === "EGDSBasicPill" && previous.car.name !== null && name.includes(previous.car.name)) {
                return _object_spread_props(_object_spread({}, previous), {
                    car: _object_spread_props(_object_spread({}, previous.car), {
                        selected: checked
                    })
                });
            }
            if (((_previous1 = previous) === null || _previous1 === void 0 ? void 0 : (_previous_flight = _previous1.flight) === null || _previous_flight === void 0 ? void 0 : _previous_flight.__typename) === "EGDSBasicPill" && previous.flight.name !== null && name.includes(previous.flight.name)) {
                return _object_spread_props(_object_spread({}, previous), {
                    flight: _object_spread_props(_object_spread({}, previous.flight), {
                        selected: checked
                    })
                });
            }
            return null;
        });
    };
    var handleOnTypeaheadSelection = function(selection) {
        setPlaybackData(function(prevPlaybackState) {
            if (!prevPlaybackState) {
                return null;
            }
            var primary = prevPlaybackState.primary;
            var newPrimary = _object_spread_props(_object_spread({}, primary), {
                text: selection.term
            });
            return _object_spread_props(_object_spread({}, prevPlaybackState), {
                primary: newPrimary
            });
        });
    };
    var _useExperiment1 = useExperiment("Default_Child_Age_with_Messaging_on_Traveler_Selector_Lodging" /* Default_Child_Age_with_Messaging_on_Traveler_Selector_Lodging */ ), defaultChildAgeMessage = _useExperiment1.exposure, logDefaultChildAgeMessage = _useExperiment1.logExperiment;
    var includeDefaultChildAgeMessage = defaultChildAgeMessage.bucket === 1;
    var _useExperiment2 = useExperiment("Save_traveler_selector_info_on_close_mweb" /* Save_traveler_selector_info_on_close_mweb */ ), travelerSelectorDismissSave = _useExperiment2.exposure, logTravelerSelectorDismissSave = _useExperiment2.logExperiment;
    var retainTravelerOnDialogDismiss = travelerSelectorDismissSave.bucket === 1;
    var _useExperiment3 = useExperiment("Date_Selector_Migration_BEX_Web" /* Date_Selector_Migration_BEX_Web */ ), useDateSelectorExposure = _useExperiment3.exposure, logUseDateSelectorExperimentExposure = _useExperiment3.logExperiment;
    var _useExperiment4 = useExperiment("Flex_Date_Search_M1_MVP_plus_or_minus_days_web" /* Flex_Date_Search_M1_MVP_plus_or_minus_days_web */ ), flexDateSearchExposure = _useExperiment4.exposure, logFlexDateSearchExperiment = _useExperiment4.logExperiment;
    var useDateSelector = flexDateSearchExposure.bucket > 0 || useDateSelectorExposure.bucket === 1;
    var includeFlexibleCalendarContent = flexDateSearchExposure.bucket === 2;
    React49.useEffect(function() {
        try {
            logUseDateSelectorExperimentExposure(useDateSelectorExposure);
        } catch (e) {}
    }, [
        logUseDateSelectorExperimentExposure,
        useDateSelectorExposure
    ]);
    React49.useEffect(function() {
        try {
            logFlexDateSearchExperiment(flexDateSearchExposure);
        } catch (e) {}
    }, [
        logFlexDateSearchExperiment,
        flexDateSearchExposure
    ]);
    var childDefaultMessageExperimentLog = React49.useCallback(function() {
        try {
            logDefaultChildAgeMessage(defaultChildAgeMessage);
        } catch (e) {}
    }, [
        logDefaultChildAgeMessage,
        defaultChildAgeMessage
    ]);
    var retainTravelerMobileWebExperimentLog = React49.useCallback(function() {
        try {
            logTravelerSelectorDismissSave(travelerSelectorDismissSave);
        } catch (e) {}
    }, [
        logTravelerSelectorDismissSave,
        travelerSelectorDismissSave
    ]);
    var logTravelerSelectorExperiments = function(viewport) {
        if (viewport === ViewSizes3.SMALL) {
            retainTravelerMobileWebExperimentLog();
        }
        childDefaultMessageExperimentLog();
    };
    var isSoftPackages = isSoftPackagesCarSelected || isSoftPackagesFlightSelected;
    var action = isSoftPackages && softPackages.actionURL ? softPackages.actionURL : actionURL;
    var softPackagesContent = softPackages && /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(SoftPackages, {
        data: softPackages,
        onProductSelect: handleProductSelect,
        setFieldRefByTypename: setFieldRefByTypename,
        fieldError: errorState.fieldsWithErrors.find(function(field) {
            return field.__typename === "EGDSSearchFormLocationFieldOrigin";
        })
    }));
    var getSearchFormColumns = function(viewSize) {
        return viewSize === ViewSizes3.SMALL ? [
            "1fr"
        ] : [
            Repeat2(3, "1fr"),
            "max-content"
        ];
    };
    var getSmallViewRows = function() {
        var rows = [
            Repeat2(3, "max-content")
        ];
        if (softPackages) {
            rows.splice(3, 0, FitContent("1x"));
        }
        return rows;
    };
    var getMediumAndLargeViewRows = function() {
        var rows = [
            "1fr"
        ];
        if (softPackages) {
            rows.push(FitContent("1x"));
        }
        return rows;
    };
    var getSmallViewAreas = function() {
        var areas = [
            "EGDSSearchFormLocationField",
            "EGDSSearchFormDatePickerField",
            "EGDSSearchFormTravelersField",
            "EGDSSearchFormButton"
        ];
        if (softPackages) {
            areas.splice(3, 0, "SoftPackages");
        }
        return areas;
    };
    var getMediumAndLargeViewAreas = function() {
        var areas = [
            "EGDSSearchFormLocationField EGDSSearchFormDatePickerField EGDSSearchFormTravelersField EGDSSearchFormButton"
        ];
        if (softPackages) {
            areas.push("SoftPackages SoftPackages SoftPackages SoftPackages");
        }
        return areas;
    };
    var getSearchForm = function(viewSize) {
        var columns = getSearchFormColumns(viewSize);
        var rows = viewSize === ViewSizes3.SMALL ? getSmallViewRows() : getMediumAndLargeViewRows();
        var areas = viewSize === ViewSizes3.SMALL ? getSmallViewAreas() : getMediumAndLargeViewAreas();
        var isCurrentLocationEnable = function() {
            var _location, _location_action, _location1;
            var location = fields.find(function(element) {
                return element.__typename === "EGDSSearchFormLocationField";
            });
            if (((_location = location) === null || _location === void 0 ? void 0 : _location.__typename) === "EGDSSearchFormLocationField" && ((_location1 = location) === null || _location1 === void 0 ? void 0 : (_location_action = _location1.action) === null || _location_action === void 0 ? void 0 : _location_action.__typename) === "OpenTypeaheadAction") {
                var _location2;
                var _location_action_info_showCurrentLocation;
                return (_location_action_info_showCurrentLocation = (_location2 = location) === null || _location2 === void 0 ? void 0 : _location2.action.info.showCurrentLocation) !== null && _location_action_info_showCurrentLocation !== void 0 ? _location_action_info_showCurrentLocation : false;
            }
            return false;
        };
        var locationQueryParameter = getLocationParameter();
        return /* @__PURE__ */ React49.createElement(UitkLayoutGrid3, {
            columns: columns,
            rows: rows,
            space: "three",
            areas: areas
        }, fields.map(function(element, index) {
            var __typename = element.__typename;
            var FieldComponent = fieldComponents.find(function(param) {
                var displayName = param.displayName;
                return displayName === __typename;
            });
            if (!FieldComponent) {
                return null;
            }
            var fieldError = errorState.fieldsWithErrors.find(function(field) {
                var isSoftPackagesAndOriginFieldHasError = __typename === "SoftPackages" && field.__typename === "EGDSSearchFormLocationFieldOrigin";
                return field.__typename === __typename || isSoftPackagesAndOriginFieldHasError;
            });
            var valueFromQueryParam = isCurrentLocationEnable() && locationQueryParameter ? locationQueryParameter : "";
            var fieldProps = _object_spread(_object_spread_props(_object_spread({}, props), {
                setFieldRefByTypename: setFieldRefByTypename,
                fieldError: fieldError,
                autoOpen: autoOpenCalendar,
                retainTravelerOnDialogDismiss: retainTravelerOnDialogDismiss,
                onProductSelect: handleProductSelect,
                valueFromQueryParam: valueFromQueryParam,
                onSelection: handleOnTypeaheadSelection,
                useDateSelector: useDateSelector,
                flexibleContentConfig: {
                    includeFlexibleCalendarContent: includeFlexibleCalendarContent !== null && includeFlexibleCalendarContent !== void 0 ? includeFlexibleCalendarContent : false,
                    includeFlexibleDatesContent: false
                },
                includeDefaultChildAgeMessage: includeDefaultChildAgeMessage,
                onOpenTravelerField: logTravelerSelectorExperiments
            }), isSoftPackages ? softPackages : {});
            var content = __typename === "SoftPackages" ? softPackagesContent : /* @__PURE__ */ React49.createElement(FieldComponent, _object_spread_props(_object_spread({}, fieldProps), {
                data: element
            }));
            return /* @__PURE__ */ React49.createElement(UitkLayoutGridItem3, {
                area: __typename,
                key: "field_".concat(__typename, "_").concat(index)
            }, /* @__PURE__ */ React49.createElement(UitkLayoutGrid3, {
                autoRows: [
                    "max-content"
                ]
            }, content));
        }));
    };
    return /* @__PURE__ */ React49.createElement(UitkForm3, {
        ref: formRef,
        id: id,
        name: id,
        method: "GET",
        action: action,
        onFieldChange: handleFieldChange,
        onSubmit: handleSubmit,
        hasRequiredFieldIndicator: true
    }, showErrorSummary && /* @__PURE__ */ React49.createElement(EGDSErrorSummary, {
        data: errorSummary2,
        errorCount: errorCount,
        inputErrorRef: errorLinkReference,
        linkClickFocusId: (_errorLinkReference = errorLinkReference) === null || _errorLinkReference === void 0 ? void 0 : (_errorLinkReference_current = _errorLinkReference.current) === null || _errorLinkReference_current === void 0 ? void 0 : _errorLinkReference_current.id
    }), /* @__PURE__ */ React49.createElement(UitkSpacing15, {
        margin: {
            blockstart: showErrorSummary ? "two" : void 0
        }
    }, /* @__PURE__ */ React49.createElement("div", null, /* @__PURE__ */ React49.createElement(Viewport6, null, /* @__PURE__ */ React49.createElement(ViewSmall4, null, playbackData ? /* @__PURE__ */ React49.createElement(EGDSSearchPlayback, {
        data: playbackData,
        stickyPlayback: stickyPlayback,
        display: displayToggle,
        onDisplayToggle: handlePlaybackToggle
    }, getSearchForm(ViewSizes3.SMALL)) : getSearchForm(ViewSizes3.SMALL)), /* @__PURE__ */ React49.createElement(ViewMedium6, null, getSearchForm(verticalLayout ? ViewSizes3.SMALL : ViewSizes3.MEDIUM)), /* @__PURE__ */ React49.createElement(ViewLarge3, null, sticky ? /* @__PURE__ */ React49.createElement(StickySearchForm, {
        paddedViewRow: paddedViewRow
    }, getSearchForm(verticalLayout ? ViewSizes3.SMALL : ViewSizes3.LARGE)) : getSearchForm(verticalLayout ? ViewSizes3.SMALL : ViewSizes3.LARGE))))));
};
LodgingSearchForm.fragment = _fragment2;
LodgingSearchForm.displayName = "LodgingSearchForm";
// src/components/form/client-events.ts
import { SystemEvent, SystemEventLevel } from "@shared-ui/logger-context";
var CLIENT_EVENTS = {
    /**
   * Pattern: `SEARCH_TOOLS_{LOB}_{COMPONENT}_{EVENT}`
   */ SEARCH_TOOLS_LODGING_SEARCH_FORM_QUERY_FAILURE: new SystemEvent(SystemEventLevel.ERROR, "SEARCH_TOOLS_LODGING_SEARCH_FORM_QUERY_FAILURE")
};
// src/components/form/search-form.tsx
var __Query = gql42(_templateObject45(), LodgingSearchForm.fragment);
var LodgingSearchFormFeatures = /* @__PURE__ */ function(LodgingSearchFormFeatures2) {
    LodgingSearchFormFeatures2["PREFILL_PROPERTY_NAME"] = "PREFILL_PROPERTY_NAME";
    return LodgingSearchFormFeatures2;
}(LodgingSearchFormFeatures || {});
var SearchForm = function(props) {
    var _inputs_propertySearchCriteriaInput, _inputs_propertySearchCriteriaInput_primary_destination, _inputs_propertySearchCriteriaInput_primary, _inputs_propertySearchCriteriaInput1, _secondary_selections_find, _secondary_selections, _secondary, _secondary_selections_find1, _secondary_selections1, _secondary1, _secondary_selections_find2, _secondary_selections2, _secondary2, _secondary_selections_find3, _secondary_selections3, _secondary3, _features;
    var inputs = props.inputs, skipSsr = props.skipSsr, _props_skipQuery = props.skipQuery, skipQuery = _props_skipQuery === void 0 ? false : _props_skipQuery, fetchPolicy = props.fetchPolicy, batchKey = props.batchKey, features = props.features, includePlayback = props.includePlayback;
    var context = useBexApi4().context;
    var systemEvents = useLoggerEvents(CLIENT_EVENTS);
    var _React50_useState = _sliced_to_array(React50.useState(skipQuery), 2), skip = _React50_useState[0], setSkip = _React50_useState[1];
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context,
        includePlayback: !!includePlayback,
        features: features
    });
    var _useQuery = useQuery(__Query, _object_spread({
        context: {
            batchKey: batchKey
        },
        variables: variables,
        ssr: !skipSsr,
        skip: skip
    }, fetchPolicy ? {
        fetchPolicy: fetchPolicy
    } : {})), currentData = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading, previousData = _useQuery.previousData;
    var data = currentData !== null && currentData !== void 0 ? currentData : previousData;
    React50.useEffect(function() {
        setSkip(skipQuery && !loading);
    }, [
        loading,
        skipQuery
    ]);
    if (loading && !data) {
        return /* @__PURE__ */ React50.createElement(Viewport7, null, /* @__PURE__ */ React50.createElement(ViewSmall5, null, /* @__PURE__ */ React50.createElement(FormSkeleton, {
            rows: [
                {
                    type: "primary"
                },
                {
                    type: "primary"
                },
                {
                    type: "primary"
                }
            ]
        })), /* @__PURE__ */ React50.createElement(ViewMedium7, null, /* @__PURE__ */ React50.createElement(FormSkeleton, {
            rows: [
                {
                    type: "primary"
                }
            ]
        })));
    }
    var secondary = (_inputs_propertySearchCriteriaInput = inputs.propertySearchCriteriaInput) === null || _inputs_propertySearchCriteriaInput === void 0 ? void 0 : _inputs_propertySearchCriteriaInput.secondary;
    var _inputs_propertySearchCriteriaInput_primary_destination_pinnedPropertyId;
    var pinnedPropertyId = (_inputs_propertySearchCriteriaInput_primary_destination_pinnedPropertyId = (_inputs_propertySearchCriteriaInput1 = inputs.propertySearchCriteriaInput) === null || _inputs_propertySearchCriteriaInput1 === void 0 ? void 0 : (_inputs_propertySearchCriteriaInput_primary = _inputs_propertySearchCriteriaInput1.primary) === null || _inputs_propertySearchCriteriaInput_primary === void 0 ? void 0 : (_inputs_propertySearchCriteriaInput_primary_destination = _inputs_propertySearchCriteriaInput_primary.destination) === null || _inputs_propertySearchCriteriaInput_primary_destination === void 0 ? void 0 : _inputs_propertySearchCriteriaInput_primary_destination.pinnedPropertyId) !== null && _inputs_propertySearchCriteriaInput_primary_destination_pinnedPropertyId !== void 0 ? _inputs_propertySearchCriteriaInput_primary_destination_pinnedPropertyId : void 0;
    var propertyRefinements = secondary ? {
        amenitiesFacilitiesGroup: (_secondary = secondary) === null || _secondary === void 0 ? void 0 : (_secondary_selections = _secondary.selections) === null || _secondary_selections === void 0 ? void 0 : (_secondary_selections_find = _secondary_selections.find(function(i) {
            return i.id === "amenities_facilities_group";
        })) === null || _secondary_selections_find === void 0 ? void 0 : _secondary_selections_find.value,
        locationGroup: (_secondary1 = secondary) === null || _secondary1 === void 0 ? void 0 : (_secondary_selections1 = _secondary1.selections) === null || _secondary_selections1 === void 0 ? void 0 : (_secondary_selections_find1 = _secondary_selections1.find(function(i) {
            return i.id === "location_group";
        })) === null || _secondary_selections_find1 === void 0 ? void 0 : _secondary_selections_find1.value,
        propertiesGoodForGroup: (_secondary2 = secondary) === null || _secondary2 === void 0 ? void 0 : (_secondary_selections2 = _secondary2.selections) === null || _secondary_selections2 === void 0 ? void 0 : (_secondary_selections_find2 = _secondary_selections2.find(function(i) {
            return i.id === "properties_good_for_group";
        })) === null || _secondary_selections_find2 === void 0 ? void 0 : _secondary_selections_find2.value,
        propertyTypeGroup: (_secondary3 = secondary) === null || _secondary3 === void 0 ? void 0 : (_secondary_selections3 = _secondary3.selections) === null || _secondary_selections3 === void 0 ? void 0 : (_secondary_selections_find3 = _secondary_selections3.find(function(i) {
            return i.id === "property_type_group";
        })) === null || _secondary_selections_find3 === void 0 ? void 0 : _secondary_selections_find3.value
    } : void 0;
    var lodgingSearchFormProps = _object_spread_props(_object_spread({}, props), {
        propertyRefinements: propertyRefinements,
        pinnedPropertyId: ((_features = features) === null || _features === void 0 ? void 0 : _features.includes("PREFILL_PROPERTY_NAME" /* PREFILL_PROPERTY_NAME */ )) ? pinnedPropertyId : void 0,
        skipQuery: skip
    });
    if (error || !data || data.searchForm.lodging.__typename !== "LodgingSearchForm") {
        var _error, _error1;
        var fallback = getFallbackFormData();
        systemEvents.SEARCH_TOOLS_LODGING_SEARCH_FORM_QUERY_FAILURE.log({
            name: (_error = error) === null || _error === void 0 ? void 0 : _error.name,
            error: new Error((_error1 = error) === null || _error1 === void 0 ? void 0 : _error1.message)
        });
        return /* @__PURE__ */ React50.createElement(LodgingSearchForm, _object_spread_props(_object_spread({}, lodgingSearchFormProps), {
            data: fallback
        }));
    }
    return /* @__PURE__ */ React50.createElement(LodgingSearchForm, _object_spread_props(_object_spread({}, lodgingSearchFormProps), {
        data: data.searchForm.lodging,
        skipQuery: skip
    }));
};
SearchForm.displayName = "sharedui-LodgingSearchForm";
// src/providers/lodging-query-params-provider.tsx
import React51 from "react";
var LodgingQueryParamsContext = React51.createContext(null);
var LodgingQueryParamsProvider = function(param) {
    var children = param.children, urlSearchParams = param.urlSearchParams;
    var inputs = getPropertySearchCriteriaFromQueryParams(urlSearchParams);
    return /* @__PURE__ */ React51.createElement(LodgingQueryParamsContext.Provider, {
        value: inputs
    }, children);
};
var useLodgingURLParamsToQueryInputs = function() {
    return React51.useContext(LodgingQueryParamsContext);
};
export { LodgingQueryParamsProvider, LodgingSearchFormFeatures, ParamsKeys, SearchForm, getPropertySearchCriteriaFromQueryParams, useLodgingURLParamsToQueryInputs }; /* istanbul ignore file -- @preserve */  /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map